import { React, useState, useEffect, useRef, forwardRef, useImperativeHandle } from "react";
import { useLocation, useNavigate, useSearchParams } from "react-router-dom";
import { Filter, Search, Breadcrumb, Modal, Button, Icon, Badge, DatePickerInput, DateRangePicker, TextInput, Pagination, TabsNavigation, Tab, Tag, DataTable, ButtonMenu, Popover, Slot, Dropdown } from "pepsico-ds";
import AuditRequestDetail from "./audit-request-detail";
import blueTick from "../../../src/assets/audit-request/blue-tick.svg";
import greenTick from "../../../src/assets/audit-request/green_tick.png";
import halfBlue from "../../../src/assets/audit-request/half-blue.svg";
import requestAuditService from "../../services/requestAuditService";
import { toast, ToastContainer } from "react-toastify";
import { useTranslation } from "react-i18next";
import "./pending-audit-request.css";
import NoDataFound from "../../common/no_data_found";
import NetworkError from "../../common/network_error";
import ServiceUnavailable from "../../common/service_unavailable";
import { useLoading } from "../../loader";
import { Tooltip } from "react-tooltip";

const PendingAuditRequests = () => {
    const location = useLocation();
    const [searchParams] = useSearchParams();
    const deepLinkRequestNumber = searchParams.get('requestNumber');
    const state = location.state || null;
    const navigate = useNavigate();
    const { showLoader, hideLoader } = useLoading();
    const [showDetail, setShowDetail] = useState(false);
    const [requestNumber, setRequestNumber] = useState(null);
    const [requestType, setRequestType] = useState(null);
    const [sendReminderPayload, setSendReminderPayload] = useState({});
    const [bundledRequestSelectedAppId, setBundledRequestSelectedAppId] = useState(null);
    const [bundledRequests, setBundledRequests] = useState([]);
    const [isOpenAppName, setIsOpenAppName] = useState(false);
    const scrollRef = useRef(null);
    const [bundledRequestSelectFrom, setBundledRequestSelectFrom] = useState("");
    const [auditData, setAuditData] = useState(null);
    const [isMobile, setIsMobile] = useState(window.innerWidth < 768);
    const [isTab, setIsTab] = useState(window.innerWidth > 768 && window.innerWidth <= 1024);
    const [isLandscape, setIsLandscape] = useState(window.innerWidth < 768 && window.innerWidth > window.innerHeight);
    const [auditRequestList, setAuditRequestList] = useState([]);
    const lastScrollTopRef = useRef(0);
    const isFetchingRef = useRef(false);
    const hasMoreRef = useRef(true);
    const containerRef = useRef(null);
    const innerContainerRef = useRef(null);
    const [loadingIndexes, setLoadingIndexes] = useState({});
    const [isLoading, setLoading] = useState(false);
    const loadingRef = useRef();
    const [error, setError] = useState(null);
    const [showNoDataFound, setShowNoDataFound] = useState(false);
    const [showViewRequestNoDataFound, setViewRequestNoShowNoDataFound] = useState(false);
    const [showNetworkError, setShowNetworkError] = useState(false);
    const [showServiceUnavailable, setShowServiceUnavailable] = useState(false);
    // const [refreshVal, setRefreshVal] = useState("");
    const [searchNum, setSearchNum] = useState("");
    const [searchType, setSearchType] = useState("");
    const [searchValue, setSearchValue] = useState("");
    const [isShowModel, setIsShowModel] = useState(false);
    const [isShowReminderModel, setIsShowReminderModel] = useState(false);
    const [isShowCancelModel, setIsShowCancelModel] = useState(false);
    const [isCancelConfirmModel, setIsCancelConfirmModel] = useState(false);
    const [open, setOpen] = useState(false);
    const [copyButtonText, setCopyButtonText] = useState("Copy");
    const [expandedIndexes, setExpandedIndexes] = useState({});
    const [appIndexes, setAppIndexes] = useState({});
    const [userGpId, setUserGpId] = useState(null);
    // const [selectedFilter, setSelectedFilter] = useState(null);
    // const selectedFilterRef = useRef(null);
    const [errorIndexes, setErrorIndexes] = useState({});
    const [showStepsIndex, setShowStepIndex] = useState({});
    const [isBtnLoading, setBtnLoading] = useState(false);
    const [selectedRange, setSelectedRange] = useState({
        from: null,
        to: null,
    });
    const [approvalData, setApprovalData] = useState();
    const { t, i18n } = useTranslation();
    const isRtl = i18n.language?.split("_")?.[0] === "ar";
    const [appName, setAppName] = useState("");
    const [requestDetail, setRequestDetail] = useState([]);
    const [requestId, setRequestId] = useState("");
    const isValidDate = (val) => val && val !== "null" && val !== "undefined" && val.trim() !== "";
    const [showAll, setShowAll] = useState(false);
    const [pageIndex, setPageIndex] = useState(1);
    const [totalRecords, setTotalRecords] = useState(0);
    const skipPageIndexEffect = useRef(false);
    const deepLinkHandledRef = useRef(null);
    const [shoudlShowDateAndStatusFilters, setShoudlShowDateAndStatusFilters] = useState(false);
    const [isRequestSelected, setisRequestSelected] = useState(false);
    const [auditRequestData, setAuditRequestData] = useState(null);
    const [selectedTabIndex, setSelectedTabIndex] = useState(0);
    const [approverQueue, setApproverQueue] = useState([]);
    const [approverQueueList, setApproverQueueList] = useState([]);
    const [routingList, setRoutingList] = useState([]);
    const [isFollowUpAvailable ,setIsFollowUpAvailable] = useState(true);
    const [toggleFilter, setToggleFilter] = useState(false);
    const [selectedStatusFilter, setSelectedStatusFilter] = useState([{ id: '5', displayText: t("auditRequest.audit_all"), value: 'all' }]);
    const [selectedStatusFilterAfterApply, setSelectedStatusFilterAfterApply] = useState([{ id: '5', displayText: t("auditRequest.audit_all"), value: 'all' }]);
    const [selectedRangeAfterApply, setSelectedRangeAfterApply] = useState({
        from: null,
        to: null,
    });
    const [disableFilter, setDisableFilter] = useState(false)
    const [fetchByDate, setFetchByDate] = useState(true);
    const requestListRef = useRef(null);
    const queueNameRef = useRef(null);
    const [truncatedTooltip, setTruncatedTooltip] = useState({});
    const [requestDataLoaded, setRequestDataLoaded] = useState(false);
    // SSO collapsible section states
    const [isSSOBusinessInfoExpanded, setIsSSOBusinessInfoExpanded] = useState(true);
    const [isSSOAppDetailsExpanded, setIsSSOAppDetailsExpanded] = useState(true);
    const [isSSOTechnicalConfigExpanded, setIsSSOTechnicalConfigExpanded] = useState(true);
    const [isSSOAccessControlExpanded, setIsSSOAccessControlExpanded] = useState(true);
    const [isSSOAuthorizationRolesExpanded, setIsSSOAuthorizationRolesExpanded] = useState(true);
    const [isSSOElevatedPermissionsExpanded, setIsSSOElevatedPermissionsExpanded] = useState(true);
    const [isSSOAppLogoExpanded, setIsSSOAppLogoExpanded] = useState(true);
    const [isSSOCertificationDetailsExpanded, setIsSSOCertificationDetailsExpanded] = useState(true);
    // SSO attachment states
    const [ssoLogoUrl, setSsoLogoUrl] = useState(null);
    const [ssoCertificateUrl, setSsoCertificateUrl] = useState(null);
    const [ssoCertificateName, setSsoCertificateName] = useState(null);
    const [isSSOLogoPreviewOpen, setIsSSOLogoPreviewOpen] = useState(false);
    const [ssoLogoPreviewSrc, setSsoLogoPreviewSrc] = useState(null);
    const [showRequestSearch, setShowRequestSearch] = useState(true);

    const openSSOLogoPreview = (logoSrc) => {
        if (!logoSrc) return;
        setSsoLogoPreviewSrc(logoSrc);
        setIsSSOLogoPreviewOpen(true);
    };

    const closeSSOLogoPreview = () => {
        setIsSSOLogoPreviewOpen(false);
        setSsoLogoPreviewSrc(null);
    };

    function normalizeToTitle(str) {
        if (!str) return "";
        let result = str.replace(/[_-]/g, " ");
        result = result.replace(/([a-z])([A-Z])/g, "$1 $2");
        result = result.replace(/\s+/g, " ").trim();
        result = result.toLowerCase();
        result = result.replace(/\b\w/g, char => char.toUpperCase());

        return result;
    }

    function camelToTitle(str) {
        return str
            .replace(/([a-z])([A-Z])/g, "$1 $2")
            .replace(/([A-Z]+)([A-Z][a-z])/g, "$1 $2")
            .replace(/\b\w/g, char => char.toUpperCase());
    }

    function formatMyPAMRequestType(str) {
        if (!str) return "";
        str = str.slice("MYPAM_".length);
        return str
        .split("_")
        .map(word => word ? (word.charAt(0)?.toUpperCase?.() || '') + (word.slice(1)?.toLowerCase?.() || '') : '')
        .join(" ");
    }

    function formatRequestTypeLabel(str) {
        if (!str) return "";

        const value = String(str).trim();
        if (!value) return "";

        const normalizedValue = value.toLowerCase().replace(/[_-]+/g, " ").replace(/\s+/g, " ").trim();
        if (normalizedValue === "sso onboarding") {
            return "New";
        }

        if (normalizedValue === "sso modification") {
            return "Modification";
        }

        if (value.startsWith("MYPAM_")) {
            return formatMyPAMRequestType(value);
        }

        if (normalizedValue.startsWith("guest")) {
            return "New";
        }

        return value
            .replace(/[_-]+/g, " ")
            .split(/\s+/)
            .map((word) => {
                if (!word) return "";
                if (word === word.toUpperCase()) return word;
                return `${word.charAt(0).toUpperCase()}${word.slice(1).toLowerCase()}`;
            })
            .join(" ");
    }

    const normalizeRequestNumber = (value) => `${value ?? ''}`.replace(/[^a-zA-Z0-9]/g, '').toLowerCase();

    const normalizeStatusValue = (status) => String(status ?? '')
        .replace(/[_-]/g, ' ')
        .replace(/\s+/g, ' ')
        .trim()
        .toLowerCase()
        .replace(/^inprogress$/, 'in progress');

    const isInProgressStatus = (status) => normalizeStatusValue(status) === 'in progress';

    const isFailedStatus = (status) => normalizeStatusValue(status) === 'failed';
    const isCompletedStatus = (status) => {
        const normalized = normalizeStatusValue(status);
        return normalized === 'complete' || normalized === 'completed';
    };

    const getGroupedRequestStatus = (items = []) => {
        const statusCandidates = [];

        items.forEach((item) => {
            if (item?.overAllStatus) statusCandidates.push(item.overAllStatus);
            if (item?.status) statusCandidates.push(item.status);
        });

        if (!statusCandidates.length) return '';

        const inProgress = statusCandidates.find((status) => isInProgressStatus(status));
        if (inProgress) return inProgress;

        return statusCandidates[0];
    };

    function formatApplicationLabel(str) {
        if (!str) return "";

        const value = String(str).trim();
        if (!value) return "";

        if (value.toLowerCase().includes("mypam")) {
            return "MyPAM";
        }

        if (value.toLowerCase().includes("guest")) {
            return "M365 Guest Invitation";
        }

        return value
            .replace(/[_-]+/g, " ")
            .split(/\s+/)
            .map((word) => {
                if (!word) return "";
                if (word === word.toUpperCase()) return word;
                return `${word.charAt(0).toUpperCase()}${word.slice(1).toLowerCase()}`;
            })
            .join(" ");
    }

    function getRequestBadgeKey(str) {
        if (!str) return "Reactive";

        const value = String(str).trim();
        const normalizedValue = value.toLowerCase().replace(/[_-]+/g, " ").replace(/\s+/g, " ").trim();

        if (normalizedValue === "sso onboarding" || normalizedValue.startsWith("guest")) {
            return "new";
        }

        if (normalizedValue === "sso modification") {
            return "modify";
        }

        return value;
    }

    const formatLabel = (key) => {
        if (!key) return "";

        return key
        .replace(/([A-Z])/g, " $1")     // insert space before capital letters
        .replace(/_/g, " ")             // replace underscores with spaces (if any)
        .trim()                         // remove leading/trailing spaces
        .replace(/\b\w/g, (char) => char.toUpperCase());  // capitalize first letter of each word
    };

    function convertIndexedObject(obj) {
        const normalized = {};
        for (const key in obj) {
            const newKey = key.replace(/\s+\[/, "[");
            normalized[newKey] = obj[key];
        }

        const indices = [...new Set(Object.keys(normalized).map(key => {
            const match = key.match(/\[(\d+)\]/);
            return match ? match[1] : null;
        }).filter(Boolean))];

        if (indices.length === 0) {
            return [normalized];
        }

        return indices.map(index => {
            const entry = {};
            for (const key in normalized) {
                const match = key.match(/^(.+)\[(\d+)\]$/);
                if (match && match[2] === index) {
                    entry[match[1].trim()] = normalized[key];
                }
            }
            return entry;
        });
    }

    const mapApproverDetails = (approverDetailsMap, notApplicableLabel) => {
        const invalidValues = ["", "null", null, undefined, "undefined"];

        return Array.isArray(approverDetailsMap)
            ? approverDetailsMap
                .filter((item) => Boolean(
                    `${item?.fullName ?? ""}`.trim() ||
                    `${item?.email ?? ""}`.trim() ||
                    `${item?.phoneNumber ?? ""}`.trim() ||
                    `${item?.ext ?? ""}`.trim() ||
                    `${item?.currentApproverGPID ?? ""}`.trim()
                ))
                .map((item) => ({
                    approver: invalidValues.includes(item?.fullName)
                        ? notApplicableLabel
                        : item.fullName,
                    email: invalidValues.includes(item?.email)
                        ? notApplicableLabel
                        : item.email,
                    phoneNumber: invalidValues.includes(item?.phoneNumber)
                        ? notApplicableLabel
                        : item.phoneNumber,
                    ext: invalidValues.includes(item?.ext)
                        ? notApplicableLabel
                        : item.ext,
                    gpid: invalidValues.includes(item?.currentApproverGPID)
                        ? notApplicableLabel
                        : item.currentApproverGPID,
                }))
            : [];
    };

    const buildSsoDisplayData = (approvalData = {}, requestedAppName = '') => {
        const appName = requestedAppName
            || approvalData?.distinctAppsList?.[0]
            || Object.keys(approvalData?.tempAttributeMap || {})?.[0]
            || Object.keys(approvalData?.finalAttributeMap || {})?.[0]
            || '';
        const appScopedTemp = appName ? approvalData?.tempAttributeMap?.[appName] : undefined;
        const appScopedFinal = appName ? approvalData?.finalAttributeMap?.[appName] : undefined;
        const provisioningRequest = approvalData?.ssoProvisioningData?.request || {};

        const featureDetails = approvalData?.featureAttributeMap?.featureDetails ||
            appScopedFinal ||
            appScopedTemp ||
            approvalData?.finalAttributeMap?.['SSO Onboarding'] ||
            approvalData?.tempAttributeMap?.['SSO Onboarding'] ||
            {};

        const rawRequest = approvalData?.featureAttributeMap?.featureDetails?.request ||
            approvalData?.featureAttributeMap?.request ||
            appScopedFinal?.request ||
            appScopedTemp?.request ||
            approvalData?.finalAttributeMap?.['SSO Onboarding']?.request ||
            approvalData?.finalAttributeMap?.request ||
            approvalData?.tempAttributeMap?.['SSO Onboarding']?.request ||
            approvalData?.tempAttributeMap?.request ||
            provisioningRequest ||
            approvalData?.request ||
            {};

        const displayFields = approvalData?.featureAttributeMap?.displayFields ||
            approvalData?.finalAttributeMap?.displayFields ||
            approvalData?.tempAttributeMap?.displayFields ||
            {};

        const attachments = approvalData?.featureAttributeMap?.attachments ||
            approvalData?.finalAttributeMap?.attachments ||
            {};

        return {
            ...approvalData,
            ...featureDetails,
            ...rawRequest,
            ...displayFields,
            ...attachments,
            sector: approvalData?.sector || rawRequest?.sector || featureDetails?.sector || '',
            applicationService: approvalData?.applicationService || rawRequest?.applicationService || featureDetails?.applicationService || '',
            dataClassification: approvalData?.dataClassification || rawRequest?.dataClassification || featureDetails?.dataClassification || '',
        };
    };

    // Fetch SSO attachments (logo and certificate)
    const fetchSSOAttachments = async (requestNumber, ssoData) => {
        // Reset previous values
        setSsoLogoUrl(null);
        setSsoCertificateUrl(null);
        setSsoCertificateName(null);

        // Fetch logo if hasLogo is true
        const hasLogo = ssoData?.['hasLogo'] === 'true' || ssoData?.['hasLogo'] === true || ssoData?.hasLogo === 'true' || ssoData?.hasLogo === true || ssoData?.['Has Logo'] === 'Yes';
        if (hasLogo) {
            try {
                const response = await requestAuditService.getSSOAttachment(requestNumber, 'LOGO');
                if (response?.data) {
                    const blob = new Blob([response.data], { type: response.headers['content-type'] || 'image/png' });
                    const url = URL.createObjectURL(blob);
                    setSsoLogoUrl(url);
                }
            } catch (error) {
                console.error('Error fetching SSO logo:', error);
            }
        }

        // Fetch certificate if hasCertificate or hasSigningCertificate is true
        const hasCertificate = ssoData?.['hasCertificate'] === 'true' || ssoData?.['hasCertificate'] === true || ssoData?.hasCertificate === 'true' || ssoData?.hasCertificate === true || ssoData?.hasSigningCertificate === true || ssoData?.hasSigningCertificate === 'true' || ssoData?.['Has Certificate'] === 'Yes';
        if (hasCertificate) {
            try {
                const response = await requestAuditService.getSSOAttachment(requestNumber, 'CERTIFICATE');
                if (response?.data) {
                    const blob = new Blob([response.data], { type: response.headers['content-type'] || 'application/x-x509-ca-cert' });
                    const url = URL.createObjectURL(blob);
                    setSsoCertificateUrl(url);
                    // Extract filename from content-disposition header if available
                    const contentDisposition = response.headers['content-disposition'];
                    if (contentDisposition) {
                        const filenameMatch = contentDisposition.match(/filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/);
                        if (filenameMatch && filenameMatch[1]) {
                            setSsoCertificateName(filenameMatch[1].replace(/['"]/g, ''));
                        }
                    }
                }
            } catch (error) {
                console.error('Error fetching SSO certificate:', error);
            }
        }
    };

    useEffect(()=>{
        if (requestListRef.current) {
            const elements = requestListRef.current.querySelectorAll(".details-content-group small");
            const truncatedTooltipObj = {};

            elements.forEach((el, idx) => {
                const isTruncated =
                el.scrollWidth > el.clientWidth || el.scrollHeight > el.clientHeight;

                truncatedTooltipObj[idx] = isTruncated;

                // if (!isTruncated) {
                //     el.removeAttribute("data-tooltip-id");
                //     el.removeAttribute("data-tooltip-content");
                // }
            });
            setTruncatedTooltip(truncatedTooltipObj);
        }
        
    },[auditRequestList])

    useEffect(()=>{
        if(requestDataLoaded){
            if (queueNameRef.current) {
                const elements = queueNameRef.current.querySelectorAll(".queue-name");
    
                elements.forEach((el, idx) => {
                    const isTruncated =
                    el.scrollWidth > el.clientWidth || el.scrollHeight > el.clientHeight;
    
                    if (!isTruncated) {
                        el.removeAttribute("data-tooltip-id");
                        el.removeAttribute("data-tooltip-content");
                    }
                });
            }

            const requestForEle = document.querySelector(".requested-for");
            const requestByEle = document.querySelector(".requested-by");

            const requestForTruncated = requestForEle?.scrollWidth > requestForEle?.clientWidth || requestForEle?.scrollHeight > requestForEle?.clientHeight;
            const requestByTruncated = requestByEle?.scrollWidth > requestByEle?.clientWidth || requestByEle?.scrollHeight > requestByEle?.clientHeight;
            if (!requestForTruncated) {
                requestForEle?.removeAttribute?.("data-tooltip-id");
                requestForEle?.removeAttribute?.("data-tooltip-content");
            }

            if (!requestByTruncated) {
                requestByEle?.removeAttribute?.("data-tooltip-id");
                requestByEle?.removeAttribute?.("data-tooltip-content");
            }

            setRequestDataLoaded(false);
        }

    },[requestDataLoaded])

    // Fetch SSO attachments when audit request data changes and it's an SSO request
    useEffect(() => {
        const isSSORequest = (auditRequestData?.requestType && auditRequestData?.requestType?.toLowerCase?.()?.includes?.('sso')) || 
                             (auditRequestData?.auditApprovalData?.requestType && auditRequestData?.auditApprovalData?.requestType?.toLowerCase?.()?.includes?.('sso')) || 
                             (auditRequestData?.applicationsRequested && auditRequestData?.applicationsRequested?.toLowerCase?.()?.includes?.('sso'));
        
        if (isSSORequest && auditRequestData?.auditApprovalData) {
            const approvalData = auditRequestData?.auditApprovalData;
            const ssoData = buildSsoDisplayData(approvalData, auditRequestData?.applicationsRequested);
            const requestNumber = approvalData?.requestNumber;
            
            const hasLogoFlag = ssoData?.['hasLogo'] === 'true' || ssoData?.['hasLogo'] === true || ssoData?.hasLogo === 'true' || ssoData?.hasLogo === true || ssoData?.['Has Logo'] === 'Yes';
            const hasCertFlag = ssoData?.['hasCertificate'] === 'true' || ssoData?.['hasCertificate'] === true || ssoData?.hasCertificate === 'true' || ssoData?.hasCertificate === true || ssoData?.hasSigningCertificate === true || ssoData?.hasSigningCertificate === 'true' || ssoData?.['Has Certificate'] === 'Yes';
            if (requestNumber && (hasLogoFlag || hasCertFlag)) {
                fetchSSOAttachments(requestNumber, ssoData);
            }
        }
    }, [auditRequestData]);

    const auditFilterOptions = [
        { id: '5', displayText: t("auditRequest.audit_all"), value: 'all' },
        { id: '6', displayText: t("auditRequest.audit_submitted"), value: 'submitted' },
        { id: '2', displayText: t("auditRequest.audit_in_progress"), value: 'in progress' },
        { id: '3', displayText: t("auditRequest.audit_completed"), value: 'completed' },
        { id: '4', displayText: t("auditRequest.audit_failed"), value: 'failed' },
        { id: '1', displayText: t("auditRequest.audit_approved"), value: 'approved' },
    ];


    // useEffect(() => {
    //     // Create a MutationObserver to watch for attribute changes
    //     const observer = new MutationObserver((mutations) => {
    //     mutations.forEach((mutation) => {
    //         if (mutation.type === "attributes" && mutation.attributeName === "data-lang") {
    //             const auditFilterOptions = [
    //                 { id: '5', label: t("auditRequest.audit_all"), value: 'all' },
    //                 { id: '6', label: t("auditRequest.audit_submitted"), value: 'submitted' },
    //                 { id: '2', label: t("auditRequest.audit_in_progress"), value: 'in progress' },
    //                 { id: '3', label: t("auditRequest.audit_completed"), value: 'completed' },
    //                 { id: '4', label: t("auditRequest.audit_failed"), value: 'failed' },
    //                 { id: '1', label: t("auditRequest.audit_approved"), value: 'approved' },
    //             ];
    //             const prevSelectedFilter = {...selectedFilterRef.current};
    //             setSelectedFilter(auditFilterOptions?.find?.((o)=>o.id === prevSelectedFilter.id));
    //         }
    //     });
    //     });

    //     // Start observing the body element
    //     observer.observe(document.body, {
    //     attributes: true,
    //     attributeFilter: ["data-lang"],
    //     });

    //     // Cleanup observer on unmount
    //     return () => {
    //     observer.disconnect();
    //     };
    // }, []);
    const entraColumns = [
        {
            columnKey: 'queue',
            header: t("auditRequest.approver_queue_upper_label"),
            initialSize: 240
        },
        {
            columnKey: 'arrivedOn',
            header: t("auditRequest.arrived_in_queue_label"),
            initialSize: 160
        },
        {
            columnKey: 'status',
            header: t("auditRequest.status_label"),
            initialSize: 100
        },
        {
            columnKey: 'approverGpid',
            header: t("auditRequest.approver_label"),
            initialSize: 120
        }       
    ];

    const entraReqDetailsColumn = [
        {
            columnKey: 'guestName',
            header: t("entraGuest.guest_name"),
            initialSize: 160
        },
        {
            columnKey: 'guestEmail',
            header: t("entraGuest.guest_email"),
            initialSize: 160
        },
        {
            columnKey: 'status',
            header: t("entraGuest.table_status"),
            initialSize: 160, 
            cellData: (ctx) => {
                return <div>
                    {ctx.row.original?.status?.split?.("_")?.reduce?.((acc,rec)=> `${acc} ${rec?.[0]?.toUpperCase?.() || ''}${rec?.slice?.(1)?.toLowerCase?.() || ''}`,"")}
                </div>
            }
        },
        {
            columnKey: 'errorMessage',
            header: t("entraGuest.table_error_message"),
            initialSize: 160
        }
    ];

    const entraCancelRequest = async() => {
        setBtnLoading(true);
        setError(null);
        try {
            let requestData = { "requestNumber": requestNumber }
            const response = await requestAuditService.entraCancelRequest(requestData);
            if (response && response.status == "Failed") {
                toast.error(response.errorMessage ? response.errorMessage : t("auditRequest.cancel_failed_msg"));
                setBtnLoading(false);
                return;
            } else {
                toast.success(t("auditRequest.cancel_success_msg"));
                setIsShowCancelModel(false);
                handleRefresh(false, requestNumber);
                // handleCancelSuccess(requestNumber);
                // const index = auditRequestList.findIndex((item) => item.request == requestData.requestNumber);
                // handleLoading(index, true);
                // await fetchRequestByRequestNumber(requestData.requestNumber);
                // handleLoading(index, false);-
            }
        } catch (err) {
            toast.error(err.message || t("auditRequest.api_call_failed_label"));
            setBtnLoading(false);
        } finally {
            setBtnLoading(false);
        }
    }

    const ssoCancelRequest = async () => {
        setBtnLoading(true);
        setError(null);
        try {
            const response = await requestAuditService.ssoCancelRequest(requestNumber);
            if (response && response.status == "Failed") {
                toast.error(response.errorMessage ? response.errorMessage : t("auditRequest.cancel_failed_msg"));
                setBtnLoading(false);
                return;
            } else {
                toast.success(t("auditRequest.cancel_success_msg"));
                setIsShowCancelModel(false);
                handleRefresh(false, requestNumber);
            }
        } catch (err) {
            toast.error(err.message || t("auditRequest.api_call_failed_label"));
            setBtnLoading(false);
        } finally {
            setBtnLoading(false);
        }
    }

    const ssoSendReminder = async () => {
        setBtnLoading(true);
        setError(null);
        try {
            const response = await requestAuditService.ssoSendReminder(requestNumber);
            if (response && response.status == "Failed") {
                toast.error(response.errorMessage ? response.errorMessage : t("auditRequest.something_went_wrong_label"));
                setBtnLoading(false);
                return;
            } else {
                toast.success(t("auditRequest.reminder_sent_success_label"));
                setIsShowModel(false);
                setIsShowReminderModel(false);
                handleRefresh(false, requestNumber);
            }
        } catch (err) {
            toast.error(err.message || t("auditRequest.api_call_failed_label"));
            setBtnLoading(false);
        } finally {
            setBtnLoading(false);
        }
    }

    const mypamCancelOrRemindRequest = async(cancelOrRemind) => {
        setBtnLoading(true);
        setError(null);
        try {
            let requestData = { "comments": "" }
            const response = await requestAuditService.mypamCancelOrRemindRequest(requestData, cancelOrRemind ,requestNumber);
            if (!response?.success) {
                toast.error(response.errorMessage ? response.errorMessage : t(cancelOrRemind === 'cancel' ? "auditRequest.cancel_failed_msg" : "auditRequest.something_went_wrong_label"));
                setBtnLoading(false);
                return;
            } else {
                toast.success(t(cancelOrRemind === 'cancel' ? "auditRequest.cancel_success_msg" : "auditRequest.reminder_sent_success_label"));
                cancelOrRemind === 'cancel' && handleRefresh(false, requestNumber);;
            }
        } catch (err) {
            toast.error(err.message || t("auditRequest.api_call_failed_label"));
            setBtnLoading(false);
        } finally {
            setBtnLoading(false);
            cancelOrRemind === 'cancel' ? setIsShowCancelModel(false) : setIsShowReminderModel(false);
        }
    }

    const entraSendFollowUp = async() => {
        setBtnLoading(true);
        setError(null);
        try {
            let requestData = { "requestNumber": requestNumber }
            const response = await requestAuditService.entraSendFollowUp(requestData);
            if (response && response.status == "Failed") {
                toast.error(response.errorMessage ? response.errorMessage : t("auditRequest.cancel_failed_msg"));
                setBtnLoading(false);
                return;
            } else {
                toast.success(t("auditRequest.reminder_sent_success_label"));
                setIsShowModel(false);
                setIsShowReminderModel(false);
            }
        } catch (err) {
            toast.error(err.message || t("auditRequest.api_call_failed_label"));
            setBtnLoading(false);
        } finally {
            setBtnLoading(false);
        }
    }

    const columns = [
        {
            columnKey: 'approverQueue',
            header: t("auditRequest.approver_queue_upper_label"),
            initialSize: 240
        },
        {
            columnKey: 'arrivedInQueue',
            header: t("auditRequest.arrived_in_queue_label"),
            initialSize: 160
        },
        {
            columnKey: 'status',
            header: t("auditRequest.status_label"),
            initialSize: 100,
            cellData: (ctx) => {
                return <>
                    {ctx.row.original?.checkSapGrcStatus ? <div className="grc-status-link" onClick={() => openGCRStatus(ctx.row.original?.checkSapGrcStatus)}>Check GRC Status</div> : <div>{normalizeToTitle(ctx.row.original.status)}</div>}
                </>
            }
        },
        {
            columnKey: 'dateCompleted',
            header: t("auditRequest.date_completed_label"),
            initialSize: 120
        },
        {
            columnKey: 'approver',
            header: t("auditRequest.approver_label"),
            initialSize: 120
        }       
    ];
    const requestSupportColumns = [
        {
            columnKey: 'approver',
            header: t("auditRequest.approver_label"),
            initialSize: 150
        },
        {
            columnKey: 'email',
            header: t("auditRequest.email_upper_label"),
            initialSize: 170,
            cellData: (ctx) => {
                return <>
                    <div dangerouslySetInnerHTML={{ __html: ctx.row.original.email }}></div>
                </>
            }
        },
        {
            columnKey: 'phoneNumber',
            header: t("auditRequest.phone_number_upper_label"),
            initialSize: 120
        },
        {
            columnKey: 'ext',
            header: t("auditRequest.exist_label"),
            initialSize: 120
        },
        {
            columnKey: 'gpid',
            header: t("auditRequest.gpid_label"),
            initialSize: 100
        }
    ];
    // const isOpenAppName = appIndexes[index];
    const [isShowAllStep, setIsShowAllStep] = useState(false);
    const [approvalList, setApprovalList] = useState([]);
    let lastStepApproved = false;
    const [visibleSteps, setVisibleSteps] = useState([]);
    let startIndex = 0;
    const handleDateRangeChange = (range) => {
        console.log("Selected Range:", range);
        setSelectedRange(range);
        setPageIndex(1);
    };

    useEffect(() => {
        const handleResize = () => {
            setIsMobile(window.innerWidth < 768);
            setIsTab(window.innerWidth >= 768 && window.innerWidth <= 1024);
            setIsLandscape(window.innerWidth < 768 && window.innerWidth > window.innerHeight);
        };

        window.addEventListener('resize', handleResize);

        return () => window.removeEventListener('resize', handleResize);
    }, []);

    useEffect(() => {
        if (searchNum && searchNum.trim() !== "" && selectedStatusFilter?.[0]) {
            if((selectedStatusFilter?.[0]?.value ||state?.statusFilter) && selectedRange?.from && selectedRange?.to && state?.type !== "requestNumber" && !loadingRef.current)fetchAuditRequest(searchNum, true, false);            
            return;
        }

        setShoudlShowDateAndStatusFilters(true);

        if(!loadingRef.current)loadInitialData();

    }, [state]);

    const handleApplyFilter = () => {
        setToggleFilter(false)
        if (searchNum && searchNum.trim() !== "" && selectedStatusFilter?.[0]) {
            if((selectedStatusFilter?.[0]?.value ||state?.statusFilter) && selectedRange?.from && selectedRange?.to && state?.type !== "requestNumber" && !loadingRef.current)fetchAuditRequest(searchNum, true, false);            
            return;
        }

        if(state?.type === "requestNumber") setShoudlShowDateAndStatusFilters(false);
        else setShoudlShowDateAndStatusFilters(true);

        setSelectedStatusFilterAfterApply([...selectedStatusFilter]);
        setSelectedRangeAfterApply({...selectedRange})

        if(!loadingRef.current)loadInitialData();
    }

    useEffect(() => {
        if (state?.statusFilter == "in progress") {
            setSelectedStatusFilter([{ id: '2', displayText: t("auditRequest.audit_in_progress"), value: 'in progress' }])
            setSelectedStatusFilterAfterApply([{ id: '2', displayText: t("auditRequest.audit_in_progress"), value: 'in progress' }])
            // setSelectedFilter({ id: '2', label: t("auditRequest.audit_in_progress"), value: 'in progress' });
            // selectedFilterRef.current = { id: '2', label: t("auditRequest.audit_in_progress"), value: 'in progress' };
        }else{
            setSelectedStatusFilter([{ id: '5', displayText: t("auditRequest.audit_all"), value: 'all' }])
            setSelectedStatusFilterAfterApply([{ id: '5', displayText: t("auditRequest.audit_all"), value: 'all' }])
            // setSelectedFilter({ id: '5', label: t("auditRequest.audit_all"), value: 'all' });
            // selectedFilterRef.current = { id: '5', label: t("auditRequest.audit_all"), value: 'all' };
        }

        const currentDate = new Date();
        const oneMonthBack = new Date();
        oneMonthBack.setMonth(oneMonthBack.getMonth() - 1);
        setSelectedRange({
            from: oneMonthBack,
            to: currentDate,
        })
        setSelectedRangeAfterApply({
            from: oneMonthBack,
            to: currentDate,
        })

        setShoudlShowDateAndStatusFilters(true);

        setSearchType(deepLinkRequestNumber ? "requestNumber" : state?.type)
        setSearchValue(deepLinkRequestNumber ? deepLinkRequestNumber.trim() : state?.value)
    }, [])


    useEffect(() => {
        if(fetchByDate){
            console.log(selectedRange?.from);
            console.log(selectedRange?.to);
            if(state?.type === "requestNumber" && state?.value) setDisableFilter(true);
            if(deepLinkRequestNumber) setDisableFilter(true);
            const from = selectedRange?.from;
            const to = selectedRange?.to;
            if (!from || !to) return;
            if(!loadingRef.current)loadInitialData();
            setFetchByDate(false)
        }
    }, [selectedRange]);

  const loadInitialData = () => {
        if (deepLinkRequestNumber) {
            // Deep link (?requestNumber=IAMCxxxx): search by request number and open its details.
            const requestNumberFromLink = deepLinkRequestNumber.trim();
            if (requestNumberFromLink && deepLinkHandledRef.current !== requestNumberFromLink) {
                deepLinkHandledRef.current = requestNumberFromLink;
                setSearchType("requestNumber");
                setSearchValue(requestNumberFromLink);
                setAuditRequestList([]);
                setTotalRecords(0);
                setDisableFilter(true);
                searchRequestByRequestNumber(requestNumberFromLink, true);
            }
            return;
        }
        deepLinkHandledRef.current = null;

        if (!state || state?.statusFilter) {
            const data = JSON.parse(localStorage.getItem("okta-token-storage"));
            if (data?.accessToken?.claims?.gpid) {
                setUserGpId(data?.accessToken?.claims?.gpid);
                if((selectedStatusFilter?.[0]?.value ||state?.statusFilter) && selectedRange?.from && selectedRange?.to && state?.type !== "requestNumber")fetchAuditRequest(data?.accessToken?.claims?.gpid);
            }
            return;
        };

        if (state?.type === "gpid" || (selectedRange?.from && selectedRange?.to)) {
            if((selectedStatusFilter?.[0]?.value ||state?.statusFilter) && selectedRange?.from && selectedRange?.to && state?.type !== "requestNumber")fetchAuditRequest(state?.value);
            return;
        }else if(state?.type === "requestNumber"){
            setAuditRequestList([]);
            setTotalRecords(0);
            searchRequestByRequestNumber(state?.value);
            return
        }
    }

    const selectedTab = (index) => {
        setSelectedTabIndex(index);
        if(state?.searchFor!=="ENTRA")getDataByStatus(appName, auditRequestData?.status, auditRequestData?.auditApprovalData, index);
    };

    const formatDate = (dateString) => {
        if (!dateString) return null;
        const date = new Date(dateString);
        const month = String(date.getMonth() + 1).padStart(2, "0");
        const day = String(date.getDate()).padStart(2, "0");
        const year = date.getFullYear();
        return `${year}-${month}-${day}`;
    };

    const formatDateMMDDYYY = (dateString) => {
        if (!dateString) return null;
        const date = new Date(dateString);
        const month = String(date.getMonth() + 1).padStart(2, "0");
        const day = String(date.getDate()).padStart(2, "0");
        const year = date.getFullYear();
        return `${month}-${day}-${year}`;
    };


    const fetchAuditRequest = async (value, isSearch, isRefresh, page = null, isLoadFromScroll = false, requestNumForRequestDetail) => {
        if (isLoadFromScroll && auditRequestList.length >= totalRecords) {
            hasMoreRef.current = false;
            return;
        }
        setLoading(true);
        showLoader();
        loadingRef.current = true;
        setError(null);
        setShowNoDataFound(false);
        setViewRequestNoShowNoDataFound(false)
        setShowNetworkError(false);
        setShowServiceUnavailable(false);
        // setRefreshVal(value);
        try {
            if (!value) {
                setError(t("auditRequest.value_missing_label"));
                setLoading(false);
                hideLoader()
                loadingRef.current = false;
                return;
            }
            const index = page || pageIndex;
            let data = { "isPassword": false, "pageIndex": isRefresh ? 1 : index }
            if (isSearch) {
                data['requestNumber'] = value;
            } else {
                if (!state || state?.statusFilter) {
                    data['gpid'] = state?.type && state?.value ? value : "";
                }
                if (state) {
                    if (state.type == "GPID" || state?.type == "gpid") {
                        data['gpid'] = value;
                    }
                    if (state.type == "requestNumber") {
                        data['requestNumber'] = value;
                    }
                }
            }
            if (selectedStatusFilter?.[0]?.value || state?.statusFilter) {
                data['statusFilter'] = isRefresh ? "all" : (selectedStatusFilter?.[0]?.value || state?.statusFilter);
            }
            if (selectedRange) {
                const requestedFromFormatted = formatDate(selectedRange?.from);
                const requestedOnFormatted = formatDate(selectedRange?.to);
                const currentDate = new Date();
                const oneMonthBack = new Date();
                oneMonthBack.setMonth(oneMonthBack.getMonth() - 1);
                data['requestedFrom'] = isRefresh ? formatDate(currentDate) : requestedOnFormatted;
                data['requestedOn'] = isRefresh ? formatDate(oneMonthBack) : requestedFromFormatted;
            }
            let response = await requestAuditService.getAuditRequestByGpid(data);

            if (response.data && response.data.status === "Failed") {
                // setError(response.data.errorMessage);
                setLoading(false);
                hideLoader();
                setShowNetworkError(true);
                return;
            }
            if(!response.data?.viewRequestsDetails?.viewRequests?.length){
                setLoading(false);
                hideLoader();
                setShowNoDataFound(true)
                setViewRequestNoShowNoDataFound(true)
                return;
            }
            setExpandedIndexes({})
            setSearchValue(value);
            if (response.data && response.data?.viewRequestsDetails?.viewRequests?.length > 0) {
                response.data.viewRequestsDetails.viewRequests = response.data?.viewRequestsDetails?.viewRequests.reduce((result, rec)=>{
                    const recArr = [];
                    rec.appNameList.forEach((appNameRec)=>{
                        const obj = {};
                        obj.applicationsRequested = appNameRec;
                        obj.requestType = rec?.requestType?.[appNameRec];
                        obj.request = rec?.requestNumber;
                        obj.dateRequested = rec?.dateRequested;
                        obj.status = rec?.status;
                        obj.userGpid = rec?.subjectGpid;
                        obj.userName = rec?.subjectName;
                        obj.requestorGpid = rec?.initiatorName
                        obj.requestorName = rec?.initiatorGpid;
                        obj.overAllStatus = rec?.overAllStatus;

                        recArr.push(obj);
                    })
                    return [...result,...recArr];

                },[])
                const auditData = response.data.viewRequestsDetails.viewRequests;
                let totalRecords = response.data.viewRequestsDetails.totalRecords;
                const grouped = auditData.reduce((acc, item) => {
                    if (!acc[item.request]) acc[item.request] = [];
                    acc[item.request].push(item);
                    return acc;
                }, {});

                const auditRequestList = Object.entries(grouped).map(([, items]) => {
                    const groupedStatus = getGroupedRequestStatus(items);

                    if (items.length > 1) {
                        return {
                            ...items[0],
                            status: groupedStatus || items[0]?.status,
                            overAllStatus: groupedStatus || items[0]?.overAllStatus,
                            auditApprovalData: {},
                            bundledRequest: items.map(i => ({
                                ...i,
                                auditApprovalData: {},
                            })),
                        };
                    } else {
                        return {
                            ...items[0],
                            status: groupedStatus || items[0]?.status,
                            overAllStatus: groupedStatus || items[0]?.overAllStatus,
                            auditApprovalData: {},
                            bundledRequest: [],
                        };
                    }
                });
                console.log("Unified List:", auditRequestList);
                
                const orderMap = {};
                response.data?.viewRequestsDetails?.viewRequests.forEach((r, index) => {
                    orderMap[r.requestNumber || r.request] = index;
                });
                
                const sortedList = [...auditRequestList];
                sortedList.sort((a, b) => {
                    const orderA = orderMap[a.request] !== undefined ? orderMap[a.request] : Infinity;
                    const orderB = orderMap[b.request] !== undefined ? orderMap[b.request] : Infinity;
                    return orderA - orderB;
                });

                if(isLoadFromScroll){
                    setAuditRequestList((prevList) => [...prevList, ...sortedList]);
                }
                else{
                    setAuditRequestList([...sortedList]);
                    if(!isMobile) {
                        const matchedIndex = requestNumForRequestDetail ? sortedList.findIndex((item) => normalizeRequestNumber(item.request) === normalizeRequestNumber(requestNumForRequestDetail) || normalizeRequestNumber(item.requestNumber) === normalizeRequestNumber(requestNumForRequestDetail)) : -1;
                        const hasMatchedRequest = matchedIndex >= 0;
                        const fallbackIndex = sortedList.length > 0 ? 0 : -1;
                        const targetIndex = hasMatchedRequest ? matchedIndex : fallbackIndex;
                        const selectedRequestNumber = targetIndex >= 0 ? (sortedList[targetIndex]?.request || sortedList[targetIndex]?.requestNumber || requestNumForRequestDetail) : null;
                        if (selectedRequestNumber) {
                            onClickToExpandRequest(selectedRequestNumber, targetIndex, sortedList);
                        }
                    }
                }
                setTotalRecords(totalRecords);                
            } else {
                // setError(t("auditRequest.no_data_found_label"));
                setShowNoDataFound(true)
                setViewRequestNoShowNoDataFound(true)
                setAuditRequestList([])
                setTotalRecords(0);
            }
        } catch (err) {
            if(err.message === "Network Error"){
                setLoading(false);
                hideLoader();
                setShowNetworkError(true);
            }else{
                setLoading(false);
                hideLoader();
                setShowServiceUnavailable(true);
            }
            // setError(err.message || t("auditRequest.api_call_failed_label"));
        } finally {
            setLoading(false);
            hideLoader();
            loadingRef.current = false;
        }
    }

    const onClickToViewDetail = (requestNumber, event) => {
        // console.log("auditRequestData in onClickToViewDetail:", auditData);
        setRequestNumber(requestNumber);
        setShowDetail(true);
        event?.stopPropagation?.();
    }

    const sendReminder = async () => {
        setBtnLoading(true);
        setError(null);
        try {
            const data = JSON.parse(localStorage.getItem("okta-token-storage"));
            let gpid;
            if (data?.accessToken?.claims?.gpid) {
                gpid = data?.accessToken?.claims?.gpid;
            }
            // let requestData = { "requestNumber": requestNumber, "searchBy": gpid }
            const response = await requestAuditService.sendFollowUp(sendReminderPayload);
            if (response.data && response.data.status?.toLowerCase() === "success") {
                toast.success(t("auditRequest.reminder_sent_success_label"));
                setIsShowModel(false);
                setIsShowReminderModel(false);
                const index = auditRequestList.findIndex((item) => item.request == requestNumber);
                handleLoading(index, true);
                await fetchRequestByRequestNumber(requestNumber);
                handleLoading(index, false);
            } else {
                toast.error(t("auditRequest.something_went_wrong_label"));
                setBtnLoading(false);
            }
        } catch (err) {
            toast.error(err.message || t("auditRequest.api_call_failed_label"));
            setBtnLoading(false);
        } finally {
            setBtnLoading(false);
        }
    }

    const handleToggle = (index) => {
        setExpandedIndexes((prev) => ({
            ...prev,
            [index]: !prev[index]
        }))
    }



    const handleAppNameToggle = (index, event) => {
        setAppIndexes((prev) => ({
            ...prev,
            [index]: !prev[index]
        }));
        event?.stopPropagation?.();
    }

    const handleLoading = (index, value) => {
        setLoadingIndexes((prev) => ({
            ...prev,
            [index]: value
        }));
    };

    const handleError = (index, message) => {
        setErrorIndexes((prev) => ({
            ...prev,
            [index]: message
        }));
    };

    const toggleShowAll = () => {
        const nextShowAll = !isShowAllStep;
        setIsShowAllStep(nextShowAll);

        if (auditRequestData?.auditApprovalData && Object.keys(auditRequestData.auditApprovalData).length > 0) {
            const appRequestedName = auditRequestData?.auditApprovalData?.requestType !== 'APPLICATION_RETIREMENT' ? ((auditRequestData?.bundledRequest && auditRequestData?.bundledRequest.length > 0) ? appName : (auditRequestData?.applicationsRequested || "")) : appName;
            const match = getMatchedObject(
                auditRequestData?.auditApprovalData?.workItemsMap,
                appRequestedName
            );

            if (match) {
                setApprovalList(match?.object);
            } else {
                setApprovalList([]);
            }

            const lastState = match?.object?.[match?.object?.length - 1]?.state;

            lastStepApproved = lastState?.toLowerCase() === "approved";

            const steps = !lastStepApproved && !nextShowAll
                ? match?.object?.slice(-2)
                : match?.object;

            setVisibleSteps(steps);

            startIndex = match?.object?.length - steps?.length;
        }
    };

    const onClickToExpandRequest = async (requestNumber, index, list, shouldHideLoader=false) => {
        let data = list || auditRequestList;
        data = data.find((item) => normalizeRequestNumber(item.request) === normalizeRequestNumber(requestNumber) || normalizeRequestNumber(item.requestNumber) === normalizeRequestNumber(requestNumber));
        if (!data) {
            return false;
        }
        setisRequestSelected(true);
        setAuditRequestData(null);
        setApproverQueue([]);
        setApproverQueueList([]);
        setRoutingList([]);
        setRequestDetail([]);
        setVisibleSteps([]);
        setSelectedTabIndex(0);
        setViewRequestNoShowNoDataFound(false);
        {
            handleToggle(index);
            handleError(index, null);
            try {
                handleLoading(index, true);
                setLoading(true);
                showLoader();
                const success = await fetchRequestByRequestNumber(requestNumber, index, data);
                
                if (!success) {
                    handleError(index, t("auditRequest.no_data_found_label"));
                    setLoading(false);
                    hideLoader();
                }
                if(isShowAllStep)toggleShowAll();
                else setIsShowAllStep(false);
                handleLoading(index, false);
                setLoading(false);
                if (requestListRef.current) {
                    const elements = requestListRef.current.querySelectorAll(".details-content-group small");
                    const truncatedTooltipObj = {};

                    elements.forEach((el, idx) => {
                        const isTruncated =
                        el.scrollWidth > el.clientWidth || el.scrollHeight > el.clientHeight;

                        truncatedTooltipObj[idx] = isTruncated;

                        // if (!isTruncated) {
                        //     el.removeAttribute("data-tooltip-id");
                        //     el.removeAttribute("data-tooltip-content");
                        // }
                    });
                    setTruncatedTooltip(truncatedTooltipObj);
                }

            } catch (e) {
                setLoading(false);
                hideLoader();
                handleError(index, t("auditRequest.something_went_wrong_label"));
                handleLoading(index, false);
            }
        }
        // setAppIndexes((prev) => ({
        //     ...prev,
        //     [index]: prev[index] ? !prev[index] : prev[index]
        // }));
        setTimeout(()=>{
            setRequestDataLoaded(true);
        },10)
        if(shouldHideLoader){
            setLoading(false);
            hideLoader();
            loadingRef.current = false;
        }
    }

    const fetchRequestByRequestNumber = async (requestNumber, index, baseData) => {
        const baseItem = baseData || auditRequestList.find((item) => normalizeRequestNumber(item.request) === normalizeRequestNumber(requestNumber)) || {};
        setApproverQueue([]);
        setApproverQueueList([]);
        setRoutingList([]);
        setRequestDetail([]);
        setApprovalList([]);
        setVisibleSteps([]);
        setAuditRequestData(null);

        if(state?.searchFor==="ENTRA"){
            const data = {
                "requestNumber": requestNumber
            };
            showLoader();
            try{
                const response = await requestAuditService.getEntraAuditRequestByRequestNumber(data);
                if (response.status === "Failed") {
                    hideLoader();
                    toast.error(response?.errorMessage);
                    return false;
                }
    
                setAuditRequestData(response);
                hideLoader();
            }catch (err) {
                hideLoader();
            }
        }else{
            const data = {
                "requestNumber": requestNumber,
                "isPassword": false
            };
            setLoading(true);
            showLoader();
            setViewRequestNoShowNoDataFound(false);
            const response = await requestAuditService.getAuditRequestByRequestNumber(data);
            if (response.data?.status === "Failed") {
                setLoading(false);
                hideLoader();
                toast.error(response.data?.errorMessage);
                setShowNetworkError(true);
                return false;
            }

            if(Object.keys(response.data).length === 0){
                setLoading(false);
                hideLoader();
                setViewRequestNoShowNoDataFound(true)
                return false;
            }

            if(response.data.isCancelled){
                const updatedWorkItemsMap = {};
                const appQueueArray = Object.entries(response.data.workItemsMap);
                if(appQueueArray.length){
                    appQueueArray.forEach(([appName,queueArr])=>{
                        const updatedQueueArrayStatus = queueArr.map((queueData)=>(isInProgressStatus(queueData.status) ? {...queueData, status: "Cancelled"}: queueData));
                        updatedWorkItemsMap[appName] = updatedQueueArrayStatus;
                    })
                }
                response.data.workItemsMap = updatedWorkItemsMap;
            }
            setLoading(false);
            hideLoader();
            setBundledRequestSelectedAppId(null);
            let auditRequestList = [];

            const arReqTypeAttributeArr = response?.data?.arReqTypeAttribute
                ? Object.entries(response?.data?.arReqTypeAttribute)
                : [];

            if (arReqTypeAttributeArr.length > 0) {

                auditRequestList = arReqTypeAttributeArr.map((rec) => {
                    const auditRequestData = {};
                    auditRequestData.applicationsRequested = rec?.[0];
                    auditRequestData.requestType = rec?.[1] || (response?.data?.requestType?.startsWith?.("MYPAM_") ? formatMyPAMRequestType(response?.data?.requestType) : response?.data?.requestType);
                    return auditRequestData;
                });

            } else {

                const appName = response?.data?.appNameMap
                    ? Object.values(response?.data?.appNameMap)?.[0]
                    : response?.data?.applicationName;

                if (appName) {

                    const auditRequestData = {};
                    auditRequestData.applicationsRequested = appName;
                    auditRequestData.requestType = response?.data?.requestType?.startsWith?.("MYPAM_") ? formatMyPAMRequestType(response?.data?.requestType) : response?.data?.requestType;
                    auditRequestList.push(auditRequestData);

                } else if (response?.data?.workItemsMap) {

                    auditRequestList = Object.keys(response?.data?.workItemsMap).map((rec) => {
                        const auditRequestData = {};
                        auditRequestData.applicationsRequested = rec;
                        auditRequestData.requestType = response?.data?.requestType?.startsWith?.("MYPAM_") ? formatMyPAMRequestType(response?.data?.requestType) : response?.data?.requestType;
                        return auditRequestData;
                    });

                }

                if (!auditRequestList.length) {
                    const auditRequestData = {};
                    auditRequestData.applicationsRequested = "";
                    auditRequestData.requestType = response?.data?.requestType?.startsWith?.("MYPAM_") ? formatMyPAMRequestType(response?.data?.requestType) : response?.data?.requestType || "";
                    auditRequestList.push(auditRequestData);
                }
            }
            const requestList = [];

            if (auditRequestList.length > 1) {

                requestList.push({
                    ...auditRequestList[0],
                    auditApprovalData: response.data,
                    bundledRequest: auditRequestList.map(i => ({
                        ...i,
                        auditApprovalData: response.data
                    }))
                });

            } else {

                requestList.push({
                    ...auditRequestList[0],
                    auditApprovalData: response.data,
                    bundledRequest: []
                });
            }

            setAuditRequestList((prevList) =>
                prevList.map((item) =>
                    item.request == requestNumber
                        ? {
                            ...item,
                            status: response?.data?.overAllStatus || item?.status,
                            overAllStatus: response?.data?.overAllStatus || item?.overAllStatus,
                            auditApprovalData: response.data,
                            bundledRequest: requestList?.[0]?.bundledRequest || []
                        }
                        : item
                )
            );
            setAuditRequestData({
                ...baseItem,
                request: baseItem?.request || response.data.requestNumber || requestNumber,
                applicationsRequested: baseItem?.applicationsRequested || requestList?.[0]?.applicationsRequested || "",
                requestType: baseItem?.requestType || requestList?.[0]?.requestType || response.data.requestType,
                dateRequested: baseItem?.dateRequested || response.data.dateRequested,
                status: response?.data?.overAllStatus || baseItem?.status,
                overAllStatus: response?.data?.overAllStatus || baseItem?.overAllStatus,
                bundledRequest: requestList?.[0]?.bundledRequest || [],
                auditApprovalData: response.data
            });

            const status = response.data.overAllStatus;
            const invalidValues = ["", "null", null, undefined, "undefined"];
            const appNames = response.data.distinctAppsList || [];
            const approvalData = response.data;

            let filteredData = approvalData;
            const requestedAppName = auditRequestList.length > 1 ? requestList?.[0]?.bundledRequest?.[0]?.applicationsRequested : appNames[0];
            setAppName(requestedAppName);
            setRequestId(response.data.requestNumber);
            filteredData = approvalData?.workItemsMap?.[requestedAppName] || [];
            let approverDetailsMap = approvalData?.approverDetailsMap?.[requestedAppName] || [];

            console.log("filteredData:::::::", filteredData);
            const transformedData = filteredData.map(item => ({
                approverQueue: invalidValues.includes(item?.queueName) ? t("auditRequest.not_applicable") : item?.queueName,
                arrivedInQueue: invalidValues.includes(item?.dateArrived) ? t("auditRequest.not_applicable") : item?.dateArrived,
                status: invalidValues.includes(item?.status) ? t("auditRequest.not_applicable") : item?.status,
                dateCompleted: invalidValues.includes(item?.dateApproved) ? t("auditRequest.not_applicable") : item?.dateApproved,
                approver: invalidValues.includes(item?.approverGpid) ? t("auditRequest.not_applicable") : item?.approverGpid,
                followUp: approvalData?.isCancelled ? approvalData?.isAppFollowupEnabled && item.followupAvailable : item.followupAvailable,
                allFollowupTsp: item.allFollowupTsp,
            }));

            const transformedRoutingData = mapApproverDetails(approverDetailsMap, t("auditRequest.not_applicable"));
            // let approverQueueData = [];

            // approverQueueData = status === "Complete" ? transformedData.filter((a) => a.status.toLowerCase() == "approved") : transformedData;
            // approverQueueData = approverQueueData?.length === 0 ? transformedData : approverQueueData;
            setRoutingList(transformedRoutingData);
            setApproverQueue(transformedData);
            setApproverQueueList(transformedData);
            getDataByStatus(requestedAppName, status, response.data, 0);
            if(transformedData?.filter(x=>x.followupAvailable)?.length > 0){
                setIsFollowUpAvailable(true)
            }
            
            setBundledRequestSelectedAppId(requestList?.[0]?.bundledRequest?.[0] || null);
            if (response?.data &&
                Object.keys(response?.data).length > 0) {
                const appRequestedName = response?.data?.applicationsRequested || "";
                const match = getMatchedObject(
                    response?.data?.workItemsMap,
                    appRequestedName
                );

                if (match) {
                    setApprovalList(match?.object);
                } else {
                    setApprovalList([]);
                }

                const lastState = match?.object?.[match?.object?.length - 1]?.state;

                lastStepApproved = lastState?.toLowerCase() === "approved";

                const steps = !lastStepApproved && !isShowAllStep
                    ? match?.object?.slice(-2)
                    : match?.object;
                setVisibleSteps(steps);
                startIndex = match?.object?.length - steps?.length;            
            }
        }
        return true;
    }

    const onClickToCancelRequest = async () => {
        setIsShowCancelModel(true);
        setBtnLoading(true);
        setError(null);
        try {
            const data = JSON.parse(localStorage.getItem("okta-token-storage"));
            let gpid;
            if (data?.accessToken?.claims?.gpid) {
                gpid = data?.accessToken?.claims?.gpid;
            }
            let requestData = { "requestNumber": requestNumber, "searchBy": gpid }
            const response = await requestAuditService.cancelRequest(requestData);
            if (response.data && response.data.status == "Failed") {
                toast.error(response.data.errorMessage ? response.data.errorMessage : t("auditRequest.cancel_failed_msg"));
                setBtnLoading(false);
                return;
            } else {
                handleCancelSuccess(requestNumber);
                toast.success(t("auditRequest.cancel_success_msg"));
                setIsShowCancelModel(false);
                const index = auditRequestList.findIndex((item) => item.request == requestData.requestNumber);
                handleLoading(index, true);
                handleRefresh(false, requestNumber);
                handleLoading(index, false);
                // setIsCancelConfirmModel(true);
            }
        } catch (err) {
            toast.error(err.message || t("auditRequest.api_call_failed_label"));
            setBtnLoading(false);
        } finally {
            setBtnLoading(false);
        }
    }

    const handleCancelSuccess = (requestId) => {
        setAuditRequestList(prevList =>
            prevList.map(item => item.request == requestId ? { ...item, status: "Complete" } : item)
        );
    }

    const renderToastContainer = () => {
        return (
            <ToastContainer
                position="bottom-center"
                autoClose={5000}
                hideProgressBar={false}
                closeOnClick
                pauseOnHover
                draggable
            />
        )
    }

    const onSelectFilter = (data) => {
        // setSelectedFilter(data);
        // selectedFilterRef.current = data
        setPageIndex(1);
    };

    const isReminder = (lastReminder) => {
        if (lastReminder) {
            const reminderDate = new Date(lastReminder.replace(' ', 'T'));
            const now = new Date();
            const diffHours = (now - reminderDate) / (1000 * 60 * 60);
            return diffHours <= 24;
        }
        return false;
    }

    const searchRequestByRequestNumber = async (requestNumber, isSearch=false) => {
        if(state?.searchFor==="ENTRA"){
            const data = {
                "requestNumber": requestNumber
            };
            showLoader();
            try{
                const response = await requestAuditService.getEntraAuditRequestByRequestNumber(data);
                if (response.status === "Failed") {
                    hideLoader();
                    toast.error(response?.errorMessage);
                    return false;
                }
    
                setAuditRequestData(response);
                hideLoader();
            }catch (err) {
                hideLoader();
            }
        }else{

            setError(null);
            setViewRequestNoShowNoDataFound(false);
            setShowNetworkError(false);
            setShowServiceUnavailable(false);
            setLoading(true);
            showLoader();
            loadingRef.current = true;

            try{
                const data = {
                    "requestNumber": requestNumber,
                    "isPassword": false
                };
                const response = await requestAuditService.getAuditRequestByRequestNumber(data);
                if (response.data?.status === "Failed") {
                    toast.error(response.data?.errorMessage);
                    setLoading(false);
                    hideLoader();
                    loadingRef.current = false;
                    setShowNetworkError(true);
                    return false;
                }

                if(Object.keys(response.data).length === 0){
                    setLoading(false);
                    hideLoader();
                    loadingRef.current = false;
                    setViewRequestNoShowNoDataFound(true)
                    return false;
                }
                
                if(response.data.isCancelled){
                    const updatedWorkItemsMap = {};
                    const appQueueArray = Object.entries(response.data.workItemsMap);
                    if(appQueueArray.length){
                        appQueueArray.forEach(([appName,queueArr])=>{
                            const updatedQueueArrayStatus = queueArr.map((queueData)=>(isInProgressStatus(queueData.status) ? {...queueData, status: "Cancelled"}: queueData));
                            updatedWorkItemsMap[appName] = updatedQueueArrayStatus;
                        })
                    }
                    response.data.workItemsMap = updatedWorkItemsMap;
                }

                setExpandedIndexes({})
                setSearchValue(requestNumber);

                if(!response?.data?.dateRequested){
                    // setError(t("auditRequest.no_data_found_label"));
                    setLoading(false);
                    hideLoader();
                    setViewRequestNoShowNoDataFound(true)
                    setAuditRequestList([])
                    setTotalRecords(0);
                }else{
                    let auditRequestList = [];
                    
                    const arReqTypeAttributeArr = response?.data?.arReqTypeAttribute ? Object.entries(response?.data?.arReqTypeAttribute) : [];
                    if(arReqTypeAttributeArr.length>0){
                        auditRequestList = arReqTypeAttributeArr.map((rec)=>{
                            const auditRequestData = {};
                            auditRequestData.applicationsRequested = rec?.[0];
                            auditRequestData.requestType = rec?.[1] || (response?.data?.requestType?.startsWith?.("MYPAM_") ? formatMyPAMRequestType(response?.data?.requestType) : response?.data?.requestType);
                            return auditRequestData;
                        });
                    }else{
                        const appName = response?.data?.appNameMap ? Object.values(response?.data?.appNameMap)?.[0] : response?.data?.applicationName;
                        if(appName){
                            const auditRequestData = {}; // handle this for simple and bulk for non ar
                            auditRequestData.applicationsRequested = appName;
                            auditRequestData.requestType = response?.data?.requestType?.startsWith?.("MYPAM_") ? formatMyPAMRequestType(response?.data?.requestType) : response?.data?.requestType;
                            auditRequestList.push(auditRequestData);
                        }else if(response?.data?.workItemsMap){
                            auditRequestList = Object.keys(response?.data?.workItemsMap).map((rec)=>{
                            const auditRequestData = {};
                            auditRequestData.applicationsRequested = rec;
                            auditRequestData.requestType = response?.data?.requestType?.startsWith?.("MYPAM_") ? formatMyPAMRequestType(response?.data?.requestType) : response?.data?.requestType;
                            return auditRequestData;
                        });
                        }

                        if(!auditRequestList.length){
                            const auditRequestData = {};
                            auditRequestData.applicationsRequested = "";
                            auditRequestData.requestType = response?.data?.requestType?.startsWith?.("MYPAM_") ? formatMyPAMRequestType(response?.data?.requestType) : response?.data?.requestType || "";
                            auditRequestList.push(auditRequestData);
                        }
                    }

                    auditRequestList = auditRequestList.map((rec)=>{
                        const auditRequestData = {...rec}; 

                        auditRequestData.dateRequested = response?.data?.dateRequested;
                        auditRequestData.request = response?.data?.requestNumber;
                        auditRequestData.requestorName = response?.data?.initiatorGpid?.split?.('-')?.[0]?.trim();
                        auditRequestData.status = response?.data?.overAllStatus;
                        auditRequestData.userGpid = response?.data?.subjectGpid?.split?.('-')?.[0]?.trim();
                        auditRequestData.requestorGpid = response?.data?.initiatorGpid?.split?.('-')?.[1]?.trim()?.split?.(" ")?.[0];
                        auditRequestData.userName = response?.data?.subjectGpid?.split?.('-')?.[1]?.trim()?.split?.(" ")?.[0];

                        return auditRequestData;
                    })

                    const requestList = [];

                    if (auditRequestList.length > 1) {
                        requestList.push({
                            ...auditRequestList[0],
                            auditApprovalData: {},
                            bundledRequest: auditRequestList.map(i => ({
                                ...i,
                                auditApprovalData: {},
                            })),
                        });
                    } else {
                        requestList.push({
                            ...auditRequestList[0],
                            auditApprovalData: {},
                            bundledRequest: [],
                        });
                    }

                    setTotalRecords(auditRequestList.length || 0);
                    setBundledRequestSelectedAppId(null)
                    setBundledRequestSelectFrom("")
                    scrollRef.current = null;
                    setAppName("")
                    setRequestId("");
                    setAppIndexes({})
                    setAuditRequestList(
                        requestList.map((item) =>
                            item.request == requestNumber
                                ? { ...item, auditApprovalData: response.data }
                                : item
                        )
                    );
                    if(!isMobile) {
                        onClickToExpandRequest(requestNumber, 0, auditRequestList, true);
                    }
                }
            if(isMobile){
                setLoading(false);
                hideLoader();
                loadingRef.current = false;
            }
            if(isSearch){
                setShowRequestSearch(false);
            }
            } catch (err) {
                if(err.message === "Network Error"){
                    setLoading(false);
                    hideLoader();
                    setShowNetworkError(true);
                }else{
                    setLoading(false);
                    hideLoader();
                    setShowServiceUnavailable(true);
                }
                // setError(err.message || t("auditRequest.api_call_failed_label"));
            } finally {
                if(isMobile){
                setLoading(false);
                hideLoader();
                loadingRef.current = false;
            }
            }
        }
        return true;
    }

    const handleSearch = () => {
        if(searchNum.length < 4){
            toast.error(t("auditRequest.search_limit_message"));
            return
        }
        setSearchType("requestNumber");
        setSearchValue(searchNum);
        // fetchAuditRequest(searchNum, true, false, 1);
        setAuditRequestList([]);
        setTotalRecords(0);
        searchRequestByRequestNumber(searchNum, true);
        setDisableFilter(true)
    };



    const AllButtonContainers = () => {
        return (
            <>
                <div id="audit_requests" className="_filter">
                    <div className="div-5">
                        <div className="audit_filter_section w-100 pr-2">
                            <div className="d-flex mt-md-0 mt-2">
                                {
                                    (shoudlShowDateAndStatusFilters || !shoudlShowDateAndStatusFilters) ? <>
                                    {/* <Filter
                                        className="mr-1"
                                        key={selectedFilter ? selectedFilter.value : "none"}
                                        iconLeading="filter"
                                        isClearable={false}
                                        label={t("auditRequest.request_status")}
                                        menuPosition="bottom-right"
                                        onChange={(data) => onSelectFilter(data)}
                                        value={selectedFilter}
                                        options={auditFilterOptions}
                                        selection="single"
                                        size="small"
                                        showSearch={false}
                                    />   */}
                                    <div
                                        style={{
                                            alignItems: 'center',
                                            display: 'flex',
                                            justifyContent: 'center',
                                            position: 'relative'
                                        }}
                                        >
                                        <Button
                                            onClick={()=>setToggleFilter((prev)=>!prev)}
                                            text={t("auditRequest.filter")}
                                            variant="secondary"
                                            className="filter-btn togglt-filter m-0"
                                            size="small"
                                            iconLeading="filter_alt"
                                            style={{paddingRight: "2rem"}}
                                            disabled={disableFilter}
                                        />
                                        {!disableFilter ? <Badge
                                            className="m-0"
                                            type="important"
                                            value={(selectedStatusFilter && selectedRange) ? '2' : (selectedStatusFilter || selectedRange) ? '1' : '0'}
                                        /> : <div className="px-1"></div>}
                                        <div
                                            style={{
                                            padding: '15px 0',
                                            position: 'absolute',
                                            top: '130%',
                                            right: '-25%'
                                            }}
                                            className="popover-container"
                                        >
                                            <Popover
                                            badgeValue=""
                                            className=""
                                            direction="top-left"
                                            onClosePopover={()=>setToggleFilter(false)}
                                            showSlot
                                            showPopover={toggleFilter}
                                            style={{}}
                                            text={t("auditRequest.filter")}
                                            >
                                                <Dropdown
                                                    childList={auditFilterOptions}
                                                    label={t("auditRequest.status")}
                                                    placeholder={t("RequestGPIDForNonEmployee.select_btn_label")}
                                                    isClearable={false}
                                                    selection="single"
                                                    size="medium"
                                                    setSelectedValue={(selected) => setSelectedStatusFilter(selected)}
                                                    selectedValue={selectedStatusFilter}
                                                    onKeyDown={(e) => e.preventDefault()}
                                                    showLabelIcon={false}
                                                    style={{gap: ".5rem", marginBottom: ".5rem"}}
                                                />
                                                <DateRangePicker
                                                    // className={"w-auto "}
                                                    label={t("auditRequest.date")}
                                                    style={{width: '100%'}}
                                                    datePickerMenu={{ 
                                                        firstDayOfWeek: "sunday",
                                                        disabled:{
                                                            afterDate: new Date()
                                                        }
                                                    }}
                                                    endYear={2030}
                                                    onSelectDateRange={handleDateRangeChange}
                                                    placeholder="Date filter"
                                                    selectedDateRange={selectedRange}
                                                    size="small"
                                                    startYear={1950}
                                                    showClearIcon={false}
                                                />
                                                <div className="d-flex justify-content-between mt-3">
                                                    <div style={{
                                                        fontSize: "12px",
                                                        fontWeight: "500",
                                                        display: "flex",
                                                        alignItems: "center"
                                                        }}>{`${(selectedStatusFilter && selectedRange) ? '2' : (selectedStatusFilter || selectedRange) ? '1' : '0'} ${t("auditRequest.filter_selected")}`}</div>
                                                    <div className="d-flex" style={{gap: ".5rem"}}>
                                                        <Button
                                                            onClick={()=>setToggleFilter(false)}
                                                            text={t("auditRequest.cancel_label")}
                                                            variant="tertiary"
                                                            className="filter-btn"
                                                            size="small"
                                                            style={{fontWeight: "bold"}}
                                                        />
                                                        <Button
                                                            onClick={handleApplyFilter}
                                                            text={t("auditRequest.apply_filter")}
                                                            variant="primary"
                                                            className="filter-btn"
                                                            size="small"
                                                        />
                                                    </div>
                                                </div>
                                            </Popover>
                                        </div>
                                    </div> 
                                    {!disableFilter && <div className="selected-filters d-flex mx-1">
                                        {selectedStatusFilterAfterApply?.[0]?.value && <div className="accountsAlign">
                                            <span className="endPointInfo mr-1" style={{fontSize: "9px"}}>{camelToTitle(selectedStatusFilterAfterApply?.[0]?.value)}</span>
                                        </div>}
                                        {selectedRangeAfterApply?.from && selectedRangeAfterApply?.to && <div className="accountsAlign">
                                            <span className="endPointInfo mr-1" style={{fontSize: "9px"}}>{`${formatDateMMDDYYY(selectedRangeAfterApply?.from)} - ${formatDateMMDDYYY(selectedRangeAfterApply?.to)}`}</span>
                                        </div>}
                                    </div>}                                 
                                    <Icon
                                        alt="alt value"
                                        className={"$color-icon-default request-refresh-btn" + (isRtl ? "mr-2" : "")}
                                        icon="refresh"
                                        data-tooltip-id="refresh-tooltip" data-tooltip-content="Refresh"
                                        size="small"
                                        onClick={() => disableFilter ? {} : handleRefresh()}
                                        style={{ alignItems: 'center', cursor: 'pointer', ...( disableFilter && {color: "var(--color-interaction-disabled)"}) }}
                                        disabled={disableFilter}
                                    />
                                    </> : null
                                }
                                
                            </div>
                            {/* {(shoudlShowDateAndStatusFilters || !shoudlShowDateAndStatusFilters) ?
                                <div className="mt-md-0 mt-2">
                                </div> : null

                            } */}
                            {((shoudlShowDateAndStatusFilters || !shoudlShowDateAndStatusFilters) && showRequestSearch && !(state?.type && state?.value)) ?
                            <Search
                                className="w-100"
                                isClearable={!(state?.type && state?.value) && searchNum.length>0}
                                menuPosition="bottom-right"
                                onClear={() => handleRefresh(true)}
                                onUpdate={(e) => setSearchNum(e)}
                                onSelectOption={function oFe() { }}
                                onSearch={() => { handleSearch() }}
                                placeholderText={t("auditRequest.search_for_another_request")}
                                size="small"
                                delay={0}
                                style={{}}
                                value={searchNum ?? ""}
                            />      
                                : null
                            }
                        </div>
                    </div>
                </div>
            </>
        );
    };

    const onClickCopynumber = () => {
        // if (requestData?.requestId) {
        //     navigator.clipboard.writeText(requestData.requestId.toString()).then(() => {
        setCopyButtonText("Copied");
        //     }).catch(err => {
        //         console.error("Failed to copy text: ", err);
        //     });
        // }
    };

    const getBorderColor = (status) => {
        const statusLower = normalizeStatusValue(status);
        switch (statusLower) {
            case "in progress":
                return "#F1CA18";
            case "modify":
                return "#0662C4";
            case "new":
                return "#027C06";
            case "mypam_create_safe":
                return "#027C06";
            case "create safe":
                return "#027C06";
            case "mypam_update_safe":
                return "#027C06";
             case "update safe":
                return "#027C06";
            case "disabled":
                return "#C12C01";
            case "disable":
                return "#C12C01";
            case "reactive":
                return "#D6AC16";
            case "reactivate":
                return "#D6AC16";       
            default:
                return "#E0E0E0";
        }
    };
    const getRequestTypeBackgroundColor = (status) => {
        const statusLower = normalizeStatusValue(status);
        switch (statusLower) {
            case "in progress":
                return "#F1CA18";
            case "timed out":
                return "#F1CA18";
            case "modify":
                return "#F5F9FF";
            case "rejected":
                return "#F5F9FF";
            case "new":
                return "#EEFEEC";
            case "create safe request":
                return "#EEFEEC";
            case "create safe":
                return "#EEFEEC";
            case "mypam_update_safe":
                return "#EEFEEC";
            case "update safe":
                return "#EEFEEC";
            case "mypam_safe_access":
                return "#EEFEEC";
            case "safe access":
                return "#EEFEEC";
            case "disabled":
                return "#FFF6F4";
            case "cancelled":
                return "#FFF6F4";
            case "disable":
                return "#FFF6F4";
            case "reactive":
                return "#FFF9D6";
            case "reactivate":
                return "#FFF9D6";
            case "complete":
                return "green";
            case "approved":
                return "green";
            case "completed":
                return "green";
            case "submitted":
                return "orange";
            case "mypam_create_safe":
                return "#EEFEEC";
            case "failed":
                return "#C12C01";
            default:
                return "#E0E0E0";
        }
    };

    const getBackgroundColor = (status) => {
        const statusLower = status?.toLowerCase();
        switch (statusLower) {
            case "in progress":
                return "#F1CA18";
            case "in_progress":
                return "#F1CA18";
            case "timed out":
                return "#F1CA18";
            case "modify":
                return "#F5F9FF";
            case "new":
                return "#EEFEEC";
            case "disabled":
                return "#FFF6F4";
            case "disable":
                return "#FFF6F4";
            case "reactive":
                return "#FFF9D6";
            case "reactivate":
                return "#FFF9D6";
            case "complete":
                return "green";
            case "approved":
                return "green";
            case "completed":
                return "green";
            case "submitted":
                return "orange";
            case "failed":
                return "#C12C01";
            case "rejected":
                return "#C12C01";
            case "cancelled":
                return "orange";
            default:
                return "#E0E0E0";
        }
    };

    const openGCRStatus = (path) => {
        const w = window.screen.width * .9;
        const h = window.screen.height * .9;
        const l = window.screen.width * .05;
        const t = window.screen.height * .05;
        window.open(path, "_blank", `width=${w},height=${h},left=${l},top=${t}`);
    }


    function getAppName(appString) {
        if (appString.includes("key=task")) {
            const match = appString.match(/key=task\.([^}]+?)\.name/);
            return match ? normalize(match[1]) : normalize(appString);
        }
        return normalize(appString);
    }

    function normalize(str) {
        return str
            ?.toLowerCase()
            .replace(/[^a-z0-9]/gi, "")
            .trim();
    }


    function similarity(s1, s2) {
        const m = s1.length, n = s2.length;
        const dp = Array.from({ length: m + 1 }, () => Array(n + 1).fill(0));

        for (let i = 0; i <= m; i++) dp[i][0] = i;
        for (let j = 0; j <= n; j++) dp[0][j] = j;

        for (let i = 1; i <= m; i++) {
            for (let j = 1; j <= n; j++) {
                dp[i][j] = s1[i - 1] === s2[j - 1]
                    ? dp[i - 1][j - 1]
                    : 1 + Math.min(dp[i - 1][j - 1], dp[i - 1][j], dp[i][j - 1]);
            }
        }

        const distance = dp[m][n];
        return 1 - distance / Math.max(m, n);
    }

    function getMatchedObject(workItemsMap, selectedAppName) {
        if(workItemsMap == null || selectedAppName == null) return null;
        const cleanSelected = normalize(selectedAppName);

        for (const key of Object.keys(workItemsMap)) {
            const cleanKey = getAppName(key);
            console.log("Comparing:", cleanKey, "with", cleanSelected);
            if (cleanKey.includes(cleanSelected) || cleanSelected.includes(cleanKey) || similarity(cleanKey, cleanSelected) >= 0.9) {
                return {
                    key,
                    object: workItemsMap[key]
                };
            }
        }

        return null;
    }

    const EntraAuditRequestBodyScreen = ({ auditRequestData }) => {
        return (
            <>
                {auditRequestData && (
                    <div className="audit-request-active">
                        <div style={{cursor: "pointer"}} >
                            <div className="d-flex justify-content-between">
                                <div className="d-flex">
                                    <div
                                        style={{
                                            color: "#2d2d2d",
                                            fontSize: `${isMobile ? "0.7rem" : "14px"}`,
                                            fontFamily: "Inter",
                                            fontWeight: 600,
                                            lineHeight: "18px",
                                            whiteSpace: "nowrap",
                                            marginRight: isRtl ? "0px" : "4px",
                                            marginLeft: isRtl ? "4px" : "0px",
                                        }}
                                    >
                                        {t("auditRequest.req") + " #" + auditRequestData?.requestNumber}
                                    </div>
                                    {/* <div
                                        data-property-1="Modified"
                                        style={{
                                            justifyContent: "flex-start",
                                            alignItems: "flex-start",
                                            display: "inline-flex",
                                        }}
                                    >
                                        <div
                                            data-show-leading-icon="false"
                                            data-show-trailing-icon="false"
                                            data-size="Small"
                                            data-state="Default"
                                            data-style="Orange"
                                            data-type="Outlined"
                                            style={{
                                                height: `${isMobile ? '18px' : "18px"}`,
                                                padding: "2px 4px",
                                                overflow: "hidden",
                                                borderRadius: "4px",
                                                backgroundColor: getRequestTypeBackgroundColor(getRequestBadgeKey(auditRequestData?.requestType)),
                                                border: `1px solid ${getBorderColor(getRequestBadgeKey(auditRequestData?.requestType))}`,
                                                outlineOffset: "-1px",
                                                justifyContent: "flex-start",
                                                alignItems: "center",
                                                gap: "2px",
                                                display: "flex",
                                            }}
                                        >
                                            <div
                                                style={{
                                                    color: "var(--Tokens-Text-Primary, #3A3A3A)",
                                                    fontSize: `${isMobile ? '0.5rem' : "9px"}`,
                                                    fontFamily: "Inter",
                                                    fontWeight: 400,
                                                    lineHeight: "18px",
                                                    whiteSpace: "nowrap",
                                                }}
                                            >
                                                {formatRequestTypeLabel(auditRequestData?.requestType) || "Reactive"}
                                            </div>
                                        </div>
                                    </div> */}
                                </div>
                                <div
                                    className="request-status-tag"
                                    style={{
                                        height: `${isMobile ? '20px' : "19px"}`,
                                        padding: "2px 8px",
                                        borderRadius: "4px",
                                        backgroundColor: getBackgroundColor(auditRequestData?.overAllStatus || auditRequestData?.status),
                                        color: isInProgressStatus(auditRequestData?.overAllStatus || auditRequestData?.status) ? "#000000" : '#ffffff',
                                        fontFamily: "Inter",
                                        fontWeight: 400,
                                        lineHeight: "18px",
                                        whiteSpace: "nowrap",
                                        display: "inline-flex",
                                        alignItems: "center",
                                        justifyContent: "center",
                                        fontSize: `${isMobile ? '0.6rem' : "11px"}`,
                                    }}
                                >
                                    {normalizeToTitle(auditRequestData?.overAllStatus || auditRequestData?.status)}
                                </div>
                            </div>
                            <div className="d-flex justify-content-between">
                                <div className="details-content-group d-flex">
                                    <small style={{ display: "flex", alignItems: "center", gap: "4px", color: "#4B4B4B", fontSize: '10px', fontWeight: 400 }}
                                    >{auditRequestData?.applicationName ? formatApplicationLabel(auditRequestData?.applicationName)
                                        : t("auditRequest.not_applicable")} <Icon
                                            alt="alt value"
                                            size="small"
                                            style={{ display: 'unset' }}
                                        /></small>
                                </div>
                                {/* <div
                                    style={{
                                        textAlign: "right",
                                        display: "flex",
                                        justifyContent: "flex-end",
                                        gap: "4px",
                                        marginTop: "5px"
                                    }}
                                >
                                    <span
                                        style={{
                                            color: "var(--Tokens-Text-Secondary, #616161)",
                                            fontSize: "10px",
                                            fontFamily: "Inter",
                                            fontWeight: 400,
                                            lineHeight: "20px",
                                            whiteSpace: "nowrap",
                                        }}
                                    >
                                        {(() => {
                                            try {
                                                const date = new Intl.DateTimeFormat("en-US", {
                                                    day: "2-digit",
                                                    month: "2-digit",
                                                    year: "numeric",
                                                    // hour: '2-digit',
                                                    // minute: '2-digit',
                                                    // hour12: true
                                                }).format(
                                                    new Date(
                                                        auditRequestData?.dateRequested)
                                                );
                                                return date
                                            } catch (error) {
                                                return t("auditRequest.not_applicable");
                                            }
                                        })()}
                                    </span>
                                </div> */}
                            </div>
                        </div>
                    </div>
                )}
            </>
        );

    };

    const AuditRequestBodyScreen = ({ index, auditRequestData }) => {
        return (
            <>
                {auditRequestData && (
                    <div key={index} className={auditRequestData?.request === requestId ? "audit-request-active" : "audit-request-list"}>
                        <div onClick={() => { onClickToExpandRequest(auditRequestData.request, index)}} style={{cursor: "pointer"}} >
                            <div className="d-flex justify-content-between">
                                <div className="d-flex">
                                    <div
                                        style={{
                                            color: "#2d2d2d",
                                            fontSize: `${isMobile ? "0.7rem" : "14px"}`,
                                            fontFamily: "Inter",
                                            fontWeight: 600,
                                            lineHeight: "18px",
                                            whiteSpace: "nowrap",
                                            marginRight: isRtl ? "0px" : "4px",
                                            marginLeft: isRtl ? "4px" : "0px",
                                        }}
                                    >
                                        {t("auditRequest.req") + " #" + auditRequestData?.request}
                                    </div>
                                    <div
                                        data-property-1="Modified"
                                        style={{
                                            justifyContent: "flex-start",
                                            alignItems: "flex-start",
                                            display: "inline-flex",
                                        }}
                                    >
                                        <div
                                            data-show-leading-icon="false"
                                            data-show-trailing-icon="false"
                                            data-size="Small"
                                            data-state="Default"
                                            data-style="Orange"
                                            data-type="Outlined"
                                            style={{
                                                height: `${isMobile ? '18px' : "18px"}`,
                                                padding: "2px 4px",
                                                overflow: "hidden",
                                                borderRadius: "4px",
                                                backgroundColor: getRequestTypeBackgroundColor(getRequestBadgeKey(auditRequestData?.requestType)),
                                                border: `1px solid ${getBorderColor(getRequestBadgeKey(auditRequestData?.requestType))}`,
                                                outlineOffset: "-1px",
                                                justifyContent: "flex-start",
                                                alignItems: "center",
                                                gap: "2px",
                                                display: "flex",
                                            }}
                                        >
                                            <div
                                                style={{
                                                    color: "var(--Tokens-Text-Primary, #3A3A3A)",
                                                    fontSize: `${isMobile ? '0.5rem' : "9px"}`,
                                                    fontFamily: "Inter",
                                                    fontWeight: 400,
                                                    lineHeight: "18px",
                                                    whiteSpace: "nowrap",
                                                }}
                                            >
                                                {formatRequestTypeLabel(auditRequestData?.requestType) || "Reactive"}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div
                                    className="request-status-tag"
                                    style={{
                                        height: `${isMobile ? '20px' : "19px"}`,
                                        padding: "2px 8px",
                                        borderRadius: "4px",
                                        backgroundColor: getBackgroundColor( auditRequestData?.overAllStatus || auditRequestData?.status),
                                        color: isInProgressStatus(auditRequestData?.overAllStatus || auditRequestData?.status) ? "#000000" : '#ffffff',
                                        fontFamily: "Inter",
                                        fontWeight: 400,
                                        lineHeight: "18px",
                                        whiteSpace: "nowrap",
                                        display: "inline-flex",
                                        alignItems: "center",
                                        justifyContent: "center",
                                        fontSize: `${isMobile ? '0.6rem' : "11px"}`,
                                    }}
                                >
                                    {normalizeToTitle(auditRequestData?.overAllStatus || auditRequestData?.status)}
                                </div>
                            </div>
                            <div className="d-flex justify-content-between">
                                {(auditRequestData?.bundledRequest && auditRequestData?.bundledRequest.length == 0) && (
                                    <div className="details-content-group d-flex">
                                        <small className={`${truncatedTooltip[index] ? "truncated" : ""}`} style={{ display: "flex", alignItems: "center", gap: "4px", color: "#4B4B4B", fontSize: '10px', fontWeight: 400 }}
                                        {...(truncatedTooltip[index] && {"data-tooltip-id":auditRequestData?.applicationsRequested, "data-tooltip-content":auditRequestData?.applicationsRequested ? formatApplicationLabel(auditRequestData?.applicationsRequested)
                                            : t("auditRequest.not_applicable")})}
                                        >{auditRequestData?.applicationsRequested ? formatApplicationLabel(auditRequestData?.applicationsRequested)
                                            : t("auditRequest.not_applicable")} <Icon
                                                alt="alt value"
                                                size="small"
                                                style={{ display: 'unset' }}
                                            /></small>
                                            <Tooltip id={auditRequestData?.applicationsRequested} place="top" style={{ maxWidth: '200px' }} type="light" effect="solid" />
                                    </div>
                                )}
                                {(auditRequestData?.bundledRequest && auditRequestData?.bundledRequest.length > 0) && (
                                    <div className="bundled-dropdown">
                                        <button
                                            className="bundled-dropdown-toggle"
                                            onClick={(e) => handleAppNameToggle(0, e)}
                                        >
                                            <Icon
                                                alt="alt value"
                                                icon="layers"
                                                size="small"
                                                style={{ display: 'unset' }}
                                            />
                                            <span className="count">{auditRequestData?.bundledRequest.length}</span>
                                            <span className="title">{t("auditRequest.bundled_label")}</span>
                                            {/* <span className={`caret ${open ? "up" : "down"}`}></span> */}
                                        </button>                                        
                                    </div>
                                )}
                                <div
                                    style={{
                                        textAlign: "right",
                                        display: "flex",
                                        justifyContent: "flex-end",
                                        gap: "4px",
                                        marginTop: "5px"
                                    }}
                                >
                                    <span
                                        style={{
                                            color: "var(--Tokens-Text-Secondary, #616161)",
                                            fontSize: "10px",
                                            fontFamily: "Inter",
                                            fontWeight: 400,
                                            lineHeight: "20px",
                                            whiteSpace: "nowrap",
                                        }}
                                    >
                                        {(() => {
                                            try {
                                                const date = new Intl.DateTimeFormat("en-US", {
                                                    day: "2-digit",
                                                    month: "2-digit",
                                                    year: "numeric",
                                                    // hour: '2-digit',
                                                    // minute: '2-digit',
                                                    // hour12: true
                                                }).format(
                                                    new Date(
                                                        auditRequestData?.dateRequested)
                                                );
                                                return date
                                            } catch (error) {
                                                return t("auditRequest.not_applicable");
                                            }
                                        })()}
                                    </span>
                                </div>
                            </div>
                        </div>
                    </div>
                )}
            </>
        );

    };

    const closeModal = () => {
        setisRequestSelected(false);
    }

    const handleScroll = async(e) => {
        const currentScrollTop = e.target.scrollTop;
        const isScrollingDown = currentScrollTop > lastScrollTopRef.current;

        const threshold = 2;
        const scrollBottom =
        e.target.scrollHeight - currentScrollTop - e.target.clientHeight;

        if (!hasMoreRef.current || isFetchingRef.current) {
            return;
        }

        if (isScrollingDown && scrollBottom <= threshold && !isFetchingRef.current) {
            isFetchingRef.current = true;
            const data = JSON.parse(localStorage.getItem("okta-token-storage"));
            await fetchAuditRequest((state?.type === "gpid" || state?.type === "GPID") ? state?.value : state?.type !== 'requestNumber' ? data?.accessToken?.claims?.gpid : state?.value, false, false, pageIndex + 1, true);
            setPageIndex((prev)=>prev+1);
            isFetchingRef.current = false;
        }

        lastScrollTopRef.current = currentScrollTop;
    };
    
    const setSelectedRequest = (e) => {
        setIsShowAllStep((prev) => {
            prev = !prev;
        });
        setAppName(e?.applicationsRequested || "");
        setRequestId(e?.request || "");
        if (auditRequestData?.auditApprovalData &&
            Object.keys(auditRequestData.auditApprovalData).length > 0) {
            const appRequestedName = e?.applicationsRequested || "";
            const match = getMatchedObject(
                auditRequestData?.auditApprovalData?.workItemsMap,
                appRequestedName
            );

            if (match) {
                console.log("Matched Key:", match?.key);
                console.log("Matched Object:", match?.object);

                setApprovalList(match?.object);
            } else {
                setApprovalList([]);
            }

            console.log("Approval List:", match?.object);

            const lastState = match?.object?.[match?.object?.length - 1]?.state;

            lastStepApproved = lastState?.toLowerCase() === "approved";

            const steps = !lastStepApproved && !isShowAllStep
                ? match?.object?.slice(-2)
                : match?.object;
            setVisibleSteps(steps);
            startIndex = match?.object?.length - steps?.length;

        }
        setBundledRequestSelectedAppId(e);
        setIsOpenAppName(false);

        let filteredData = auditRequestData?.auditApprovalData;
        const requestedAppName = e?.applicationsRequested;
        filteredData = auditRequestData?.auditApprovalData?.workItemsMap?.[requestedAppName] || [];
        let approverDetailsMap = auditRequestData?.auditApprovalData?.approverDetailsMap?.[requestedAppName] || [];
        const invalidValues = ["", "null", null, undefined, "undefined"];
        const transformedData = filteredData.map(item => ({
            approverQueue: invalidValues.includes(item?.queueName) ? t("auditRequest.not_applicable") : item?.queueName,
            arrivedInQueue: invalidValues.includes(item?.dateArrived) ? t("auditRequest.not_applicable") : item?.dateArrived,
            status: invalidValues.includes(item?.status) ? t("auditRequest.not_applicable") : item?.status,
            dateCompleted: invalidValues.includes(item?.dateApproved) ? t("auditRequest.not_applicable") : item?.dateApproved,
            approver: invalidValues.includes(item?.approverGpid) ? t("auditRequest.not_applicable") : item?.approverGpid,
            followUp: auditRequestData?.auditApprovalData?.isCancelled ? auditRequestData?.auditApprovalData?.isAppFollowupEnabled && item.followupAvailable : item.followupAvailable,
            allFollowupTsp: item.allFollowupTsp,
        }));

        const transformedRoutingData = mapApproverDetails(approverDetailsMap, t("auditRequest.not_applicable"));
        setRoutingList(transformedRoutingData);
        setApproverQueue(transformedData);
        setApproverQueueList(transformedData);
 
    }

    const getDataByStatus = (requestedAppName, status, auditRequestData, index) => {
        let map = {};
        if(index){
             map =
                index === 2
                    ? auditRequestData?.finalAttributeMap
                    : auditRequestData?.tempAttributeMap;
        }else{
             map =
                isCompletedStatus(status)
                    ? auditRequestData?.finalAttributeMap
                    : auditRequestData?.tempAttributeMap;
        }

        const appNames = auditRequestData?.distinctAppsList || [];
        const applicationName = requestedAppName ? requestedAppName : appNames[0];
        const appNameMapSecondary = requestedAppName ? requestedAppName : Object.values(auditRequestData?.appNameMap)[0];
        const auditAdditionalData = map?.[applicationName || appNameMapSecondary] || {};


        if (!auditAdditionalData || Object.keys(auditAdditionalData).length === 0) {
            setRequestDetail([]);
            return;
        }

        const keyValueArray = Object.entries(auditAdditionalData).map(([key, value]) => ({
            key,
            value
        }));

        console.log("UPDATING UI WITH:", keyValueArray);

        const isGuestRequest = (auditRequestData?.requestNumber?.includes?.('IAMC') && !['MYPAM_CREATE_SAFE', 'MYPAM_SAFE_ACCESS', 'MYPAM_UPDATE_SAFE', 'ENTRA_APP_REGISTRATION', 'APPLICATION_RETIREMENT', 'Create Safe', 'Safe Access', 'Update Safe'].includes(auditRequestData?.requestType))

        setRequestDetail( isGuestRequest ? convertIndexedObject(auditAdditionalData) : [...keyValueArray]);
    };

    const getSectionHeight = () => {
        if(isMobile && isLandscape){
            return 'auto';
        }
        else if(auditRequestData?.bundledRequest?.length > 0 && (auditRequestData?.auditApprovalData?.isFollowupEnabled || auditRequestData?.auditApprovalData?.isRequestCancellable)){
            return 'calc(100dvh - 460px)';
        }
        else if(auditRequestData?.bundledRequest?.length > 0){
            return 'calc(100dvh - 472px)';
        }
        else if(auditRequestData?.auditApprovalData?.isFollowupEnabled || auditRequestData?.auditApprovalData?.isRequestCancellable){
            return 'calc(100dvh - 460px)';
        }
        else{
            return 'calc(100dvh - 412px)';
        }
    }

    const renderAuditRequestDetail = () => {
        const isSSORequest = (auditRequestData?.requestType && auditRequestData?.requestType?.toLowerCase?.()?.includes?.('sso')) || 
                             (auditRequestData?.auditApprovalData?.requestType && auditRequestData?.auditApprovalData?.requestType?.toLowerCase?.()?.includes?.('sso')) || 
                             (auditRequestData?.applicationsRequested && auditRequestData?.applicationsRequested?.toLowerCase?.()?.includes?.('sso'));
        const ssoProvisioningData = auditRequestData?.auditApprovalData?.ssoProvisioningData;
        const provisioningOverallStatus = `${ssoProvisioningData?.['Provisioning Summary']?.['Overall Status'] || ''}`.trim().toLowerCase();
        const hasProvisioningPayload = !!(ssoProvisioningData && (
            Object.keys(ssoProvisioningData).length > 0 ||
            ssoProvisioningData?.request ||
            Array.isArray(ssoProvisioningData?.provisioningActions) && ssoProvisioningData.provisioningActions.length > 0 ||
            ssoProvisioningData?.provisionedDetails && Object.keys(ssoProvisioningData.provisionedDetails).length > 0
        ));
        const hasSSOProvisioningData = !!(ssoProvisioningData && (
            hasProvisioningPayload && (
                provisioningOverallStatus !== 'unknown' && provisioningOverallStatus !== '' ||
                (Array.isArray(ssoProvisioningData.provisioningActions) && ssoProvisioningData.provisioningActions.length > 0) ||
                (ssoProvisioningData.provisionedDetails && Object.keys(ssoProvisioningData.provisionedDetails).length > 0) ||
                (ssoProvisioningData.request && Object.keys(ssoProvisioningData.request).length > 0)
            )
        ));
        const isCancelledRequest = normalizeStatusValue(auditRequestData?.overAllStatus || auditRequestData?.status) === 'cancelled';
        const shouldShowProvisionDetails = isSSORequest && !isCancelledRequest && (hasSSOProvisioningData || (isCompletedStatus(auditRequestData?.overAllStatus || auditRequestData?.status) && hasProvisioningPayload));
        const isGuestRequest = !isSSORequest && auditRequestData?.auditApprovalData?.requestNumber?.includes?.('IAMC') && !['MYPAM_CREATE_SAFE', 'MYPAM_SAFE_ACCESS', 'MYPAM_UPDATE_SAFE', 'ENTRA_APP_REGISTRATION', 'APPLICATION_RETIREMENT', 'Create Safe', 'Safe Access', 'Update Safe'].includes(auditRequestData?.auditApprovalData?.requestType);
        return <section className={"request_details_section pr-0 pl-0 " + (isMobile ? "col-12" : "col-9") } style={{ 
            // height: (auditRequestData?.auditApprovalData?.isFollowupEnabled || auditRequestData?.auditApprovalData?.isRequestCancellable) ? 'calc(100vh - 177px)' : 'calc(100vh - 220px)', maxHeight: (auditRequestData?.auditApprovalData?.isFollowupEnabled || auditRequestData?.auditApprovalData?.isRequestCancellable) ? 'calc(100vh - 177px)' : 'calc(100vh - 220px)', 
            flexShrink: "1"}}>
            {isRequestSelected ? 
                (
                <>
                    <>
                        <div className="request_details_header px-0">
                            <div className={"contentgroup-2 " + (isMobile ? "" : "pl-3")}>
                                <div className="title-content-group-2">
                                    <div
                                        data-show-leading-icon="false"
                                        data-show-trailing-icon="false"
                                        data-size="Medium"
                                        data-state="Default"
                                        data-style="Blue"
                                        data-type="Faded"
                                        style={{
                                            height: "24px",                                                                                                     
                                            overflow: "hidden",
                                            justifyContent: "flex-start",
                                            alignItems: "center",                                                    
                                            display: "inline-flex",
                                            marginRight: isRtl ? "0px" : "8px",
                                        }}
                                    >
                                        <div
                                            style={{
                                                color: "var(--Tokens-Text-High-contrast, black)",
                                                fontSize: "14px",
                                                fontFamily: "Inter",
                                                fontWeight: 700,
                                                lineHeight: "18px",
                                                whiteSpace: "nowrap",
                                            }}
                                        >
                                            {t("auditRequest.req") + " #" + auditRequestData?.request}
                                        </div>
                                    </div>{" "}
                                    <div
                                        data-property-1="Modified"
                                        style={{
                                            justifyContent: "flex-start",
                                            alignItems: "flex-start",
                                            display: "inline-flex",
                                        }}
                                    >
                                        <div
                                            data-show-leading-icon="false"
                                            data-show-trailing-icon="false"
                                            data-size="Medium"
                                            data-state="Default"
                                            data-style="Orange"
                                            data-type="Outlined"
                                            style={{
                                                height: `${isMobile ? '16px' : "18px"}`,
                                                padding: "2px 8px",
                                                overflow: "hidden",
                                                borderRadius: "4px",
                                                backgroundColor: getRequestTypeBackgroundColor(getRequestBadgeKey(auditRequestData?.requestType)),
                                                border: `1px solid ${getBorderColor(getRequestBadgeKey(auditRequestData?.requestType))}`,
                                                outlineOffset: "-1px",
                                                justifyContent: "flex-start",
                                                alignItems: "center",
                                                gap: "2px",
                                                display: "flex",
                                            }}
                                        >
                                            <div
                                                style={{
                                                    color: "var(--Tokens-Text-Primary, #3A3A3A)",
                                                    fontSize: `${isMobile ? '0.7rem' : "10px"}`,
                                                    fontFamily: "Inter",
                                                    fontWeight: 400,
                                                    lineHeight: "18px",
                                                    whiteSpace: "nowrap",
                                                }}
                                            >                                            
                                                {formatRequestTypeLabel(auditRequestData?.requestType) || "Reactive"}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                {(auditRequestData?.bundledRequest && auditRequestData?.bundledRequest.length == 0) && (
                                    <div className="details-content-group">
                                        <small style={{ display: "flex", alignItems: "center", gap: "4px", color: "#4B4B4B", fontWeight: 400 }}
                                        >{auditRequestData?.applicationsRequested ? formatApplicationLabel(auditRequestData?.applicationsRequested)
                                            : t("auditRequest.not_applicable")} <Icon
                                                alt="alt value"
                                                size="small"
                                                style={{ display: 'unset' }}
                                            /></small>
                                    </div>
                                )}
                                {(auditRequestData?.bundledRequest && auditRequestData?.bundledRequest.length > 0) && (
                                        <div className="bundled-dropdown">
                                            <button
                                                className="bundled-dropdown-toggle"
                                                onClick={(e) => handleAppNameToggle(0, e)}
                                            >
                                                <Icon
                                                    alt="alt value"
                                                    icon="layers"
                                                    size="small"
                                                    style={{ display: 'unset' }}
                                                />
                                                <span className="count">{auditRequestData?.bundledRequest.length}</span>
                                                <span className="title">{t("auditRequest.bundled_label")}</span>
                                            </button>
                                        </div>
                                    )}
                            </div>
                            <div className={"rightaccessory " + (isMobile ? " pt-2" : "pr-3") + (isRtl ? "" : " "   )}>
                                <div className="tagdueyellow">                                
                                    <div
                                        className="request-status-tag"
                                        style={{
                                            height: `${isMobile ? '20px' : "24px"}`,
                                            padding: "2px 8px",
                                            borderRadius: "4px",
                                            backgroundColor: getBackgroundColor(
                                                auditRequestData?.overAllStatus || auditRequestData?.status),
                                            // border: `1px solid ${getBorderColor(auditRequestData?.status)}`,
                                            color: isInProgressStatus(auditRequestData?.overAllStatus || auditRequestData?.status) ? "#000000" : '#ffffff',
                                            fontSize: `${isMobile ? '0.7rem' : "12px"}`,
                                            fontFamily: "Inter",
                                            fontWeight: 400,
                                            lineHeight: "18px",
                                            whiteSpace: "nowrap",
                                            display: "inline-flex",
                                            alignItems: "center",
                                            justifyContent: "center",
                                        }}
                                    >
                                        {normalizeToTitle(auditRequestData?.overAllStatus || auditRequestData?.status)}
                                    </div>
                                </div>

                                <div
                                    style={{
                                        textAlign: "right",
                                        display: "flex",
                                        justifyContent: "flex-end",
                                        gap: "4px",
                                        marginTop: "5px"
                                    }}
                                >
                                    <span
                                        style={{
                                            color: "var(--Tokens-Text-Secondary, #616161)",
                                            fontSize: "12px",
                                            fontFamily: "Inter",
                                            fontWeight: 400,
                                            lineHeight: "20px",
                                            whiteSpace: "nowrap",
                                        }}
                                    >
                                        {t("auditRequest.requested_on")}:
                                    </span>
                                    <span
                                        style={{
                                            color: "var(--Tokens-Text-Secondary, #616161)",
                                            fontSize: "12px",
                                            fontFamily: "Inter",
                                            fontWeight: 400,
                                            lineHeight: "20px",
                                            whiteSpace: "nowrap",
                                        }}
                                    >
                                        {(() => {
                                            try {
                                                return new Intl.DateTimeFormat("en-US", {
                                                    day: "2-digit",
                                                    month: "2-digit",
                                                    year: "numeric",
                                                    // hour: "2-digit",
                                                    // minute: "2-digit",
                                                    // hour12: true,
                                                }).format( new Date( auditRequestData?.dateRequested));
                                            } catch (error) {
                                                return t("auditRequest.not_applicable");
                                            }
                                        })()}
                                    </span>
                                </div>
                            </div>
                        </div>
                        {(auditRequestData?.auditApprovalData?.subjectGpid || auditRequestData?.auditApprovalData?.initiatorGpid) ?
                        <>
                            <div style={{ display: "inline-flex", width: '100%', maxHeight: isMobile ? 'auto' : "56px", flexDirection: isMobile ? 'row' : "column", alignItems: "flex-start"}}>
                                {(auditRequestData?.auditApprovalData?.subjectGpid || auditRequestData?.auditApprovalData?.initiatorGpid) ? 
                                <div
                                    style={{
                                        padding: "0px 8px",
                                        borderRadius: "8px",                                    
                                        display: isMobile ? "contents" : "inline-flex",
                                        justifyContent: "space-between",
                                        alignItems: "flex-start",
                                        width: '100%',
                                        // flexWrap: "wrap",
                                        maxHeight: isMobile ? 'auto' : "56px"
                                    }}>
                                        {
                                            auditRequestData?.applicationsRequested?.toLowerCase?.()?.includes?.('guest') ? null :
                                            <div
                                                style={{
                                                    margin: isMobile ? "10px 0px" : "8px 10px",
                                                    display: "inline-flex",
                                                    flexDirection: "column",
                                                    alignItems: "flex-start",
                                                    width: "48%",
                                                    maxWidth: "48%",
                                                    // wordBreak: "break-word",
                                                }}
                                            >
                                                <div
                                                    style={{
                                                        color: "var(--Tokens-Text-Secondary, #2d2d2d)",
                                                        fontSize: isMobile ? "13px" : "14px",
                                                        fontFamily: "Inter",
                                                        fontWeight: 500,
                                                        lineHeight: "20px",
                                                    }}
                                                >
                                                    {t("auditRequest.requested_for")}:
                                                </div>
                                                <div
                                                    className="requested-for"
                                                    style={{
                                                        color: "var(--Tokens-Text-Secondary, #2d2d2d)",
                                                        fontSize: isMobile ? "12px" :"13px",
                                                        fontFamily: "Inter",
                                                        fontWeight: 700,
                                                        lineHeight: "20px",                                                        
                                                        width: "100%",
                                                        maxWidth: "100%",
                                                        whiteSpace: isMobile ? "break-spaces" : "nowrap",
                                                        textOverflow: "ellipsis",
                                                        overflow: "hidden"
                                                    }}
                                                    data-tooltip-id={auditRequestData?.auditApprovalData?.subjectGpid} data-tooltip-content={auditRequestData?.auditApprovalData?.subjectGpid ??
                                                        t("auditRequest.not_applicable")}
                                                >
                                                    {auditRequestData?.auditApprovalData?.subjectGpid ??
                                                        t("auditRequest.not_applicable")}
                                                </div>
                                                <Tooltip id={auditRequestData?.auditApprovalData?.subjectGpid} place="top" style={{ maxWidth: '200px' }} type="light" effect="solid" />
                                            </div>
                                        }
                                    <div
                                        style={{
                                            margin: isMobile ? "10px 0px" : "8px 10px",
                                            display: "inline-flex",
                                            flexDirection: "column",
                                            alignItems: "flex-start",
                                            width: "48%",
                                            maxWidth: "48%",
                                            // wordBreak: "break-word",
                                        }}
                                    >
                                        <div
                                            style={{
                                                color: "var(--Tokens-Text-Secondary, #2d2d2d)",
                                                fontSize: isMobile ? "13px" :"14px",
                                                fontFamily: "Inter",
                                                fontWeight: 500,
                                                lineHeight: "20px",
                                            }}
                                        >
                                            {t("auditRequest.requested_by")}:
                                        </div>
                                        <div
                                            className="requested-by"
                                            style={{
                                                color: "var(--Tokens-Text-Secondary, #2d2d2d)",
                                                fontSize: isMobile ? "12px" :"13px",
                                                fontFamily: "Inter",
                                                fontWeight: 700,
                                                lineHeight: "20px",                                                        
                                                width: "100%",
                                                maxWidth: "100%",
                                                textOverflow: "ellipsis",
                                                whiteSpace: isMobile ? "break-spaces" : "nowrap",
                                                overflow: "hidden"
                                            }}
                                            data-tooltip-id={auditRequestData?.auditApprovalData?.initiatorGpid} data-tooltip-content={auditRequestData?.auditApprovalData?.initiatorGpid ??
                                                t("auditRequest.not_applicable")}
                                        >
                                            {auditRequestData?.auditApprovalData?.initiatorGpid ??
                                                t("auditRequest.not_applicable")}
                                        </div>
                                        <Tooltip id={auditRequestData?.auditApprovalData?.initiatorGpid} place="top" style={{ maxWidth: '200px' }} type="light" effect="solid" />
                                    </div>
                                </div>
                                    : <div style={{ textAlign: "center", color: "red", marginTop: "10px", marginLeft: "auto", marginRight: "auto" }}>
                                            {isLoading ? null : t("auditRequest.no_data_found_label")}
                                    </div>
                                }
                                
                            </div>
                            <div style={{border: auditRequestData?.bundledRequest && auditRequestData?.bundledRequest.length > 0 ? 'solid 1px #D8E7FB' : 'none', borderRadius: '8px', margin: isMobile ? '0px' : '0px 16px', flexGrow: '1'}}>
                                {(auditRequestData?.bundledRequest && auditRequestData?.bundledRequest.length > 0) && (
                                    <>
                                        <div className="bundled-requests-section">
                                            <div className="d-flex" style={{alignItems: "center", gap: "8px"}}>
                                                <Icon
                                                    alt="alt value"
                                                    className="$color-icon-default"
                                                    style={{margin: 'auto', color: '#0755AA'}}
                                                    icon="info"
                                                    size="medium"
                                                />
                                                <div className="bundled-request-info">{t("RequestNewAccessForOthers.bundled_info")}</div>
                                            </div>
                                            <div>
                                                {(auditRequestData?.bundledRequest && auditRequestData?.bundledRequest.length > 0) && (
                                                    <div className="bundled-dropdown">
                                                        <button
                                                            className="bundled-dropdown-toggle"
                                                            onClick={(e) => { e.stopPropagation(); setIsOpenAppName(!isOpenAppName); }}
                                                        >
                                                            <span className="title">{bundledRequestSelectedAppId?.applicationsRequested}</span>
                                                            <span className={`caret ${isOpenAppName ? "up" : "down"}`}></span>
                                                        </button>
                                                        {isOpenAppName && (
                                                            <div className="bundled-dropdown-menu">
                                                                {auditRequestData?.bundledRequest?.map((app, i) => (
                                                                    <div key={i} className={`bundled-dropdown-item ${appName == app.applicationsRequested ? "selected" : ""}`} onClick={(e) => { 
                                                                        setSelectedRequest(app); 
                                                                        setIsOpenAppName(false); 
                                                                        getDataByStatus(app?.applicationsRequested, auditRequestData?.status, auditRequestData?.auditApprovalData, 0); 
                                                                        e.stopPropagation();
                                                                    }}>
                                                                        {app.applicationsRequested}
                                                                    </div>
                                                                ))}
                                                            </div>
                                                        )}
                                                    </div>
                                                )}                                           
                                            </div>
                                        </div>
                                    </>
                                )}
                                <div style={{ borderRadius: '8px', backgroundColor:'#e9eef4', minHeight: '100%'}}>
                                    <div className="p-2" >
                                        <TabsNavigation
                                            className="request-audit-tabs"
                                            onUpdate={selectedTab}
                                            selectedIndex={selectedTabIndex}
                                            style={{...(isMobile ? {overflow: "scroll"} : {})}}
                                        >
                                            <Tab
                                                label={t("auditRequest.approver_queue")}
                                                onClick={function aFe() { }}
                                            />
                                            {
                                                isGuestRequest ? 
                                                <Tab
                                                    label="Request Details"
                                                    onClick={function aFe() { }}
                                                />
                                                :
                                                isSSORequest ?
                                                <Tab
                                                    label={t("auditRequest.request_submitted_label")}
                                                    onClick={function aFe() { }}
                                                />
                                                :
                                                <Tab
                                                    label={t("auditRequest.request_submitted_label")}
                                                    onClick={function aFe() { }}
                                                />
                                            }
                                            {(!isFailedStatus(auditRequestData?.overAllStatus || auditRequestData?.status) && !isInProgressStatus(auditRequestData?.overAllStatus || auditRequestData?.status)) && !isGuestRequest && !isSSORequest &&(
                                                <Tab
                                                    label={t("auditRequest.request_completed_label")}
                                                    onClick={function aFe() { }}
                                                />
                                            )}
                                            {shouldShowProvisionDetails && (
                                                <Tab
                                                    label="Provision Details"
                                                    onClick={function aFe() { }}
                                                />
                                            )}
                                        </TabsNavigation>
                                        <div className="tab-content approvalSteps" style={{
                                            // height: getSectionHeight(), 
                                            minHeight: "190px",
                                            overflow:'auto', ...(isMobile ? {minHeight: "120px"} : {})}}>
                                            {selectedTabIndex === 0 ? (
                                                <div>
                                                    <div className="progressindicatorwithreminder">
                                                        <div className="progress-indicator" ref={queueNameRef}>
                                                            {visibleSteps?.map((_data, _index) => {
                                                                const originalIndex = startIndex + _index;
                                                                const displayStepNumber = originalIndex + 1;

                                                                const isLast = _index === visibleSteps.length - 1;
                                                                const allApproved = lastStepApproved;
                                                                const tickImage = allApproved
                                                                    ? greenTick
                                                                    : _data?.status === "Approved"
                                                                        ? greenTick
                                                                        : halfBlue;
                                                                const lineClass =
                                                                    allApproved
                                                                        ? "div-11"
                                                                        : _data?.status === "Approved"
                                                                            ? "div-11"
                                                                            : "div-13";

                                                                return (
                                                                    <div className="step" key={_index}>
                                                                        <div className="step-1 queue-name" data-tooltip-id={_data?.queueName} data-tooltip-content={_data?.queueName}>
                                                                            {_data?.queueName && _data?.queueName != null
                                                                                    ? _data?.queueName
                                                                                    : t("auditRequest.not_applicable")}{" "}
                                                                        </div>
                                                                        <Tooltip id={_data?.queueName} place="top" style={{ maxWidth: '200px' }} type="light" effect="solid" />
                                                                        <div className="bar">
                                                                            <img loading="lazy" src={tickImage} className="img-9" />
                                                                            <div className="audit-line">
                                                                                {!isLast && <div className={lineClass} />}
                                                                            </div>
                                                                        </div>

                                                                        <div className="_label-2 p-0">
                                                                            <div className="description" style={{ wordWrap: "break-word", whiteSpace: "normal", overflowWrap: "break-word", color: '#2D2D2D', fontSize: '12px', fontWeight: 400 }}>
                                                                                <span>{(_data?.status?.toLowerCase?.() == "denied" || _data?.status?.toLowerCase?.() == "rejected") ? t("auditRequest.rejecter_gpid_label") : t("auditRequest.approver_gpid_label")}:</span>{" "}
                                                                                {_data?.approverGpid && _data?.approverGpid != null
                                                                                    ? _data?.approverGpid
                                                                                    : t("auditRequest.not_applicable")}
                                                                            </div>
                                                                            {_data.dateArrived ? (
                                                                                <div className="description">
                                                                                    <span>{t("auditRequest.arrived_on_label")}:</span>{" "}
                                                                                    {["", "null", null, undefined, "undefined"].includes(_data?.dateArrived?.split(".")[0])
                                                                                        ? t("auditRequest.not_applicable")
                                                                                        : _data?.dateArrived?.split(".")[0]}
                                                                                    <br />
                                                                                    <span>{(_data?.status?.toLowerCase?.() == "denied" || _data?.status?.toLowerCase?.() == "rejected") ? t("auditRequest.rejected_on_label") : t("auditRequest.approved_on_label")}:</span>{" "}
                                                                                    {["", "null", null, undefined, "undefined"].includes(_data?.dateApproved?.split(".")[0])
                                                                                        ? t("auditRequest.not_applicable")
                                                                                        : _data?.dateApproved?.split(".")[0]}
                                                                                </div>
                                                                            ) : (
                                                                                <div className="description-3">{t("homePage.pending")}</div>
                                                                            )}
                                                                        </div>

                                                                        {(_data?.checkSapGrcStatus && _data?.checkSapGrcStatus != null) ?
                                                                            <div className="grc-status-link" onClick={() => openGCRStatus(_data?.checkSapGrcStatus)}>Check GRC Status</div>
                                                                            :
                                                                            <div className="d-flex" style={{gap:".5rem"}}>
                                                                                <Tag
                                                                                    color={(_data?.status === 'Approved' || _data?.status === 'Approval Skipped' || _data?.status === 'APPROVED') ? 'white' : (_data?.status === 'Cancelled' || _data?.status === 'Pending' || _data?.status === 'In Progress' ||  _data?.status === 'Timed Out'|| _data?.status === 'For ISUM Exception Queue' || _data?.status === 'SUBMITTED' || _data?.status === 'FAILED' || _data?.status === 'IN_PROGRESS' || _data?.status === 'CANCELLED') ? 'black' : 'black'}
                                                                                    size="small"
                                                                                    style={{ backgroundColor: (_data?.status === 'Approved' || _data?.status === 'Approval Skipped' || _data?.status === 'APPROVED') ? 'green' : (_data?.status === 'Cancelled' || _data?.status === 'Pending' || _data?.status === 'In Progress' || _data?.status === 'Timed Out' || _data?.status === 'For ISUM Exception Queue' || _data?.status === 'SUBMITTED' || _data?.status === 'FAILED' || _data?.status === 'IN_PROGRESS' || _data?.status === 'CANCELLED') ? '#F1CA18' : '#8b8b8b', marginTop: '8px',
                                                                                        color: (_data?.status === 'Approved' || _data?.status === 'Approval Skipped' || _data?.status === 'APPROVED') ? 'white' : (_data?.status === 'Cancelled' || _data?.status === 'Pending' || _data?.status === 'In Progress' ||  _data?.status === 'Timed Out'|| _data?.status === 'For ISUM Exception Queue' || _data?.status === 'SUBMITTED' || _data?.status === 'FAILED' || _data?.status === 'IN_PROGRESS' || _data?.status === 'REJECTED' || _data?.status === 'CANCELLED') ? 'rgba(0, 0, 0, 1)' : 'rgba(0, 0, 0, 1)', height: '24px'
                                                                                    }}
                                                                                    className="status-tag"
                                                                                    iconTrailing={false}
                                                                                    iconLeading=""
                                                                                    text={_data?.status && _data?.status != null ? ( _data?.status?.includes?.(" ") ? _data?.status?.split?.(" ")?.map?.(val=>`${val?.[0]?.toUpperCase?.() || ''}${val?.slice?.(1)?.toLowerCase?.() || ''}`)?.join?.(" ") : _data?.status?.split?.("_")?.map?.(val=>`${val?.[0]?.toUpperCase?.() || ''}${val?.slice?.(1)?.toLowerCase?.() || ''}`)?.join?.(" ")) : t("auditRequest.not_applicable")}
                                                                                    // type="default"
                                                                                />
                                                                                {((_data?.status?.toLowerCase?.() == "denied") && auditRequestData?.auditApprovalData?.rejectionCommentsMap?.[(auditRequestData?.bundledRequest && auditRequestData?.bundledRequest.length > 0) ? bundledRequestSelectedAppId?.applicationsRequested : auditRequestData?.applicationsRequested]?.replace("[","")?.replace("]","")) ? (
                                                                                    // <TextInput
                                                                                    //     className="denied-text-input mt-0"
                                                                                    //     feedbackType="info"
                                                                                    //     inputSize="medium"
                                                                                    //     label="Reason For Denial"
                                                                                    //     prefixType="none"
                                                                                    //     style={{ width: "200px", marginTop: "10px" }}
                                                                                    //     suffixType="none"
                                                                                    //     type="text"
                                                                                    //     value={auditRequestData?.auditApprovalData?.rejectionCommentsMap?.[auditRequestData?.applicationsRequested]?.replace("[","")?.replace("]","") || ""}
                                                                                    //     disabled
                                                                                    // />
                                                                                    <>
                                                                                        <div className="grc-status-link d-flex align-center" style={{alignItems: "center"}}
                                                                                            data-tooltip-id={auditRequestData?.auditApprovalData?.rejectionCommentsMap?.[(auditRequestData?.bundledRequest && auditRequestData?.bundledRequest.length > 0) ? bundledRequestSelectedAppId?.applicationsRequested : auditRequestData?.applicationsRequested]?.replace("[","")?.replace("]","")} 
                                                                                            data-tooltip-content={auditRequestData?.auditApprovalData?.rejectionCommentsMap?.[(auditRequestData?.bundledRequest && auditRequestData?.bundledRequest.length > 0) ? bundledRequestSelectedAppId?.applicationsRequested : auditRequestData?.applicationsRequested]?.replace("[","")?.replace("]","") || ""}
                                                                                        >Reason For Denial</div>
                                                                                        <Tooltip id={auditRequestData?.auditApprovalData?.rejectionCommentsMap?.[(auditRequestData?.bundledRequest && auditRequestData?.bundledRequest.length > 0) ? bundledRequestSelectedAppId?.applicationsRequested : auditRequestData?.applicationsRequested]?.replace("[","")?.replace("]","")} place="top" style={{ maxWidth: '200px' }} type="light" effect="solid" />
                                                                                    </>
                                                                                ) : null}
                                                                                {((_data?.status?.toLowerCase?.() == "rejected") && auditRequestData?.auditApprovalData?.featureAttributeMap?.approvalInfo?.actionComments) ? (
                                                                                    <>
                                                                                        <div className="grc-status-link d-flex align-center" style={{alignItems: "center"}}
                                                                                            data-tooltip-id={auditRequestData?.auditApprovalData?.featureAttributeMap?.approvalInfo?.actionComments} 
                                                                                            data-tooltip-content={auditRequestData?.auditApprovalData?.featureAttributeMap?.approvalInfo?.actionComments}
                                                                                        >Reason For Denial</div>
                                                                                        <Tooltip id={auditRequestData?.auditApprovalData?.featureAttributeMap?.approvalInfo?.actionComments} place="top" style={{ maxWidth: '200px' }} type="light" effect="solid" />
                                                                                    </>
                                                                                ) : null}
                                                                            </div>
                                                                            // <Badge
                                                                            //     className="status-tag"
                                                                            //     color={(_data?.status === 'Approved' || _data?.status === 'Approval Skipped') ? 'green' : (_data?.status === 'Cancelled' || _data?.status === 'Pending' || _data?.status === 'In Progress' ||  _data?.status === 'Timed Out'|| _data?.status === 'For ISUM Exception Queue') ? 'black' : 'black'}
                                                                            //     style={{ backgroundColor: (_data?.status === 'Approved' || _data?.status === 'Approval Skipped') ? 'green' : (_data?.status === 'Cancelled' || _data?.status === 'Pending' || _data?.status === 'In Progress' || _data?.status === 'Timed Out' || _data?.status === 'For ISUM Exception Queue') ? '#F1CA18' : '#8b8b8b', marginTop: '8px' }}
                                                                            //     // type="default"
                                                                            //     value={_data?.status && _data?.status != null ? _data?.status : t("auditRequest.not_applicable")}
                                                                            // />
                                                                            // <div
                                                                            //     style={{
                                                                            //         marginTop: "8px",
                                                                            //         height: "24px",
                                                                            //         width: "fit-content",
                                                                            //         padding: "2px 8px",
                                                                            //         borderRadius: "4px",
                                                                            //         outline: "1px solid var(--Tokens-Tag-Auxiliary-High-Contrast, #0078A7)",
                                                                            //         outlineOffset: "-1px",
                                                                            //         justifyContent: "flex-start",
                                                                            //         alignItems: "center",
                                                                            //         gap: "2px",
                                                                            //         display: "inline-flex",
                                                                            //     }}
                                                                            // >
                                                                            //     <div
                                                                            //         style={{
                                                                            //             color: "var(--Tokens-Text-Primary, #3A3A3A)",
                                                                            //             fontSize: "12px",
                                                                            //             fontFamily: "Inter",
                                                                            //             fontWeight: 400,
                                                                            //             lineHeight: "18px",
                                                                            //             whiteSpace: "nowrap",
                                                                            //         }}
                                                                            //     >
                                                                            //         {_data?.status && _data?.status != null ? _data?.status : t("auditRequest.not_applicable")}
                                                                            //     </div>
                                                                            // </div>
                                                                        }

                                                                        {/* {
                                                                            _data?.followupAvailable && (
                                                                                <div className="div-15" style={{width: "fit-content", marginTop: "8px", flexWrap: "wrap", height: isMobile ? "75px" : "auto"}}>
                                                                                    <div>
                                                                                        {
                                                                                            _data?.allFollowupTsp?.length > 0 ?  _data?.allFollowupTsp.map((rec)=>{
                                                                                                return <p style={{fontSize: "12px"}}>{`Follow-Up sent on ${rec}`}</p>
                                                                                            }) : null
                                                                                        }
                                                                                        <div className="d-flex justify-content-between">
                                                                                            <div className="stillwaitingforaresponse mr-1">{t("auditRequest.still_waiting_label")}</div>
                                                                                            <button
                                                                                                style={{
                                                                                                    cursor: "pointer",
                                                                                                    border: "none",
                                                                                                    opacity: 1,
                                                                                                }}
                                                                                                className={`${isMobile ? '' : "buttonmenu-default"}`}
                                                                                                onClick={() => {
                                                                                                    const sendReminderPayload = {
                                                                                                        requestNumber: auditRequestData?.request,
                                                                                                        appName: auditRequestData?.applicationsRequested,
                                                                                                        queue: _data?.queueName,
                                                                                                        prociId: auditRequestData?.auditApprovalData?.appProciIDMap[auditRequestData?.applicationsRequested]?.[0]
                                                                                                    };
                                                                                                    setSendReminderPayload(sendReminderPayload);
                                                                                                    setApprovalData(approvalList);
                                                                                                    setRequestNumber(auditRequestData?.request);
                                                                                                    setIsShowModel(true);

                                                                                                }}
                                                                                                // disabled={isDisabled}
                                                                                            >
                                                                                                <div className="button-single-3" style={{height : isMobile ? "56px" : "var(--Spacing-spacing-32, 32px)"}}>
                                                                                                    <div className="unstyled-button-3">
                                                                                                        {t("auditRequest.send_a_reminder_label")}
                                                                                                    </div>
                                                                                                </div>
                                                                                            </button>
                                                                                        </div>
                                                                                    </div>
                                                                                </div>
                                                                            )
                                                                        }  */}

                                                                    </div>
                                                                );
                                                            })}
                                                        </div>

                                                        {!lastStepApproved && approvalList.length > 2 && (
                                                            <button
                                                                onClick={() => toggleShowAll()}
                                                                className="view-all-button"
                                                                style={{
                                                                    marginTop: "8px",
                                                                    border: "none",
                                                                    background: "none",
                                                                    color: "#0078A7",
                                                                    textDecoration: "underline",
                                                                    cursor: "pointer",
                                                                    fontSize: "12px",
                                                                    fontWeight: 600
                                                                }}
                                                            >
                                                                {isShowAllStep
                                                                    ? "Hide Steps"
                                                                    : "Show All Steps"}
                                                            </button>
                                                        )}

                                                        
                                                    </div>
                                                    <div className="approver-queue">
                                                                                                            
                                                        <div className="div-approval-queue"  style={{ flexWrap: "wrap"}}>
                                                            {visibleSteps?.map((_data, _index) => {
                                                                return (    
                                                                    // ((auditRequestData?.auditApprovalData?.isCancelled ? auditRequestData?.auditApprovalData?.isAppFollowupEnabled && _data?.followupAvailable : _data?.followupAvailable) || (_data?.allFollowupTsp?.length > 0 && auditRequestData?.status?.toLowerCase() === "in progress")) && (
                                                                    (auditRequestData?.auditApprovalData?.isCancelled ? auditRequestData?.auditApprovalData?.isAppFollowupEnabled && _data?.followupAvailable : _data?.followupAvailable) && (
                                                                        <div key={_index} className="d-flex justify-content-between" style={{alignItems: "center", backgroundColor: isMobile ? '#fff' : 'transparent', flexWrap: "wrap", padding: "12px", gap: "12px"}}>
                                                                            <div style={{ color: '#2D2D2D', fontSize: '14px'}}>{t("RequestNewAccessForOthers.request_info")}</div>
                                                                            <Button
                                                                                size="small"
                                                                                text={_data?.followupAvailable ? t("auditRequest.send_a_reminder_label") : t("auditRequest.follow_up_reminder_label")}
                                                                                variant="secondary"
                                                                                iconLeading="notifications"
                                                                                style={{ height: '24px !important', fontWeight: 700, color: '#004895', border: 'solid 1px #004895 !important', minWidth: "138px" }}
                                                                                onClick={() => {
                                                                                    const sendReminderPayload = {
                                                                                        requestNumber: auditRequestData?.request,
                                                                                        appName: (auditRequestData?.bundledRequest && auditRequestData?.bundledRequest.length > 0) ? bundledRequestSelectedAppId?.applicationsRequested : auditRequestData?.applicationsRequested,
                                                                                        queue: _data?.queueName,
                                                                                        prociId: auditRequestData?.auditApprovalData?.appProciIDMap?.[(auditRequestData?.bundledRequest && auditRequestData?.bundledRequest.length > 0) ? bundledRequestSelectedAppId?.applicationsRequested : auditRequestData?.applicationsRequested]?.[0]
                                                                                    };
                                                                                    setSendReminderPayload(sendReminderPayload);
                                                                                    setApprovalData(approvalList);
                                                                                    setRequestNumber(auditRequestData?.request);
                                                                                    setRequestType(auditRequestData?.requestType);
                                                                                    // setIsShowModel(true);
                                                                                    setIsShowReminderModel(true);

                                                                                }}
                                                                            />
                                                                        </div>
                                                                    )
                                                            )})}

                                                            <DataTable
                                                                className="datatable audit-request-table audit-approver-queue-table"
                                                                columns={((auditRequestData?.overAllStatus && !isInProgressStatus(auditRequestData?.overAllStatus)) || (auditRequestData?.auditApprovalData?.overAllStatus && !isInProgressStatus(auditRequestData?.auditApprovalData?.overAllStatus))) ? approverQueue.length > 0 ? columns : requestSupportColumns : routingList.length > 0 ? requestSupportColumns : columns}
                                                                key={i18n.language}  
                                                                data={((auditRequestData?.overAllStatus && !isInProgressStatus(auditRequestData?.overAllStatus)) || (auditRequestData?.auditApprovalData?.overAllStatus && !isInProgressStatus(auditRequestData?.auditApprovalData?.overAllStatus))) ? approverQueue.length > 0 ? approverQueue : routingList : routingList.length > 0 ? routingList : approverQueue}
                                                                isResizable={false}
                                                                enableSorting={true}
                                                                onColumnFiltersChange={function oFe() { }}
                                                                onGlobalSearchChange={function oFe() { }}                                                                
                                                                showPagination={false}  
                                                                pageSize={((auditRequestData?.overAllStatus && auditRequestData?.overAllStatus?.toLowerCase?.() !== "in progress") || (auditRequestData?.auditApprovalData?.overAllStatus && auditRequestData?.auditApprovalData?.overAllStatus?.toLowerCase?.() !== "in progress")) ? approverQueue.length > 0 ? (approverQueue?.length || 0) : (routingList?.length || 0) : routingList.length > 0 ? (routingList?.length || 0) : (approverQueue?.length || 0) }                                                             
                                                                renderSubComponent={function oFe() { }}
                                                                rowExpandingHandler={function oFe() { }}
                                                                searchPlaceholder="Type a search keyword"
                                                                selection="single"
                                                                showColumnFilters={false}
                                                                showDescription={false}
                                                                showFilterButton={false}
                                                                showFilterToolbar={false}
                                                                showMultiSortMenu={false}
                                                                showSearchOption={false}
                                                                showTableHeader={false}
                                                                showTitle={false}
                                                                size="large"
                                                                sortingHandler={function oFe() { }}
                                                                style={{width: "100%", overflow: "auto"}}
                                                                tableDescription="Search for a user using a criteria"
                                                                tableHeader="Extension for others"
                                                                noDataDescriptionText=""                             
                                                            />  
                                                        </div>                                                        
                                                    </div>
                                                </div>
                                            ) : 
                                            (isGuestRequest && selectedTabIndex === 1) ? 
                                                <>                                               
                                                    <div className="reqContainer" style={{ justifyContent: auditRequestData?.requestDetails?.length > 0 ? '' :'center'}}>
                                                        { requestDetail?.length > 0 ? (
                                                            <DataTable
                                                                className="datatable audit-request-table audit-approver-queue-table"
                                                                columns={ entraReqDetailsColumn}
                                                                key={i18n.language}
                                                                data={requestDetail}
                                                                isResizable={false}
                                                                enableSorting={true}
                                                                onColumnFiltersChange={function oFe() { }}
                                                                onGlobalSearchChange={function oFe() { }}                                                                
                                                                showPagination={false}      
                                                                pageSize={requestDetail?.length || 0}                                                         
                                                                renderSubComponent={function oFe() { }}
                                                                rowExpandingHandler={function oFe() { }}
                                                                searchPlaceholder="Type a search keyword"
                                                                selection="single"
                                                                showColumnFilters={false}
                                                                showDescription={false}
                                                                showFilterButton={false}
                                                                showFilterToolbar={false}
                                                                showMultiSortMenu={false}
                                                                showSearchOption={false}
                                                                showTableHeader={false}
                                                                showTitle={false}
                                                                size="large"
                                                                sortingHandler={function oFe() { }}
                                                                style={{width: "100%", overflow: "auto"}}
                                                                tableDescription="Search for a user using a criteria"
                                                                tableHeader="Extension for others"
                                                                noDataDescriptionText=""                             
                                                            />
                                                        ) : (
                                                            <>
                                                                <div className="noData" style={{minHeight: "190px"}}></div>
                                                                <div className="no-data-found-text">{t("auditRequest.no_data_found_label")}</div>
                                                            </>
                                                        )}
                                                    </div>
                                                </>
                                            :
                                            (isSSORequest && selectedTabIndex === 1) ?
                                                (() => {
                                                    // Get SSO data from auditApprovalData (response.data contains featureAttributeMap, finalAttributeMap)
                                                    const approvalData = auditRequestData?.auditApprovalData || {};
                                                    const ssoData = buildSsoDisplayData(approvalData, auditRequestData?.applicationsRequested);
                                                    const integrationType = `${ssoData?.['Integration Type'] || ssoData?.integrationType || ssoData?.type || ''}`.toLowerCase();
                                                    const requestTypeNormalized = `${ssoData?.type || ''}`.toLowerCase();
                                                    const grantsText = Array.isArray(ssoData?.grants)
                                                        ? ssoData.grants.join(',').toLowerCase()
                                                        : `${ssoData?.['Grants'] || ssoData?.grants || ''}`.toLowerCase();
                                                    const isM2MType =
                                                        integrationType.includes('m2m') ||
                                                        integrationType.includes('machine2machine') ||
                                                        integrationType.includes('machine to machine') ||
                                                        requestTypeNormalized === 'm2m' ||
                                                        requestTypeNormalized === 'service_application' ||
                                                        requestTypeNormalized === 'service application' ||
                                                        grantsText.includes('client_credentials');
                                                    const isSamlType = !isM2MType && integrationType.includes('saml');
                                                    const isOidcType = !isM2MType && integrationType.includes('oidc');
                                                    const isTruthyChoice = (value) => {
                                                        if (value === true) return true;
                                                        const normalized = String(value || '').trim().toLowerCase();
                                                        return normalized === 'true' || normalized === 'yes';
                                                    };
                                                    const ssoT = (key, fallback = key) => {
                                                        const translated = t(`sso_onboarding.${key}`);
                                                        return translated === `sso_onboarding.${key}` ? fallback : translated;
                                                    };
                                                    const getFieldValue = (...keys) => {
                                                        for (const key of keys) {
                                                            if (ssoData?.[key] !== undefined && ssoData?.[key] !== null) {
                                                                return ssoData[key];
                                                            }
                                                        }
                                                        return undefined;
                                                    };
                                                    const samlApplicationUrl = getFieldValue('Application URL', 'applicationUrl', 'applicationURL');
                                                    const samlAcsUrl = getFieldValue('Assertion Consumer Service (ACS) URL', 'acsURL', 'acsUrl');
                                                    const samlEntityId = getFieldValue('Audience URI (SP Entity ID)', 'entityID', 'audienceUri');
                                                    const samlNameIdFormat = getFieldValue('Name ID Format', 'nameIdFormat', 'nameIdFormatType', 'nameIDFormat');
                                                    const oidcApplicationTypeValue = ssoData?.applicationTypeName || ssoData?.['Application Type'] || ssoData?.applicationType;
                                                    const oidcApplicationUrlValue = ssoData?.['Application URL'] || ssoData?.applicationUrl || ssoData?.applicationURL;
                                                    const oidcLoginUrlValue = ssoData?.['Login URL'] || (Array.isArray(ssoData?.signinUris) ? ssoData.signinUris.join(', ') : (ssoData?.['Sign-in Redirect URIs'] || ssoData?.signinUris));
                                                    const oidcLogoutUrlValue = ssoData?.['Logout URL'] || (Array.isArray(ssoData?.signoutUris) ? ssoData.signoutUris.join(', ') : (ssoData?.['Sign-out Redirect URIs'] || ssoData?.signoutUris));
                                                    const hasLogo = isTruthyChoice(ssoData?.['hasLogo']) || isTruthyChoice(ssoData?.hasLogo) || isTruthyChoice(ssoData?.['Has Logo']);
                                                    const hasCertificate = isTruthyChoice(ssoData?.['hasCertificate']) || isTruthyChoice(ssoData?.hasCertificate) || isTruthyChoice(ssoData?.hasSigningCertificate) || isTruthyChoice(ssoData?.['Has Certificate']);
                                                    const mfaRequired = isTruthyChoice(ssoData?.['Is application designed for administrators with elevated permissions, with restricted access for standard users ?']) || isTruthyChoice(ssoData?.['Is Admin App']) || isTruthyChoice(ssoData?.isAdminApp) || isTruthyChoice(ssoData?.isMFARequired) || isTruthyChoice(ssoData?.['Elevated Permissions']);
                                                    const needIdxAttributeRaw = getFieldValue('needIdxAttribute', 'Need IDX Attribute', 'needIDXAttribute', 'need_idx_attribute');
                                                    const needIdxAttribute = isTruthyChoice(needIdxAttributeRaw);
                                                    const hasNeedIdxAttribute = needIdxAttributeRaw !== undefined;
                                                    const hasExistingIdxAttributeRaw = getFieldValue('hasExistingIdxAttribute', 'Has Existing IDX Attribute', 'hasExistingIDXAttribute', 'has_existing_idx_attribute');
                                                    const hasExistingIdxAttribute = isTruthyChoice(hasExistingIdxAttributeRaw);
                                                    const idxAttributeName = getFieldValue('IDX Attribute Name', 'idxAttribute', 'idx_attribute', 'IDX Attribute');
                                                    const newIdxAttributeRaw = getFieldValue('Is New IDX Attribute', 'newIdxAttribute', 'New IDX Attribute', 'isNewIdxAttribute', 'is_new_idx_attribute');
                                                    const isNewIdxAttribute = isTruthyChoice(newIdxAttributeRaw);
                                                    const needAuthorizationRolesRaw = getFieldValue('needAuthorizationRoles', 'Need Authorization Roles', 'need_authorization_roles');
                                                    const needAuthorizationRoles = isTruthyChoice(needAuthorizationRolesRaw);
                                                    const hasNeedAuthorizationRoles = needAuthorizationRolesRaw !== undefined;
                                                    const hasExistingIdxForRoleRaw = getFieldValue('hasExistingIdxForRole', 'Has Existing IDX For Role', 'hasExistingIDXForRole', 'has_existing_idx_for_role');
                                                    const hasExistingIdxForRole = isTruthyChoice(hasExistingIdxForRoleRaw);
                                                    const roleIdxAttributeName = getFieldValue('Role IDX Attribute', 'roleIdxAttribute', 'role_idx_attribute', 'Role Idx Attribute');
                                                    const newRoleIdxAttributeRaw = getFieldValue('Is New Role IDX Attribute', 'newRoleIdxAttribute', 'New Role IDX Attribute', 'isNewRoleIdxAttribute', 'is_new_role_idx_attribute');
                                                    const isNewRoleIdxAttribute = isTruthyChoice(newRoleIdxAttributeRaw);
                                                    const authorizationRolesValue = getFieldValue('Authorization Roles', 'Roles', 'roles');
                                                    const integrationTypeValue = getFieldValue('Integration Type', 'integrationType', 'type');
                                                    const hasRoleData = !!(authorizationRolesValue || roleIdxAttributeName || hasExistingIdxForRoleRaw !== undefined || newRoleIdxAttributeRaw !== undefined || hasNeedAuthorizationRoles);
                                                    const dataClassification = `${ssoData?.['Data Classification'] || ssoData?.dataClassification || ''}`.toLowerCase();
                                                    const isRestrictedOrConfidential = dataClassification.includes('restricted') || dataClassification.includes('confidential');
                                                    const isSSOModificationRequest = [
                                                        auditRequestData?.requestType,
                                                        auditRequestData?.auditApprovalData?.requestType,
                                                        ssoData?.type,
                                                    ].some((value) => `${value || ''}`.toLowerCase().includes('modif'));
                                                    const hasDisplayValue = (value) => {
                                                        if (Array.isArray(value)) {
                                                            return value.some((item) => hasDisplayValue(item));
                                                        }
                                                        if (value === undefined || value === null) return false;
                                                        const normalized = `${value}`.trim();
                                                        return normalized !== '' && normalized !== '-';
                                                    };
                                                    const showTechnicalConfigSection = isOidcType;
                                                    const showAccessControlSection = !isSSOModificationRequest && (isSamlType || isOidcType || hasNeedIdxAttribute || hasExistingIdxAttributeRaw !== undefined || idxAttributeName !== undefined || newIdxAttributeRaw !== undefined);
                                                    const showAuthorizationRolesSection = (isSamlType || isOidcType) && (needAuthorizationRoles || hasRoleData);
                                                    const showElevatedPermissionsSection = !isSSOModificationRequest && (isSamlType || isOidcType);
                                                    const hasApplicationDetails = !!(
                                                        ssoData?.['Application Name'] ||
                                                        ssoData?.applicationName ||
                                                        integrationTypeValue ||
                                                        samlApplicationUrl ||
                                                        samlAcsUrl ||
                                                        samlEntityId ||
                                                        samlNameIdFormat ||
                                                        ssoData?.['Application Short Name'] ||
                                                        ssoData?.applicationShortName ||
                                                        ssoData?.['Application Type'] ||
                                                        ssoData?.applicationTypeName ||
                                                        ssoData?.applicationType ||
                                                        ssoData?.['Application URL'] ||
                                                        ssoData?.applicationUrl ||
                                                        ssoData?.applicationURL ||
                                                        ssoData?.['Application/Services Type'] ||
                                                        ssoData?.accessTypeName ||
                                                        ssoData?.['Access Type'] ||
                                                        ssoData?.accessType ||
                                                        ssoData?.['Custom Scope Name'] ||
                                                        ssoData?.['Scopes'] ||
                                                        ssoData?.scopes
                                                    );
                                                    const hasLogoDetails = hasLogo || ssoLogoUrl || ssoData?.logoUrl || ssoData?.logoFileName || ssoData?.['logoFileName'];
                                                    const showApplicationLogoSection = (isSamlType || isOidcType) && (!isSSOModificationRequest || hasLogoDetails);
                                                    const showCertificationDetailsSection = !isSSOModificationRequest && isSamlType && (isRestrictedOrConfidential || hasCertificate || ssoData?.certBusinessJustification || ssoData?.['Certificate Business Justification']);
                                                    return (
                                                    <>
                                                        <div className="sso-details-sections" style={{ padding: '12px 0' }}>
                                                            {/* Business Information Section */}
                                                            <div className="sso-section" style={{ marginBottom: '8px', backgroundColor: '#fff', borderRadius: '8px', border: '1px solid #e5e7eb' }}>
                                                                <div 
                                                                    className="sso-section-header"
                                                                    onClick={() => setIsSSOBusinessInfoExpanded(!isSSOBusinessInfoExpanded)}
                                                                    style={{ cursor: 'pointer', display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '12px 16px', borderBottom: isSSOBusinessInfoExpanded ? '1px solid #e5e7eb' : 'none' }}
                                                                >
                                                                    <span style={{ fontWeight: 600, fontSize: '14px', color: '#1a1a1a' }}>{ssoT('Business Information')}</span>
                                                                    <Icon icon={isSSOBusinessInfoExpanded ? "keyboard_arrow_up" : "keyboard_arrow_down"} size="small" />
                                                                </div>
                                                                {isSSOBusinessInfoExpanded && (
                                                                    <div style={{ padding: '16px', display: 'flex', flexWrap: 'wrap', gap: '16px' }}>
                                                                        <div style={{ width: '48%', minWidth: '200px' }}>
                                                                            <div style={{ fontSize: '12px', color: '#666', marginBottom: '4px' }}>{ssoT('Sector')}</div>
                                                                            <div style={{ fontSize: '14px', fontWeight: 500, color: '#1a1a1a' }}>{ssoData?.['Sector'] || ssoData?.sector || '-'}</div>
                                                                        </div>
                                                                        <div style={{ width: '48%', minWidth: '200px' }}>
                                                                            <div style={{ fontSize: '12px', color: '#666', marginBottom: '4px' }}>{ssoT('Environment')}</div>
                                                                            <div style={{ fontSize: '14px', fontWeight: 500, color: '#1a1a1a' }}>{ssoData?.['Environment'] || ssoData?.environment || '-'}</div>
                                                                        </div>
                                                                        <div style={{ width: '48%', minWidth: '200px' }}>
                                                                            <div style={{ fontSize: '12px', color: '#666', marginBottom: '4px' }}>{ssoT('Business Application')}</div>
                                                                            <div style={{ fontSize: '14px', fontWeight: 500, color: '#1a1a1a' }}>{ssoData?.['Business Application'] || ssoData?.businessApplication || ssoData?.businessAppName || '-'}</div>
                                                                        </div>
                                                                        <div style={{ width: '48%', minWidth: '200px' }}>
                                                                            <div style={{ fontSize: '12px', color: '#666', marginBottom: '4px' }}>{ssoT('Application Service')}</div>
                                                                            <div style={{ fontSize: '14px', fontWeight: 500, color: '#1a1a1a' }}>{ssoData?.['Application Service'] || ssoData?.applicationService || '-'}</div>
                                                                        </div>
                                                                        <div style={{ width: '48%', minWidth: '200px' }}>
                                                                            <div style={{ fontSize: '12px', color: '#666', marginBottom: '4px' }}>{ssoT('Data Classification')}</div>
                                                                            <div style={{ fontSize: '14px', fontWeight: 500, color: '#1a1a1a' }}>{ssoData?.['Data Classification'] || ssoData?.dataClassification || '-'}</div>
                                                                        </div>
                                                                        <div style={{ width: '48%', minWidth: '200px' }}>
                                                                            <div style={{ fontSize: '12px', color: '#666', marginBottom: '4px' }}>{ssoT('Application Owner')}</div>
                                                                            <div style={{ fontSize: '14px', fontWeight: 500, color: '#1a1a1a' }}>{ssoData?.['Application Owner'] || ssoData?.applicationOwner || auditRequestData?.initiatorGpid || '-'}</div>
                                                                        </div>
                                                                    </div>
                                                                )}
                                                            </div>

                                                            {/* Application Details Section */}
                                                            {hasApplicationDetails && (
                                                                <div className="sso-section" style={{ marginBottom: '8px', backgroundColor: '#fff', borderRadius: '8px', border: '1px solid #e5e7eb' }}>
                                                                    <div 
                                                                        className="sso-section-header"
                                                                        onClick={() => setIsSSOAppDetailsExpanded(!isSSOAppDetailsExpanded)}
                                                                        style={{ cursor: 'pointer', display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '12px 16px', borderBottom: isSSOAppDetailsExpanded ? '1px solid #e5e7eb' : 'none' }}
                                                                    >
                                                                        <span style={{ fontWeight: 600, fontSize: '14px', color: '#1a1a1a' }}>{ssoT('Application Details')}</span>
                                                                        <Icon icon={isSSOAppDetailsExpanded ? "keyboard_arrow_up" : "keyboard_arrow_down"} size="small" />
                                                                    </div>
                                                                    {isSSOAppDetailsExpanded && (
                                                                        <div style={{ padding: '16px', display: 'flex', flexWrap: 'wrap', gap: '16px' }}>
                                                                            {/* Common field: Application Name */}
                                                                            <div style={{ width: '48%', minWidth: '200px' }}>
                                                                                <div style={{ fontSize: '12px', color: '#666', marginBottom: '4px' }}>{ssoT('Application Name')}</div>
                                                                                <div style={{ fontSize: '14px', fontWeight: 500, color: '#1a1a1a' }}>{ssoData?.['Application Name'] || ssoData?.applicationName || '-'}</div>
                                                                            </div>
                                                                            {integrationTypeValue && (
                                                                                <div style={{ width: '48%', minWidth: '200px' }}>
                                                                                    <div style={{ fontSize: '12px', color: '#666', marginBottom: '4px' }}>{ssoT('Integration Type')}</div>
                                                                                    <div style={{ fontSize: '14px', fontWeight: 500, color: '#1a1a1a' }}>{integrationTypeValue || '-'}</div>
                                                                                </div>
                                                                            )}
                                                                            
                                                                            {/* SAML specific fields */}
                                                                            {isSamlType && (
                                                                                <>
                                                                                    {hasDisplayValue(samlApplicationUrl) && (
                                                                                        <div style={{ width: '48%', minWidth: '200px' }}>
                                                                                            <div style={{ fontSize: '12px', color: '#666', marginBottom: '4px' }}>{ssoT('End-user Application URL')}</div>
                                                                                            <div style={{ fontSize: '14px', fontWeight: 500, color: '#1a1a1a', wordBreak: 'break-all' }}>{samlApplicationUrl}</div>
                                                                                        </div>
                                                                                    )}
                                                                                    {hasDisplayValue(samlAcsUrl) && (
                                                                                        <div style={{ width: '48%', minWidth: '200px' }}>
                                                                                            <div style={{ fontSize: '12px', color: '#666', marginBottom: '4px' }}>{ssoT('Assertion Consumer Service (ACS) URL')}</div>
                                                                                            <div style={{ fontSize: '14px', fontWeight: 500, color: '#1a1a1a', wordBreak: 'break-all' }}>{samlAcsUrl}</div>
                                                                                        </div>
                                                                                    )}
                                                                                    {hasDisplayValue(samlEntityId) && (
                                                                                        <div style={{ width: '48%', minWidth: '200px' }}>
                                                                                            <div style={{ fontSize: '12px', color: '#666', marginBottom: '4px' }}>{ssoT('Audience URI (SP Entity ID)')}</div>
                                                                                            <div style={{ fontSize: '14px', fontWeight: 500, color: '#1a1a1a', wordBreak: 'break-all' }}>{samlEntityId}</div>
                                                                                        </div>
                                                                                    )}
                                                                                    {hasDisplayValue(samlNameIdFormat) && (
                                                                                        <div style={{ width: '48%', minWidth: '200px' }}>
                                                                                            <div style={{ fontSize: '12px', color: '#666', marginBottom: '4px' }}>{ssoT('Name ID Format')}</div>
                                                                                            <div style={{ fontSize: '14px', fontWeight: 500, color: '#1a1a1a' }}>{samlNameIdFormat}</div>
                                                                                        </div>
                                                                                    )}
                                                                                    {(ssoData?.['Application Short Name'] || ssoData?.applicationShortName) && (
                                                                                        <div style={{ width: '48%', minWidth: '200px' }}>
                                                                                            <div style={{ fontSize: '12px', color: '#666', marginBottom: '4px' }}>{ssoT('Application Short Name')}</div>
                                                                                            <div style={{ fontSize: '14px', fontWeight: 500, color: '#1a1a1a' }}>{ssoData?.['Application Short Name'] || ssoData?.applicationShortName || '-'}</div>
                                                                                        </div>
                                                                                    )}
                                                                                </>
                                                                            )}

                                                                            {/* OIDC specific fields */}
                                                                            {isOidcType && (
                                                                                <>
                                                                                    {hasDisplayValue(oidcApplicationTypeValue) && (
                                                                                        <div style={{ width: '48%', minWidth: '200px' }}>
                                                                                            <div style={{ fontSize: '12px', color: '#666', marginBottom: '4px' }}>{ssoT('Application Type')}</div>
                                                                                            <div style={{ fontSize: '14px', fontWeight: 500, color: '#1a1a1a' }}>{oidcApplicationTypeValue}</div>
                                                                                        </div>
                                                                                    )}
                                                                                    {hasDisplayValue(oidcApplicationUrlValue) && (
                                                                                        <div style={{ width: '48%', minWidth: '200px' }}>
                                                                                            <div style={{ fontSize: '12px', color: '#666', marginBottom: '4px' }}>{ssoT('Application URL')}</div>
                                                                                            <div style={{ fontSize: '14px', fontWeight: 500, color: '#1a1a1a', wordBreak: 'break-all' }}>{oidcApplicationUrlValue}</div>
                                                                                        </div>
                                                                                    )}
                                                                                    {(ssoData?.['Application Short Name'] || ssoData?.applicationShortName) && (
                                                                                        <div style={{ width: '48%', minWidth: '200px' }}>
                                                                                            <div style={{ fontSize: '12px', color: '#666', marginBottom: '4px' }}>{ssoT('Application Short Name')}</div>
                                                                                            <div style={{ fontSize: '14px', fontWeight: 500, color: '#1a1a1a' }}>{ssoData?.['Application Short Name'] || ssoData?.applicationShortName || '-'}</div>
                                                                                        </div>
                                                                                    )}
                                                                                </>
                                                                            )}

                                                                            {/* M2M specific fields */}
                                                                            {isM2MType && (
                                                                                <>
                                                                                    <div style={{ width: '48%', minWidth: '200px' }}>
                                                                                        <div style={{ fontSize: '12px', color: '#666', marginBottom: '4px' }}>{ssoT('Application/Services Type')}</div>
                                                                                        <div style={{ fontSize: '14px', fontWeight: 500, color: '#1a1a1a' }}>{ssoData?.['Application/Services Type'] || ssoData?.accessTypeName || ssoData?.['Access Type'] || ssoData?.accessType || '-'}</div>
                                                                                    </div>
                                                                                    {(ssoData?.['Custom Scope Name'] || ssoData?.['Scopes'] || ssoData?.scopes) && (
                                                                                        <div style={{ width: '48%', minWidth: '200px' }}>
                                                                                            <div style={{ fontSize: '12px', color: '#666', marginBottom: '4px' }}>{ssoT('Custom Scope Name')}</div>
                                                                                            <div style={{ fontSize: '14px', fontWeight: 500, color: '#1a1a1a' }}>
                                                                                                {Array.isArray(ssoData?.['Custom Scope Name'])
                                                                                                    ? ssoData?.['Custom Scope Name'].join(', ')
                                                                                                    : Array.isArray(ssoData?.['Scopes'])
                                                                                                        ? ssoData?.['Scopes'].join(', ')
                                                                                                        : Array.isArray(ssoData?.scopes)
                                                                                                            ? ssoData?.scopes.join(', ')
                                                                                                            : (ssoData?.['Custom Scope Name'] || ssoData?.['Scopes'] || ssoData?.scopes || '-')}
                                                                                            </div>
                                                                                        </div>
                                                                                    )}
                                                                                </>
                                                                            )}

                                                                        </div>
                                                                    )}
                                                                </div>
                                                            )}

                                                            {/* Access Control Section */}
                                                            {showAccessControlSection && (
                                                            <div className="sso-section" style={{ marginBottom: '8px', backgroundColor: '#fff', borderRadius: '8px', border: '1px solid #e5e7eb' }}>
                                                                <div 
                                                                    className="sso-section-header"
                                                                    onClick={() => setIsSSOAccessControlExpanded(!isSSOAccessControlExpanded)}
                                                                    style={{ cursor: 'pointer', display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '12px 16px', borderBottom: isSSOAccessControlExpanded ? '1px solid #e5e7eb' : 'none' }}
                                                                >
                                                                    <span style={{ fontWeight: 600, fontSize: '14px', color: '#1a1a1a' }}>{ssoT('Access Control')}</span>
                                                                    <Icon icon={isSSOAccessControlExpanded ? "keyboard_arrow_up" : "keyboard_arrow_down"} size="small" />
                                                                </div>
                                                                {isSSOAccessControlExpanded && (
                                                                    <div style={{ padding: '16px', display: 'flex', flexWrap: 'wrap', gap: '16px', alignItems: 'flex-start' }}>
                                                                        {hasNeedIdxAttribute && (
                                                                            <div style={{ width: '48%', minWidth: '200px' }}>
                                                                                <div style={{ fontSize: '12px', color: '#666', marginBottom: '4px' }}>{ssoT('Need IDX Attribute')}</div>
                                                                                <div style={{ fontSize: '14px', fontWeight: 500, color: '#1a1a1a' }}>{needIdxAttribute ? ssoT('Yes') : ssoT('No')}</div>
                                                                            </div>
                                                                        )}

                                                                        {(!needIdxAttribute && (ssoData?.['Application Access Control'] || ssoData?.accessControls || ssoData?.applicationAccessControl)) && (
                                                                            <div style={{ width: '48%', minWidth: '200px' }}>
                                                                                <div style={{ fontSize: '12px', color: '#666', marginBottom: '4px' }}>{ssoT('Application Access Control')}</div>
                                                                                <div style={{ fontSize: '14px', fontWeight: 500, color: '#1a1a1a' }}>{Array.isArray(ssoData?.accessControls) ? ssoData.accessControls.join(', ') : (ssoData?.['Application Access Control'] || ssoData?.applicationAccessControl || '-')}</div>
                                                                            </div>
                                                                        )}

                                                                        {hasExistingIdxAttributeRaw !== undefined && (
                                                                            <div style={{ width: '48%', minWidth: '200px' }}>
                                                                                <div style={{ fontSize: '12px', color: '#666', marginBottom: '4px' }}>{ssoT('Has Existing IDX Attribute')}</div>
                                                                                <div style={{ fontSize: '14px', fontWeight: 500, color: '#1a1a1a' }}>{hasExistingIdxAttribute ? ssoT('Yes') : ssoT('No')}</div>
                                                                            </div>
                                                                        )}

                                                                        {idxAttributeName !== undefined && (
                                                                            <div style={{ width: '48%', minWidth: '200px' }}>
                                                                                <div style={{ fontSize: '12px', color: '#666', marginBottom: '4px' }}>{ssoT('IDX Attribute Name')}</div>
                                                                                <div style={{ fontSize: '14px', fontWeight: 500, color: '#1a1a1a' }}>{idxAttributeName || '-'}</div>
                                                                            </div>
                                                                        )}

                                                                        {newIdxAttributeRaw !== undefined && (
                                                                            <div style={{ width: '48%', minWidth: '200px' }}>
                                                                                <div style={{ fontSize: '12px', color: '#666', marginBottom: '4px' }}>{ssoT('Is New IDX Attribute')}</div>
                                                                                <div style={{ fontSize: '14px', fontWeight: 500, color: '#1a1a1a' }}>{isNewIdxAttribute ? ssoT('Yes') : ssoT('No')}</div>
                                                                            </div>
                                                                        )}

                                                                        {hasNeedAuthorizationRoles && <div style={{ width: '48%', minWidth: '200px' }}>
                                                                            <div style={{ fontSize: '12px', color: '#666', marginBottom: '4px' }}>{ssoT('Need Authorization Roles')}</div>
                                                                            <div style={{ fontSize: '14px', fontWeight: 500, color: '#1a1a1a' }}>{needAuthorizationRoles ? ssoT('Yes') : ssoT('No')}</div>
                                                                        </div>}

                                                                    </div>
                                                                )}
                                                            </div>
                                                            )}

                                                            {showTechnicalConfigSection && (
                                                                <div className="sso-section" style={{ marginBottom: '8px', backgroundColor: '#fff', borderRadius: '8px', border: '1px solid #e5e7eb' }}>
                                                                    <div
                                                                        className="sso-section-header"
                                                                        onClick={() => setIsSSOTechnicalConfigExpanded(!isSSOTechnicalConfigExpanded)}
                                                                        style={{ cursor: 'pointer', display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '12px 16px', borderBottom: isSSOTechnicalConfigExpanded ? '1px solid #e5e7eb' : 'none' }}
                                                                    >
                                                                        <span style={{ fontWeight: 600, fontSize: '14px', color: '#1a1a1a' }}>{ssoT('OIDC Configurations')}</span>
                                                                        <Icon icon={isSSOTechnicalConfigExpanded ? "keyboard_arrow_up" : "keyboard_arrow_down"} size="small" />
                                                                    </div>
                                                                    {isSSOTechnicalConfigExpanded && (
                                                                        <div style={{ padding: '16px', display: 'flex', flexWrap: 'wrap', gap: '16px' }}>
                                                                            {isOidcType && (
                                                                                <>
                                                                                    {hasDisplayValue(oidcLoginUrlValue) && (
                                                                                        <div style={{ width: '48%', minWidth: '200px' }}>
                                                                                            <div style={{ fontSize: '12px', color: '#666', marginBottom: '4px' }}>{ssoT('Login URL')}</div>
                                                                                            <div style={{ fontSize: '14px', fontWeight: 500, color: '#1a1a1a', wordBreak: 'break-all' }}>{oidcLoginUrlValue}</div>
                                                                                        </div>
                                                                                    )}
                                                                                    {hasDisplayValue(oidcLogoutUrlValue) && (
                                                                                        <div style={{ width: '48%', minWidth: '200px' }}>
                                                                                            <div style={{ fontSize: '12px', color: '#666', marginBottom: '4px' }}>{ssoT('Logout URL')}</div>
                                                                                            <div style={{ fontSize: '14px', fontWeight: 500, color: '#1a1a1a', wordBreak: 'break-all' }}>{oidcLogoutUrlValue}</div>
                                                                                        </div>
                                                                                    )}
                                                                                </>
                                                                            )}
                                                                        </div>
                                                                    )}
                                                                </div>
                                                            )}

                                                            {showAuthorizationRolesSection && <div className="sso-section" style={{ marginBottom: '8px', backgroundColor: '#fff', borderRadius: '8px', border: '1px solid #e5e7eb' }}>
                                                                <div
                                                                    className="sso-section-header"
                                                                    onClick={() => setIsSSOAuthorizationRolesExpanded(!isSSOAuthorizationRolesExpanded)}
                                                                    style={{ cursor: 'pointer', display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '12px 16px', borderBottom: isSSOAuthorizationRolesExpanded ? '1px solid #e5e7eb' : 'none' }}
                                                                >
                                                                    <span style={{ fontWeight: 600, fontSize: '14px', color: '#1a1a1a' }}>{ssoT('Authorization Roles')}</span>
                                                                    <Icon icon={isSSOAuthorizationRolesExpanded ? "keyboard_arrow_up" : "keyboard_arrow_down"} size="small" />
                                                                </div>
                                                                {isSSOAuthorizationRolesExpanded && (
                                                                    <div style={{ padding: '16px', display: 'flex', flexWrap: 'wrap', gap: '16px' }}>
                                                                        {(needAuthorizationRoles || hasRoleData) && authorizationRolesValue && (
                                                                            <div style={{ width: '48%', minWidth: '200px' }}>
                                                                                <div style={{ fontSize: '12px', color: '#666', marginBottom: '4px' }}>{ssoT('Authorization Roles')}</div>
                                                                                <div style={{ fontSize: '14px', fontWeight: 500, color: '#1a1a1a' }}>{Array.isArray(authorizationRolesValue) ? authorizationRolesValue.join(', ') : (authorizationRolesValue || '-')}</div>
                                                                            </div>
                                                                        )}
                                                                        {(needAuthorizationRoles || hasRoleData) && hasExistingIdxForRoleRaw !== undefined && (
                                                                            <div style={{ width: '48%', minWidth: '200px' }}>
                                                                                <div style={{ fontSize: '12px', color: '#666', marginBottom: '4px' }}>{ssoT('Has Existing IDX For Role')}</div>
                                                                                <div style={{ fontSize: '14px', fontWeight: 500, color: '#1a1a1a' }}>{hasExistingIdxForRole ? ssoT('Yes') : ssoT('No')}</div>
                                                                            </div>
                                                                        )}
                                                                        {(needAuthorizationRoles || hasRoleData) && roleIdxAttributeName !== undefined && (
                                                                            <div style={{ width: '48%', minWidth: '200px' }}>
                                                                                <div style={{ fontSize: '12px', color: '#666', marginBottom: '4px' }}>{ssoT('Role Idx Attribute')}</div>
                                                                                <div style={{ fontSize: '14px', fontWeight: 500, color: '#1a1a1a' }}>{roleIdxAttributeName || '-'}</div>
                                                                            </div>
                                                                        )}
                                                                        {(needAuthorizationRoles || hasRoleData) && newRoleIdxAttributeRaw !== undefined && (
                                                                            <div style={{ width: '48%', minWidth: '200px' }}>
                                                                                <div style={{ fontSize: '12px', color: '#666', marginBottom: '4px' }}>{ssoT('Is New Role IDX Attribute')}</div>
                                                                                <div style={{ fontSize: '14px', fontWeight: 500, color: '#1a1a1a' }}>{isNewRoleIdxAttribute ? ssoT('Yes') : ssoT('No')}</div>
                                                                            </div>
                                                                        )}
                                                                    </div>
                                                                )}
                                                            </div>}

                                                            {showElevatedPermissionsSection && <div className="sso-section" style={{ marginBottom: '8px', backgroundColor: '#fff', borderRadius: '8px', border: '1px solid #e5e7eb' }}>
                                                                <div
                                                                    className="sso-section-header"
                                                                    onClick={() => setIsSSOElevatedPermissionsExpanded(!isSSOElevatedPermissionsExpanded)}
                                                                    style={{ cursor: 'pointer', display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '12px 16px', borderBottom: isSSOElevatedPermissionsExpanded ? '1px solid #e5e7eb' : 'none' }}
                                                                >
                                                                    <span style={{ fontWeight: 600, fontSize: '14px', color: '#1a1a1a' }}>{ssoT('Elevated Permissions')}</span>
                                                                    <Icon icon={isSSOElevatedPermissionsExpanded ? "keyboard_arrow_up" : "keyboard_arrow_down"} size="small" />
                                                                </div>
                                                                {isSSOElevatedPermissionsExpanded && (
                                                                    <div style={{ padding: '16px', display: 'flex', flexWrap: 'wrap', gap: '16px' }}>
                                                                        <div style={{ width: '48%', minWidth: '200px' }}>
                                                                            <div style={{ fontSize: '12px', color: '#666', marginBottom: '4px' }}>{ssoT('Is application designed for administrators with elevated permissions, with restricted access for standard users ?')}</div>
                                                                            <div style={{ fontSize: '14px', fontWeight: 500, color: '#1a1a1a' }}>{mfaRequired ? ssoT('Yes') : ssoT('No')}</div>
                                                                        </div>
                                                                    </div>
                                                                )}
                                                            </div>}

                                                            {showApplicationLogoSection && <div className="sso-section" style={{ marginBottom: '8px', backgroundColor: '#fff', borderRadius: '8px', border: '1px solid #e5e7eb' }}>
                                                                <div
                                                                    className="sso-section-header"
                                                                    onClick={() => setIsSSOAppLogoExpanded(!isSSOAppLogoExpanded)}
                                                                    style={{ cursor: 'pointer', display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '12px 16px', borderBottom: isSSOAppLogoExpanded ? '1px solid #e5e7eb' : 'none' }}
                                                                >
                                                                    <span style={{ fontWeight: 600, fontSize: '14px', color: '#1a1a1a' }}>{ssoT('Application Logo')}</span>
                                                                    <Icon icon={isSSOAppLogoExpanded ? "keyboard_arrow_up" : "keyboard_arrow_down"} size="small" />
                                                                </div>
                                                                {isSSOAppLogoExpanded && (
                                                                    <div style={{ padding: '16px', display: 'flex', flexWrap: 'wrap', gap: '16px', alignItems: 'flex-start' }}>
                                                                        <div style={{ width: '48%', minWidth: '200px' }}>
                                                                            <div style={{ fontSize: '12px', color: '#666', marginBottom: '4px' }}>{ssoT('Has Logo')}</div>
                                                                            <div style={{ fontSize: '14px', fontWeight: 500, color: '#1a1a1a', marginBottom: '12px' }}>{hasLogo ? ssoT('Yes') : ssoT('No')}</div>
                                                                            {hasLogo && (
                                                                                <>
                                                                                    <div style={{ fontSize: '12px', color: '#666', marginBottom: '8px' }}>{ssoT('Application Logo')} {ssoData?.logoFileName && `(${ssoData.logoFileName})`}</div>
                                                                                    <div style={{ width: '120px', height: '120px', border: '1px solid #e5e7eb', borderRadius: '8px', display: 'flex', alignItems: 'center', justifyContent: 'center', overflow: 'hidden', backgroundColor: '#f9fafb' }}>
                                                                                        {(ssoLogoUrl || ssoData?.logoUrl) ? (
                                                                                            <img
                                                                                                src={ssoLogoUrl || ssoData?.logoUrl}
                                                                                                alt="Application Logo"
                                                                                                style={{ maxWidth: '100%', maxHeight: '100%', objectFit: 'contain', cursor: 'zoom-in' }}
                                                                                                title="Click to enlarge"
                                                                                                onClick={() => openSSOLogoPreview(ssoLogoUrl || ssoData?.logoUrl)}
                                                                                                onError={(e) => { e.target.onerror = null; e.target.src = ''; e.target.alt = 'Logo not available'; }}
                                                                                            />
                                                                                        ) : (
                                                                                            <span style={{ fontSize: '12px', color: '#999' }}>Loading...</span>
                                                                                        )}
                                                                                    </div>
                                                                                </>
                                                                            )}
                                                                        </div>
                                                                    </div>
                                                                )}
                                                            </div>}

                                                            {showCertificationDetailsSection && (
                                                                <div className="sso-section" style={{ marginBottom: '8px', backgroundColor: '#fff', borderRadius: '8px', border: '1px solid #e5e7eb' }}>
                                                                    <div
                                                                        className="sso-section-header"
                                                                        onClick={() => setIsSSOCertificationDetailsExpanded(!isSSOCertificationDetailsExpanded)}
                                                                        style={{ cursor: 'pointer', display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '12px 16px', borderBottom: isSSOCertificationDetailsExpanded ? '1px solid #e5e7eb' : 'none' }}
                                                                    >
                                                                        <span style={{ fontWeight: 600, fontSize: '14px', color: '#1a1a1a' }}>{ssoT('Certification Details')}</span>
                                                                        <Icon icon={isSSOCertificationDetailsExpanded ? "keyboard_arrow_up" : "keyboard_arrow_down"} size="small" />
                                                                    </div>
                                                                    {isSSOCertificationDetailsExpanded && (
                                                                        <div style={{ padding: '16px', display: 'flex', flexWrap: 'wrap', gap: '16px', alignItems: 'flex-start' }}>
                                                                            <div style={{ width: '48%', minWidth: '200px' }}>
                                                                                <div style={{ fontSize: '12px', color: '#666', marginBottom: '4px' }}>{ssoT('Has Certificate')}</div>
                                                                                <div style={{ fontSize: '14px', fontWeight: 500, color: '#1a1a1a', marginBottom: '12px' }}>{hasCertificate ? ssoT('Yes') : ssoT('No')}</div>
                                                                                {hasCertificate && (
                                                                                    <>
                                                                                        <div style={{ fontSize: '12px', color: '#666', marginBottom: '4px' }}>{ssoT('Certificate')}</div>
                                                                                        {ssoCertificateUrl ? (
                                                                                            <div style={{ display: 'flex', alignItems: 'center', gap: '8px', padding: '8px 12px', backgroundColor: '#f9fafb', borderRadius: '6px', border: '1px solid #e5e7eb', width: 'fit-content' }}>
                                                                                                <Icon icon="description" size="small" style={{ color: '#004895' }} />
                                                                                                <span style={{ fontSize: '14px', fontWeight: 500, color: '#1a1a1a' }}>
                                                                                                    {ssoCertificateName || ssoData?.certificateFileName || ssoData?.['certificateFileName'] || 'Certificate.crt'}
                                                                                                </span>
                                                                                                <a href={ssoCertificateUrl} download={ssoCertificateName || ssoData?.certificateFileName || ssoData?.['certificateFileName'] || 'Certificate.crt'} style={{ display: 'flex', alignItems: 'center', cursor: 'pointer', color: '#004895', textDecoration: 'none' }} title="Download Certificate">
                                                                                                    <Icon icon="download" size="small" style={{ color: '#004895' }} />
                                                                                                </a>
                                                                                            </div>
                                                                                        ) : (
                                                                                            <span style={{ fontSize: '12px', color: '#999' }}>Loading...</span>
                                                                                        )}
                                                                                    </>
                                                                                )}
                                                                            </div>
                                                                            {(ssoData?.['Certificate Business Justification'] || ssoData?.certBusinessJustification) && (
                                                                                <div style={{ width: '100%', minWidth: '200px' }}>
                                                                                    <div style={{ fontSize: '12px', color: '#666', marginBottom: '4px' }}>{ssoT('Certificate Business Justification')}</div>
                                                                                    <div style={{ fontSize: '14px', fontWeight: 500, color: '#1a1a1a' }}>{ssoData?.['Certificate Business Justification'] || ssoData?.certBusinessJustification || '-'}</div>
                                                                                </div>
                                                                            )}
                                                                        </div>
                                                                    )}
                                                                </div>
                                                            )}

                                                        </div>
                                                    </>
                                                    );
                                                })()
                                            :
                                            selectedTabIndex === 1 ? (
                                                <>                                               
                                                    <div className="reqContainer" style={{ justifyContent: requestDetail.length > 0 ? '' :'center'}}>
                                                        { requestDetail.length > 0 ? (
                                                            requestDetail?.sort?.((a, b) =>({"errorMessage":1,"entraAppId":2,"entraAppObjectId":3,"entraSpObjectId":4}[a.key] ?? 999) - ({"errorMessage":1,"entraAppId":2,"entraAppObjectId":3,"entraSpObjectId":4}[b.key] ?? 999))?.map?.((item, _index) => (
                                                            (item?.key && !item?.key.toLowerCase()?.includes("status") && item.value?.replace?.(/^\[|\}|\{|\]$/g, "") && ((!isFailedStatus(auditRequestData?.overAllStatus || auditRequestData?.status) && !isInProgressStatus(auditRequestData?.overAllStatus || auditRequestData?.status) && auditRequestData?.auditApprovalData?.requestType==='ENTRA_APP_REGISTRATION' && !["errorMessage", "entraAppId", "entraAppObjectId", "entraSpObjectId"].includes(item?.key)) || isInProgressStatus(auditRequestData?.overAllStatus || auditRequestData?.status)) && (item?.key!=="errorMessage" || ['partial_failed', 'failed']?.includes(requestDetail?.filter((i)=>i?.key === "provisioningStatus")[0]?.value?.toLowerCase()))) ? <div className="item" key={_index}>
                                                                <div className="reqKey" dangerouslySetInnerHTML={{ __html: `${item?.key?.includes?.(":") ? camelToTitle(item?.key) : `${camelToTitle(item?.key || '')}:`}` }}></div>
                                                                <div className="reqValue">{
                                                                    item?.key === "apiPermissions"
                                                                    ? [...item.value.matchAll(/name=([^,\]}]+)/g)].map(m => m[1]).join(", ")
                                                                    :
                                                                    item?.value?.includes?.("~")
                                                                    ? item.value.split("~").map((val, i) => (
                                                                        <div key={i}>{val}</div>
                                                                    ))
                                                                    : item.value?.replace?.(/^\[|\}|\{|\]$/g, "")}</div>
                                                            </div> 
                                                            : (item?.key && !item?.key.toLowerCase()?.includes("status") && item.value?.replace?.(/^\[|\}|\{|\]$/g, "") && auditRequestData?.auditApprovalData?.requestType!=='ENTRA_APP_REGISTRATION') ? <div className="item" key={_index}>
                                                                <div className="reqKey" dangerouslySetInnerHTML={{ __html: `${item?.key?.includes?.(":") ? camelToTitle(item?.key) : `${camelToTitle(item?.key || '')}:`}` }}></div>
                                                                <div className="reqValue">{
                                                                    item?.key === "apiPermissions"
                                                                    ? [...item.value.matchAll(/name=([^,\]}]+)/g)].map(m => m[1]).join(", ")
                                                                    :
                                                                    item?.value?.includes?.("~")
                                                                    ? item.value.split("~").map((val, i) => (
                                                                        <div key={i}>{val}</div>
                                                                    ))
                                                                    : item.value?.replace?.(/^\[|\}|\{|\]$/g, "")}</div>
                                                            </div> : null
                                                            ))
                                                        ) : (
                                                            <>
                                                                <div className="noData" style={{minHeight: "190px"}}></div>
                                                                <div className="no-data-found-text">{t("auditRequest.no_data_found_label")}</div>
                                                            </>
                                                        )}
                                                    </div>
                                                </>
                                                

                                            ) : selectedTabIndex === 2 && isSSORequest && shouldShowProvisionDetails ? (
                                                (() => {
                                                    const approvalData = auditRequestData?.auditApprovalData || {};
                                                    // Provisioning data is under ssoProvisioningData key in the API response
                                                    const ssoProvisioningData = approvalData?.ssoProvisioningData || {};
                                                    const provisioningActions = ssoProvisioningData?.provisioningActions || [];
                                                    const provisioningSummary = ssoProvisioningData?.['Provisioning Summary'] || {};
                                                    const provisionedDetails = ssoProvisioningData?.provisionedDetails || {};
                                                    const requestPayload = ssoProvisioningData?.request || {};
                                                    const hasFallbackProvisioningRequest = Object.keys(requestPayload).length > 0;
                                                    const getStatusColor = (status) => {
                                                        const s = (status || '').toUpperCase();
                                                        if (s === 'SUCCESS' || s === 'PROVISIONED') return { bg: '#e8f5e9', color: '#2e7d32', border: '#a5d6a7' };
                                                        if (s === 'FAILED' || s === 'ERROR') return { bg: '#ffebee', color: '#c62828', border: '#ef9a9a' };
                                                        return { bg: '#fff8e1', color: '#f57f17', border: '#ffe082' };
                                                    };
                                                    return (
                                                        <div style={{ padding: '8px 0' }}>
                                                            {/* Provisioning Summary */}
                                                            {Object.keys(provisioningSummary).length > 0 && (
                                                                <div style={{ marginBottom: '12px', backgroundColor: '#fff', borderRadius: '8px', border: '1px solid #e5e7eb' }}>
                                                                    <div style={{ padding: '12px 16px', borderBottom: '1px solid #e5e7eb' }}>
                                                                        <span style={{ fontWeight: 600, fontSize: '14px', color: '#1a1a1a' }}>Provisioning Summary</span>
                                                                    </div>
                                                                    <div style={{ padding: '16px', display: 'flex', flexWrap: 'wrap', gap: '16px' }}>
                                                                        {Object.entries(provisioningSummary).map(([key, val], i) => {
                                                                            const { bg, color, border } = getStatusColor(val);
                                                                            return (
                                                                                <div key={i} style={{ minWidth: '180px' }}>
                                                                                    <div style={{ fontSize: '12px', color: '#666', marginBottom: '6px' }}>{key}</div>
                                                                                    <span style={{ display: 'inline-block', padding: '2px 10px', borderRadius: '4px', backgroundColor: bg, color, border: `1px solid ${border}`, fontSize: '13px', fontWeight: 600 }}>{val}</span>
                                                                                </div>
                                                                            );
                                                                        })}
                                                                    </div>
                                                                </div>
                                                            )}

                                                            {/* Provisioned Details */}
                                                            {(Object.keys(provisionedDetails).length > 0 || hasFallbackProvisioningRequest) && (
                                                                <div style={{ marginBottom: '12px', backgroundColor: '#fff', borderRadius: '8px', border: '1px solid #e5e7eb' }}>
                                                                    <div style={{ padding: '12px 16px', borderBottom: '1px solid #e5e7eb' }}>
                                                                        <span style={{ fontWeight: 600, fontSize: '14px', color: '#1a1a1a' }}>Provisioned Details</span>
                                                                    </div>
                                                                    <div style={{ padding: '16px', display: 'flex', flexWrap: 'wrap', gap: '16px' }}>
                                                                        {(provisionedDetails.ssoType || requestPayload?.integrationType || requestPayload?.ssoType) && (
                                                                            <div style={{ width: '48%', minWidth: '180px' }}>
                                                                                <div style={{ fontSize: '12px', color: '#666', marginBottom: '4px' }}>SSO Type</div>
                                                                                <div style={{ fontSize: '14px', fontWeight: 500, color: '#1a1a1a' }}>{provisionedDetails.ssoType || requestPayload?.integrationType || requestPayload?.ssoType}</div>
                                                                            </div>
                                                                        )}
                                                                        {(provisionedDetails.applicationId || requestPayload?.applicationId || requestPayload?.appId) && (
                                                                            <div style={{ width: '48%', minWidth: '180px' }}>
                                                                                <div style={{ fontSize: '12px', color: '#666', marginBottom: '4px' }}>Application ID</div>
                                                                                <div style={{ fontSize: '14px', fontWeight: 500, color: '#1a1a1a', wordBreak: 'break-all' }}>{provisionedDetails.applicationId || requestPayload?.applicationId || requestPayload?.appId}</div>
                                                                            </div>
                                                                        )}
                                                                        {(provisionedDetails.clientId || requestPayload?.clientId) && (
                                                                            <div style={{ width: '48%', minWidth: '180px' }}>
                                                                                <div style={{ fontSize: '12px', color: '#666', marginBottom: '4px' }}>Client ID</div>
                                                                                <div style={{ fontSize: '14px', fontWeight: 500, color: '#1a1a1a', wordBreak: 'break-all' }}>{provisionedDetails.clientId || requestPayload?.clientId}</div>
                                                                            </div>
                                                                        )}
                                                                        {(provisionedDetails.metadataUrl || requestPayload?.metadataUrl || requestPayload?.metadataURL) && (
                                                                            <div style={{ width: '100%' }}>
                                                                                <div style={{ fontSize: '12px', color: '#666', marginBottom: '4px' }}>Metadata URL</div>
                                                                                <div style={{ fontSize: '14px', fontWeight: 500, color: '#1a1a1a', wordBreak: 'break-all' }}>{provisionedDetails.metadataUrl || requestPayload?.metadataUrl || requestPayload?.metadataURL}</div>
                                                                            </div>
                                                                        )}
                                                                        {(provisionedDetails.clientSecret || requestPayload?.clientSecret) && (
                                                                            <div style={{ width: '100%' }}>
                                                                                <div style={{ fontSize: '12px', color: '#666', marginBottom: '4px' }}>Client Secret</div>
                                                                                <div style={{ fontSize: '13px', fontWeight: 400, color: '#555', wordBreak: 'break-all', backgroundColor: '#f5f5f5', padding: '8px', borderRadius: '4px', fontFamily: 'monospace' }}>{provisionedDetails.clientSecret || requestPayload?.clientSecret}</div>
                                                                            </div>
                                                                        )}
                                                                    </div>
                                                                </div>
                                                            )}

                                                            {/* Provisioning Actions */}
                                                            {provisioningActions.length > 0 ? (
                                                                <div style={{ backgroundColor: '#fff', borderRadius: '8px', border: '1px solid #e5e7eb' }}>
                                                                    <div style={{ padding: '12px 16px', borderBottom: '1px solid #e5e7eb' }}>
                                                                        <span style={{ fontWeight: 600, fontSize: '14px', color: '#1a1a1a' }}>Provisioning Actions</span>
                                                                    </div>
                                                                    <div style={{ padding: '12px 16px', display: 'flex', flexDirection: 'column', gap: '10px' }}>
                                                                        {provisioningActions.sort((a, b) => (a.actionOrder || 0) - (b.actionOrder || 0)).map((action, idx) => {
                                                                            const { bg, color, border } = getStatusColor(action.status);
                                                                            const hasResultRef = Boolean(action.resultRef);
                                                                            const hasUpdatedAt = Boolean(action.updatedAt);
                                                                            const gridTemplateColumns = hasResultRef && hasUpdatedAt
                                                                                ? 'minmax(160px, 1.4fr) minmax(110px, 0.8fr) minmax(180px, 1.5fr) minmax(170px, 1.2fr)'
                                                                                : hasResultRef || hasUpdatedAt
                                                                                    ? 'minmax(160px, 1.4fr) minmax(110px, 0.8fr) minmax(180px, 1.5fr) minmax(170px, 1.2fr)'
                                                                                    : 'minmax(160px, 1.4fr) minmax(110px, 0.8fr)';

                                                                            return (
                                                                                <div key={idx} style={{ display: 'grid', gridTemplateColumns, gap: '12px', padding: '12px', backgroundColor: '#f9fafb', borderRadius: '8px', border: '1px solid #e5e7eb', alignItems: 'flex-start', minWidth: 0 }}>
                                                                                    <div style={{ minWidth: 0 }}>
                                                                                        <div style={{ fontSize: '12px', color: '#666', marginBottom: '4px' }}>Action Code</div>
                                                                                        <div style={{ fontSize: '14px', fontWeight: 600, color: '#1a1a1a', wordBreak: 'break-word' }}>{action.actionCode || '-'}</div>
                                                                                    </div>
                                                                                    <div style={{ minWidth: 0 }}>
                                                                                        <div style={{ fontSize: '12px', color: '#666', marginBottom: '4px' }}>Status</div>
                                                                                        <span style={{ display: 'inline-block', padding: '2px 10px', borderRadius: '4px', backgroundColor: bg, color, border: `1px solid ${border}`, fontSize: '12px', fontWeight: 600 }}>{action.status || '-'}</span>
                                                                                    </div>
                                                                                    {hasResultRef && (
                                                                                        <div style={{ minWidth: 0, gridColumn: hasUpdatedAt ? '3' : '3' }}>
                                                                                            <div style={{ fontSize: '12px', color: '#666', marginBottom: '4px' }}>Result Reference</div>
                                                                                            <div style={{ fontSize: '13px', fontWeight: 500, color: '#1a1a1a', wordBreak: 'break-all' }}>{action.resultRef}</div>
                                                                                        </div>
                                                                                    )}
                                                                                    {hasUpdatedAt && (
                                                                                        <div style={{ minWidth: 0, gridColumn: hasResultRef ? '4' : '3' }}>
                                                                                            <div style={{ fontSize: '12px', color: '#666', marginBottom: '4px' }}>Updated At</div>
                                                                                            <div style={{ fontSize: '13px', fontWeight: 400, color: '#555', wordBreak: 'break-word' }}>{action.updatedAt}</div>
                                                                                        </div>
                                                                                    )}
                                                                                </div>
                                                                            );
                                                                        })}
                                                                    </div>
                                                                </div>
                                                            ) : (!Object.keys(provisioningSummary).length && !Object.keys(provisionedDetails).length && !hasFallbackProvisioningRequest) ? (
                                                                <>
                                                                    <div className="noData" style={{minHeight: "120px"}}></div>
                                                                    <div className="no-data-found-text">{t("auditRequest.no_data_found_label")}</div>
                                                                </>
                                                            ) : null}
                                                        </div>
                                                    );
                                                })()
                                            ) : selectedTabIndex === 2 && !isSSORequest ? (
                                                <>                                                
                                                    <div className="reqContainer" style={{ justifyContent: requestDetail.length > 0 ? '' : 'center'}}>
                                                        { requestDetail.length > 0 ? (
                                                            requestDetail?.sort?.((a, b) =>({"errorMessage":1,"entraAppId":2,"entraAppObjectId":3,"entraSpObjectId":4}[a.key] ?? 999) - ({"errorMessage":1,"entraAppId":2,"entraAppObjectId":3,"entraSpObjectId":4}[b.key] ?? 999))?.map?.((item, _index) => (
                                                            (item?.key && !item?.key.toLowerCase()?.includes("status") && item.value?.replace?.(/^\[|\}|\{|\]$/g, "") && (item?.key!=="errorMessage" || ['partial_failed', 'failed']?.includes(requestDetail?.filter((item)=>item?.key === "provisioningStatus")[0]?.value?.toLowerCase()))) ? <div className="item" key={_index}>
                                                                <div className="reqKey" dangerouslySetInnerHTML={{ __html: `${item?.key?.includes?.(":") ? camelToTitle(item?.key) : `${camelToTitle(item?.key || '')}:`}` }}></div>
                                                                <div className="reqValue">{
                                                                    item?.key === "apiPermissions"
                                                                    ? [...item.value.matchAll(/name=([^,\]}]+)/g)].map(m => m[1]).join(", ")
                                                                    :
                                                                    item?.value?.includes?.("~")
                                                                    ? item.value.split("~").map((val, i) => (
                                                                        <div key={i}>{val}</div>
                                                                    ))
                                                                    : item.value?.replace?.(/^\[|\}|\{|\]$/g, "")}</div>
                                                            </div> : null
                                                            ))
                                                        ) : (
                                                            <>
                                                                <div className="noData" style={{minHeight: "190px"}}></div>
                                                                <div className="no-data-found-text">{t("auditRequest.no_data_found_label")}</div>
                                                            </>
                                                        )}
                                                    </div>
                                                </>
                                            ) : null}
                                        </div>
                                    </div>
                                
                                </div>
                                
                            </div>
                        </>
                        :   <>
                                {
                                    isLoading ? null : <>
                                        <div className="noData" style={{minHeight: "190px"}}></div>
                                        <div className="no-data-found-text text-center">{t("auditRequest.no_data_found_label")}</div>
                                    </>
                                }
                            </>
                            // <div style={{ textAlign: "center", color: "red", marginTop: "10px", marginLeft: "auto", marginRight: "auto" }}>
                            //     {isLoading ? null : t("auditRequest.no_data_found_label")}
                            // </div>
                        }
                    </>
                    {(auditRequestData?.auditApprovalData?.isFollowupEnabled || auditRequestData?.auditApprovalData?.isRequestCancellable) && (
                        <>
                            {auditRequestData?.auditApprovalData?.isRequestCancellable && (
                                <div className="div-cancel-request">
                                    <Button
                                        size="small"
                                        className="mt-3"
                                        text={t("auditRequest.cancel_request_action_label")}
                                        variant="secondary"
                                        iconLeading={false}
                                        style={{ height: '24px !important', marginRight: "16px", fontWeight: 700, color: '#004895', border: 'solid 1px #004895 !important' }}
                                        onClick={() => {
                                            setRequestNumber(auditRequestData?.request);
                                            setRequestType(auditRequestData?.requestType);
                                            setIsShowCancelModel(true);
                                        }}
                                    />                                            
                                </div>
                            )}
                        </>
                    )}
                </>
                ) : (
                <div style={{ height: 'calc(100vh - 272px)', alignContent: 'center', display: 'grid', gap: '16px', justifyContent: 'center', textAlign: 'center', margin: 'auto' }}>
                    <Icon
                        alt="alt value"
                        className="$color-icon-default"
                        style={{margin: 'auto'}}
                        icon="format_list_bulleted"
                        size="large"
                    />
                    <h6 style={{ fontWeight: '700' }}>{t("auditRequest.no_request_selected")}</h6>
                    <div style={{ fontSize: 'small' }} className="no-selection-message">{t("auditRequest.select_request_to_view_details")}</div>
                </div>
            )}
        </section>
    }

    const renderEntraAuditRequestDetail = () => (
        <section className={"request_details_section pr-0 pl-0 " + (isMobile ? "col-12" : "col-9") } style={{ 
            // height: (auditRequestData?.auditApprovalData?.isFollowupEnabled || auditRequestData?.auditApprovalData?.isRequestCancellable) ? 'calc(100vh - 177px)' : 'calc(100vh - 220px)', maxHeight: (auditRequestData?.auditApprovalData?.isFollowupEnabled || auditRequestData?.auditApprovalData?.isRequestCancellable) ? 'calc(100vh - 177px)' : 'calc(100vh - 220px)', 
            flexShrink: "1"}}>
            {auditRequestData?.requestNumber ? 
                (
                <>
                    <>
                        <div className="request_details_header px-0">
                            <div className={"contentgroup-2 " + (isMobile ? "" : "pl-3")}>
                                <div className="title-content-group-2">
                                    <div
                                        data-show-leading-icon="false"
                                        data-show-trailing-icon="false"
                                        data-size="Medium"
                                        data-state="Default"
                                        data-style="Blue"
                                        data-type="Faded"
                                        style={{
                                            height: "24px",                                                                                                     
                                            overflow: "hidden",
                                            justifyContent: "flex-start",
                                            alignItems: "center",                                                    
                                            display: "inline-flex",
                                            marginRight: isRtl ? "0px" : "8px",
                                        }}
                                    >
                                        <div
                                            style={{
                                                color: "var(--Tokens-Text-High-contrast, black)",
                                                fontSize: "14px",
                                                fontFamily: "Inter",
                                                fontWeight: 700,
                                                lineHeight: "18px",
                                                whiteSpace: "nowrap",
                                            }}
                                        >
                                            {t("auditRequest.req") + " #" + auditRequestData?.requestNumber}
                                        </div>
                                    </div>{" "}
                                    {/* <div
                                        data-property-1="Modified"
                                        style={{
                                            justifyContent: "flex-start",
                                            alignItems: "flex-start",
                                            display: "inline-flex",
                                        }}
                                    >
                                        <div
                                            data-show-leading-icon="false"
                                            data-show-trailing-icon="false"
                                            data-size="Medium"
                                            data-state="Default"
                                            data-style="Orange"
                                            data-type="Outlined"
                                            style={{
                                                height: `${isMobile ? '16px' : "18px"}`,
                                                padding: "2px 8px",
                                                overflow: "hidden",
                                                borderRadius: "4px",
                                                backgroundColor: getRequestTypeBackgroundColor(getRequestBadgeKey(auditRequestData?.requestType)),
                                                border: `1px solid ${getBorderColor(getRequestBadgeKey(auditRequestData?.requestType))}`,
                                                outlineOffset: "-1px",
                                                justifyContent: "flex-start",
                                                alignItems: "center",
                                                gap: "2px",
                                                display: "flex",
                                            }}
                                        >
                                            <div
                                                style={{
                                                    color: "var(--Tokens-Text-Primary, #3A3A3A)",
                                                    fontSize: `${isMobile ? '0.7rem' : "10px"}`,
                                                    fontFamily: "Inter",
                                                    fontWeight: 400,
                                                    lineHeight: "18px",
                                                    whiteSpace: "nowrap",
                                                }}
                                            >                                            
                                                {formatRequestTypeLabel(auditRequestData?.requestType) || "Reactive"}
                                            </div>
                                        </div>
                                    </div> */}
                                </div>
                                <div className="details-content-group">
                                    <small style={{ display: "flex", alignItems: "center", gap: "4px", color: "#4B4B4B", fontWeight: 400 }}
                                    >{auditRequestData?.applicationName ? auditRequestData?.applicationName
                                        : t("auditRequest.not_applicable")} <Icon
                                            alt="alt value"
                                            size="small"
                                            style={{ display: 'unset' }}
                                        /></small>
                                </div>
                            </div>
                            <div className={"rightaccessory " + (isMobile ? " pt-2" : "pr-3") + (isRtl ? "" : " "   )}>
                                <div className="tagdueyellow">                                
                                    <div
                                        className="request-status-tag"
                                        style={{
                                            height: `${isMobile ? '20px' : "24px"}`,
                                            padding: "2px 8px",
                                            borderRadius: "4px",
                                            backgroundColor: getBackgroundColor(
                                                auditRequestData?.overAllStatus || auditRequestData?.status),
                                            // border: `1px solid ${getBorderColor(auditRequestData?.status)}`,
                                            color: isInProgressStatus(auditRequestData?.overAllStatus || auditRequestData?.status) ? "#000000" : '#ffffff',
                                            fontSize: `${isMobile ? '0.7rem' : "12px"}`,
                                            fontFamily: "Inter",
                                            fontWeight: 400,
                                            lineHeight: "18px",
                                            whiteSpace: "nowrap",
                                            display: "inline-flex",
                                            alignItems: "center",
                                            justifyContent: "center",
                                        }}
                                    >
                                        {normalizeToTitle(auditRequestData?.overAllStatus || auditRequestData?.status)}
                                    </div>
                                </div>
                            </div>
                        </div>
                        {(auditRequestData?.requestedBy) ?
                        <>
                            <div style={{ display: "inline-flex", width: '100%', maxHeight: isMobile ? 'auto' : "56px", flexDirection: isMobile ? 'row' : "column", alignItems: "flex-start"}}>
                                <div
                                    style={{
                                        padding: "0px 8px",
                                        borderRadius: "8px",                                    
                                        display: isMobile ? "contents" : "inline-flex",
                                        justifyContent: "space-between",
                                        alignItems: "flex-start",
                                        width: '100%',
                                        // flexWrap: "wrap",
                                        maxHeight: isMobile ? 'auto' : "56px"
                                    }}>

                                    <div
                                        style={{
                                            margin: isMobile ? "10px 0px" : "8px 10px",
                                            display: "inline-flex",
                                            flexDirection: "column",
                                            alignItems: "flex-start",
                                            width: "48%",
                                            maxWidth: "48%",
                                            // wordBreak: "break-word",
                                        }}
                                    >
                                        <div
                                            style={{
                                                color: "var(--Tokens-Text-Secondary, #2d2d2d)",
                                                fontSize: isMobile ? "13px" :"14px",
                                                fontFamily: "Inter",
                                                fontWeight: 500,
                                                lineHeight: "20px",
                                            }}
                                        >
                                            {t("auditRequest.requested_by")}:
                                        </div>
                                        <div
                                            className="requested-by"
                                            style={{
                                                color: "var(--Tokens-Text-Secondary, #2d2d2d)",
                                                fontSize: isMobile ? "12px" :"13px",
                                                fontFamily: "Inter",
                                                fontWeight: 700,
                                                lineHeight: "20px",                                                        
                                                width: "100%",
                                                maxWidth: "100%",
                                                textOverflow: "ellipsis",
                                                whiteSpace: isMobile ? "break-spaces" : "nowrap",
                                                overflow: "hidden"
                                            }}
                                        >
                                            {auditRequestData?.requestedBy ??
                                                t("auditRequest.not_applicable")}
                                        </div>
                                    </div>
                                </div>
                                
                            </div>
                            <div style={{border: auditRequestData?.bundledRequest && auditRequestData?.bundledRequest?.length > 0 ? 'solid 1px #D8E7FB' : 'none', borderRadius: '8px', margin: isMobile ? '0px' : '0px 16px', flexGrow: '1'}}>
                                
                                <div style={{ borderRadius: '8px', backgroundColor:'#e9eef4', minHeight: '100%'}}>
                                    <div className="p-2" >
                                        <TabsNavigation
                                            className="request-audit-tabs"
                                            onUpdate={selectedTab}
                                            selectedIndex={selectedTabIndex}
                                            style={{...(isMobile ? {overflow: "scroll"} : {})}}
                                        >
                                            <Tab
                                                label={t("auditRequest.approver_queue")}
                                                onClick={function aFe() { }}
                                            />
                                            <Tab
                                                label="Request Details"
                                                onClick={function aFe() { }}
                                            />
                                        </TabsNavigation>
                                        <div className="tab-content approvalSteps" style={{
                                            // height: getSectionHeight(), 
                                            minHeight: "190px",
                                            overflow:'auto', ...(isMobile ? {minHeight: "120px"} : {})}}>
                                            {selectedTabIndex === 0 ? (
                                                <div>
                                                    <div className="progressindicatorwithreminder">
                                                        <div className="progress-indicator" ref={queueNameRef}>
                                                            <div className="step">
                                                                <div className="step-1 queue-name" data-tooltip-id={auditRequestData?.approvalDetails?.queue} data-tooltip-content={auditRequestData?.approvalDetails?.queue}>
                                                                    {auditRequestData?.approvalDetails?.queue && auditRequestData?.approvalDetails?.queue != null
                                                                            ? auditRequestData?.approvalDetails?.queue
                                                                            : t("auditRequest.not_applicable")}{" "}
                                                                </div>
                                                                <Tooltip id={auditRequestData?.approvalDetails?.queue} place="top" style={{ maxWidth: '200px' }} type="light" effect="solid" />
                                                                <div className="bar">
                                                                    {/* <img loading="lazy" src={tickImage} className="img-9" /> */}
                                                                </div>

                                                                <div className="_label-2 p-0">
                                                                    <div className="description" style={{ wordWrap: "break-word", whiteSpace: "normal", overflowWrap: "break-word", color: '#2D2D2D', fontSize: '12px', fontWeight: 400 }}>
                                                                        <span>{t("auditRequest.approver_gpid_label")}:</span>{" "}
                                                                        {auditRequestData?.approvalDetails?.approverGpid && auditRequestData?.approvalDetails?.approverGpid != null
                                                                            ? auditRequestData?.approvalDetails?.approverGpid
                                                                            : t("auditRequest.not_applicable")}
                                                                    </div>
                                                                    {auditRequestData?.approvalDetails?.arrivedOn ? (
                                                                        <div className="description">
                                                                            <span>{t("auditRequest.arrived_on_label")}:</span>{" "}
                                                                            {["", "null", null, undefined, "undefined"].includes(auditRequestData?.approvalDetails?.arrivedOn?.split(".")[0])
                                                                                ? t("auditRequest.not_applicable")
                                                                                : auditRequestData?.approvalDetails?.arrivedOn?.split(".")[0]}
                                                                            <br />
                                                                            <span>{t("auditRequest.approved_on_label")}:</span>{" "}
                                                                            {["", "null", null, undefined, "undefined"].includes(auditRequestData?.approvalDetails?.approvedOn?.split(".")[0])
                                                                                ? t("auditRequest.not_applicable")
                                                                                : auditRequestData?.approvalDetails?.approvedOn?.split(".")[0]}
                                                                        </div>
                                                                    ) : (
                                                                        <div className="description-3">{t("homePage.pending")}</div>
                                                                    )}
                                                                </div>

                                                                <div className="d-flex" style={{gap:".5rem"}}>
                                                                    <Tag
                                                                        color={auditRequestData?.approvalDetails?.status === 'APPROVED' ? 'white' : (auditRequestData?.approvalDetails?.status === 'CANCELLED' || auditRequestData?.approvalDetails?.status === 'REJECTED' || auditRequestData?.approvalDetails?.status === 'IN_PROGRESS' ||  auditRequestData?.approvalDetails?.status === 'TIMED_OUT'|| auditRequestData?.approvalDetails?.status === 'FAILED') ? 'black' : 'black'}
                                                                        size="small"
                                                                        style={{ backgroundColor: auditRequestData?.approvalDetails?.status === 'APPROVED' ? 'green' : (auditRequestData?.approvalDetails?.status === 'CANCELLED' || auditRequestData?.approvalDetails?.status === 'REJECTED' || auditRequestData?.approvalDetails?.status === 'IN_PROGRESS' || auditRequestData?.approvalDetails?.status === 'TIMED_OUT' || auditRequestData?.approvalDetails?.status === 'FAILED') ? '#F1CA18' : '#8b8b8b', marginTop: '8px',
                                                                            color: auditRequestData?.approvalDetails?.status === 'APPROVED' ? 'white' : (auditRequestData?.approvalDetails?.status === 'CANCELLED' || auditRequestData?.approvalDetails?.status === 'REJECTED' || auditRequestData?.approvalDetails?.status === 'IN_PROGRESS' ||  auditRequestData?.approvalDetails?.status === 'TIMED_OUT'|| auditRequestData?.approvalDetails?.status === 'FAILED') ? 'rgba(0, 0, 0, 1)' : 'rgba(0, 0, 0, 1)', height: '24px'
                                                                        }}
                                                                        className="status-tag"
                                                                        iconTrailing={false}
                                                                        iconLeading=""
                                                                        text={auditRequestData?.approvalDetails?.status && auditRequestData?.approvalDetails?.status != null ? auditRequestData?.approvalDetails?.status?.split?.("_")?.map?.(val=>`${val?.[0]?.toUpperCase?.() || ''}${val?.slice?.(1)?.toLowerCase?.() || ''}`)?.join?.(" ") : t("auditRequest.not_applicable")}
                                                                        // type="default"
                                                                    />
                                                                    {((auditRequestData?.approvalDetails?.status?.toLowerCase?.() == "denied") && auditRequestData?.approvalDetails?.rejectionComments?.replace("[","")?.replace("]","")) ? (
                                                                        <>
                                                                            <div className="grc-status-link d-flex align-center" style={{alignItems: "center"}}
                                                                                data-tooltip-id={auditRequestData?.approvalDetails?.rejectionComments?.replace("[","")?.replace("]","")} 
                                                                                data-tooltip-content={auditRequestData?.approvalDetails?.rejectionComments?.replace("[","")?.replace("]","") || ""}
                                                                            >Reason For Denial</div>
                                                                            <Tooltip id={auditRequestData?.approvalDetails?.rejectionComments?.replace("[","")?.replace("]","")} place="top" style={{ maxWidth: '200px' }} type="light" effect="solid" />
                                                                        </>
                                                                    ) : null}
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="approver-queue">
                                                                                                            
                                                        <div className="div-approval-queue"  style={{ flexWrap: "wrap"}}>
                                                            {
                                                                auditRequestData?.reminderEnabled ? 
                                                                <div className="d-flex justify-content-between" style={{alignItems: "center", backgroundColor: isMobile ? '#fff' : 'transparent', flexWrap: "wrap", padding: "12px", gap: "12px"}}>
                                                                    <div style={{ color: '#2D2D2D', fontSize: '14px'}}>{t("RequestNewAccessForOthers.request_info")}</div>
                                                                    <Button
                                                                        size="small"
                                                                        text={t("auditRequest.send_a_reminder_label")}
                                                                        variant="secondary"
                                                                        iconLeading="notifications"
                                                                        style={{ height: '24px !important', fontWeight: 700, color: '#004895', border: 'solid 1px #004895 !important', minWidth: "138px" }}
                                                                        onClick={() => {
                                                                            setRequestNumber(auditRequestData?.requestNumber);
                                                                            setRequestType(auditRequestData?.requestType);
                                                                            setIsShowReminderModel(true);
                                                                        }}
                                                                    />
                                                                </div>
                                                                :
                                                                null
                                                            }

                                                            <DataTable
                                                                className="datatable audit-request-table audit-approver-queue-table"
                                                                columns={ entraColumns}
                                                                key={i18n.language}
                                                                data={[auditRequestData?.approvalDetails]}
                                                                isResizable={false}
                                                                enableSorting={true}
                                                                onColumnFiltersChange={function oFe() { }}
                                                                onGlobalSearchChange={function oFe() { }}                                                                
                                                                showPagination={false}  
                                                                pageSize={[auditRequestData?.approvalDetails]?.length || 0}                                                             
                                                                renderSubComponent={function oFe() { }}
                                                                rowExpandingHandler={function oFe() { }}
                                                                searchPlaceholder="Type a search keyword"
                                                                selection="single"
                                                                showColumnFilters={false}
                                                                showDescription={false}
                                                                showFilterButton={false}
                                                                showFilterToolbar={false}
                                                                showMultiSortMenu={false}
                                                                showSearchOption={false}
                                                                showTableHeader={false}
                                                                showTitle={false}
                                                                size="large"
                                                                sortingHandler={function oFe() { }}
                                                                style={{width: "100%", overflow: "auto"}}
                                                                tableDescription="Search for a user using a criteria"
                                                                tableHeader="Extension for others"
                                                                noDataDescriptionText=""                             
                                                            />  
                                                        </div>                                                        
                                                    </div>
                                                </div>
                                            ) : selectedTabIndex === 1 ? (
                                                <>                                               
                                                    <div className="reqContainer" style={{ justifyContent: auditRequestData?.requestDetails?.length > 0 ? '' :'center'}}>
                                                        { auditRequestData?.requestDetails?.length > 0 ? (
                                                            <DataTable
                                                                className="datatable audit-request-table audit-approver-queue-table"
                                                                columns={ entraReqDetailsColumn}
                                                                key={i18n.language}
                                                                data={auditRequestData?.requestDetails}
                                                                isResizable={false}
                                                                enableSorting={true}
                                                                onColumnFiltersChange={function oFe() { }}
                                                                onGlobalSearchChange={function oFe() { }}                                                                
                                                                showPagination={false} 
                                                                pageSize={auditRequestData?.requestDetails?.length || 0}                                                              
                                                                renderSubComponent={function oFe() { }}
                                                                rowExpandingHandler={function oFe() { }}
                                                                searchPlaceholder="Type a search keyword"
                                                                selection="single"
                                                                showColumnFilters={false}
                                                                showDescription={false}
                                                                showFilterButton={false}
                                                                showFilterToolbar={false}
                                                                showMultiSortMenu={false}
                                                                showSearchOption={false}
                                                                showTableHeader={false}
                                                                showTitle={false}
                                                                size="large"
                                                                sortingHandler={function oFe() { }}
                                                                style={{width: "100%", overflow: "auto"}}
                                                                tableDescription="Search for a user using a criteria"
                                                                tableHeader="Extension for others"
                                                                noDataDescriptionText=""                             
                                                            />
                                                        ) : (
                                                            <>
                                                                <div className="noData" style={{minHeight: "190px"}}></div>
                                                                <div className="no-data-found-text">{t("auditRequest.no_data_found_label")}</div>
                                                            </>
                                                        )}
                                                    </div>
                                                </>
                                                

                                            ) : null}
                                        </div>
                                    </div>
                                
                                </div>
                                
                            </div>
                        </>
                        :  <>
                                <div className="noData" style={{minHeight: "190px"}}></div>
                                <div className="no-data-found-text text-center">{t("auditRequest.no_data_found_label")}</div>
                            </>
                        }
                    </>
                    {auditRequestData?.requestCancellable ? 
                        <>
                            <div className="div-cancel-request">
                                <Button
                                    size="small"
                                    className="mt-3"
                                    text={t("auditRequest.cancel_request_action_label")}
                                    variant="secondary"
                                    iconLeading={false}
                                    style={{ height: '24px !important', marginRight: "16px", fontWeight: 700, color: '#004895', border: 'solid 1px #004895 !important' }}
                                    onClick={() => {
                                        setRequestNumber(auditRequestData?.requestNumber);
                                        setRequestType(auditRequestData?.requestType);
                                        setIsShowCancelModel(true);
                                    }}
                                />                                            
                            </div>
                        </>
                    :
                    null}
                </>
                ) : (
                <div style={{ height: 'calc(100vh - 272px)', alignContent: 'center', display: 'grid', gap: '16px', justifyContent: 'center', textAlign: 'center', margin: 'auto' }}>
                    <Icon
                        alt="alt value"
                        className="$color-icon-default"
                        style={{margin: 'auto'}}
                        icon="format_list_bulleted"
                        size="large"
                    />
                    <h6 style={{ fontWeight: '700' }}>{t("auditRequest.no_request_selected")}</h6>
                    <div style={{ fontSize: 'small' }} className="no-selection-message">{t("auditRequest.select_request_to_view_details")}</div>
                </div>
            )}
        </section>
    )

    const onClickMyIdm = () => {
        navigate("/myidmPortal");
    }

    const handleRefresh = (clearSearch = false, requestNumber) => {
        const currentDate = new Date();
        const oneMonthBack = new Date();
        oneMonthBack.setMonth(oneMonthBack.getMonth() - 1);
        setSelectedRange({from: null, to: null,})
        setSelectedRangeAfterApply({from: null, to: null,})
        setTimeout(() => {
            setSelectedRange({
                from: oneMonthBack,
                to: currentDate,
            })
            setSelectedRangeAfterApply({
                from: oneMonthBack,
                to: currentDate,
            })
            setDisableFilter(false);
            if(innerContainerRef?.current?.scrollTop) innerContainerRef.current.scrollTop = 0;
            setPageIndex(1);
        }, 10);
        
        // setSelectedFilter({ id: '5', label: t("auditRequest.audit_all"), value: 'all' });
        setSelectedStatusFilter([{ id: '5', displayText: t("auditRequest.audit_all"), value: 'all' }])
        setSelectedStatusFilterAfterApply([{ id: '5', displayText: t("auditRequest.audit_all"), value: 'all' }])
        // selectedFilterRef.current = { id: '5', label: t("auditRequest.audit_all"), value: 'all' };
        searchNum && clearSearch && setSearchNum("");
        if (!clearSearch && searchNum && searchNum.trim() !== "" && state?.type !== "requestNumber") {
            // fetchAuditRequest(searchNum, true, true);
            setAuditRequestList([]);
            setTotalRecords(0);
            // fetchAuditRequest("", false, true, null, false, requestNumber);
            searchRequestByRequestNumber(searchNum);
        }else if (state?.type === "GPID" || state?.type == "gpid") {
            if((selectedStatusFilter?.[0]?.value ||state?.statusFilter) && selectedRange?.from && selectedRange?.to && state?.type !== "requestNumber")fetchAuditRequest(state?.value, false, true, null, false, requestNumber);
        }else if(state?.type === "requestNumber"){
            setAuditRequestList([]);
            setTotalRecords(0);
            searchRequestByRequestNumber(state?.value);
        } else {
            const data = JSON.parse(localStorage.getItem("okta-token-storage"));
            if (data?.accessToken?.claims?.gpid) {
                setUserGpId(data?.accessToken?.claims?.gpid);
                if((selectedStatusFilter?.[0]?.value ||state?.statusFilter) && selectedRange?.from && selectedRange?.to && state?.type !== "requestNumber")fetchAuditRequest(data?.accessToken?.claims?.gpid, false, true, null, false, requestNumber);
            }
        }
        return;
    }

    return (
        <main id="pending_audit_request" className="requests-container" style={{height: "100%", overflow: "inherit"}}>
            <section className="requests-content" style={{height: "100%"}}>
                <header_ar className="header_ar-section">
                    {(!isMobile) ? (
                        <Breadcrumb
                            homeIcon={{
                                icon: "home",
                                onClick:()=>{
                                navigate("/home")
                                }
                            }}
                            breadcrumbs={[
                                {
                                    label: 'Home'
                                },
                                {
                                    label: <div onClick={()=>{
                                        navigate("/myidmPortal")
                                    }}>myidM</div>
                                },
                                {
                                    label: t("auditRequest.view_requests_title")
                                }
                            ]}
                            className=""
                            style={{}}
                        />
                    ) : (
                        <div className="req-myidm-btn" onClick={() => onClickMyIdm()}><Icon
                            alt="alt value"
                            icon="arrow_back"
                            size="medium"
                            style={{ marginRight: '8px' }}
                        />myidM</div>
                    )}

                    <div className="header_ar-title pb-0">
                        <h1>{t("auditRequest.view_requests_title")}</h1>
                    </div>
                </header_ar>
                <section className="main-section">
                    {/* {(error || showNoDataFound || showNetworkError || showServiceUnavailable) ? showNoDataFound ? <NoDataFound /> : showNetworkError ? <NetworkError handleRefresh={handleRefresh} /> : showServiceUnavailable ? <ServiceUnavailable /> : (
                        <div style={{ textAlign: "center", color: "red", marginTop: "10px" }}>
                            {error}
                        </div> 
                    ) : null } */}
                    {(                    
                        <section className={"filters-requests-section " + ((isMobile) ? "col-12" : "col-3 pl-0 pr-0")} style={{minWidth: "360px"}}>
                            <section className="" style={{gap: "16px", display: 'grid', height: state?.searchFor!=="ENTRA" ? '95.75%' : 'auto'}}>
                                <div className="records-header_ar" style={{...(state?.searchFor!=="ENTRA" && {minHeight: "unset"})}}>
                                    {
                                        ((state?.type && state?.value) || !showRequestSearch) ?
                                            <div className="d-md-flex">
                                                <div className="search-result"><span className="search-result-info">{`${state?.searchFor!=="ENTRA" ? totalRecords : 1} ${t('RequestNewAccessForOthers.search')}`}</span> {t('RequestNewAccessForOthers.results_for')} {searchType === "requestNumber" ? "Request Number" : searchType} &apos;&apos;{searchValue}&apos;&apos;</div>
                                                {state?.searchFor!=="ENTRA" ? null : <Icon
                                                    alt="alt value"
                                                    className={"$color-icon-default request-refresh-btn" + (isRtl ? "mr-2" : "")}
                                                    icon="refresh"
                                                    data-tooltip-id="refresh-tooltip" data-tooltip-content="Refresh"
                                                    size="small"
                                                    onClick={() => searchRequestByRequestNumber(state?.value)}
                                                    style={{ alignItems: 'center', cursor: 'pointer', maxHeight: "25px" }}
                                                />}
                                                {state?.searchFor!=="ENTRA" ? <button className="cancel-button" onClick={() => {
                                                    // let statePayload = { navigateFrom: "extension_request" };
                                                    // navigate("/myidmPortal", { state: statePayload });
                                                    // handleRefresh()

                                                    // if(searchNum)setSearchNum("")
                                                    // setSelectedStatusFilter([{ id: '5', displayText: t("auditRequest.audit_all"), value: 'all' }])
                                                    // setSelectedStatusFilterAfterApply([{ id: '5', displayText: t("auditRequest.audit_all"), value: 'all' }])
                                                    // const currentDate = new Date();
                                                    // const oneMonthBack = new Date();
                                                    // oneMonthBack.setMonth(oneMonthBack.getMonth() - 1);
                                                    // setSelectedRange({
                                                    //     from: oneMonthBack,
                                                    //     to: currentDate,
                                                    // })
                                                    // setSelectedRangeAfterApply({
                                                    //     from: oneMonthBack,
                                                    //     to: currentDate,
                                                    // })
                                                    // navigate("/audit-requests")
                                                    // setDisableFilter(false)

                                                    const currentDate = new Date();
                                                    const oneMonthBack = new Date();
                                                    oneMonthBack.setMonth(oneMonthBack.getMonth() - 1);
                                                    setSelectedRange({from: null, to: null,})
                                                    setSelectedRangeAfterApply({from: null, to: null,})
                                                    setTimeout(() => {
                                                        setSelectedRange({
                                                            from: oneMonthBack,
                                                            to: currentDate,
                                                        })
                                                        setSelectedRangeAfterApply({
                                                            from: oneMonthBack,
                                                            to: currentDate,
                                                        })
                                                        setDisableFilter(false);
                                                        if(innerContainerRef?.current?.scrollTop) innerContainerRef.current.scrollTop = 0;
                                                        setPageIndex(1);
                                                    }, 10);
                                                    
                                                    setSelectedStatusFilter([{ id: '5', displayText: t("auditRequest.audit_all"), value: 'all' }])
                                                    setSelectedStatusFilterAfterApply([{ id: '5', displayText: t("auditRequest.audit_all"), value: 'all' }])
                                                    const data = JSON.parse(localStorage.getItem("okta-token-storage"));
                                                    if (data?.accessToken?.claims?.gpid) {
                                                        setUserGpId(data?.accessToken?.claims?.gpid);
                                                        if((selectedStatusFilter?.[0]?.value ||state?.statusFilter) && selectedRange?.from && selectedRange?.to)fetchAuditRequest(data?.accessToken?.claims?.gpid, false, true, null, false, requestNumber);
                                                    }
                                                    setShowRequestSearch(true);
                                                    setSearchNum("");
                                                    navigate("/audit-requests")
                                                }}>
                                                    Clear search
                                                </button> : null }
                                            </div>
                                            : null
                                    }
                                    {state?.searchFor!=="ENTRA" && AllButtonContainers()}
                                </div>

                            {(error || showNoDataFound || showNetworkError || showServiceUnavailable) ? showNoDataFound ? <><div className="noData" style={{minHeight: "190px"}}></div><div className="no-data-found-text text-center">{t("auditRequest.no_data_found_label")}</div></> : showNetworkError ? <NetworkError handleRefresh={handleRefresh} className="audit-request-list" /> : showServiceUnavailable ? <ServiceUnavailable /> : (
                                <div style={{ textAlign: "center", color: "red", marginTop: "10px" }}>
                                    {error}
                                </div> 
                            ) : null }

                                {!error && !showNoDataFound && !showNetworkError && !showServiceUnavailable &&(
                                    <>
                                        {/* {isLoading ? (
                                            null
                                        ) : ( */}
                                            <div ref={containerRef}>
                                                <div className={(state?.type && state?.value) ? "requests-state-list" : "requests-list"} onScroll={handleScroll} ref={innerContainerRef} key={auditRequestData?.requestNumber}>
                                                    <div style={{ flex: "1" }} className="list-container" ref={requestListRef}>
                                                    {state?.searchFor!=="ENTRA" ? auditRequestList?.map((data, index) => (
                                                        <AuditRequestBodyScreen
                                                        key={index}
                                                        index={index}
                                                        auditRequestData={data}
                                                        />
                                                    )) : <EntraAuditRequestBodyScreen
                                                            auditRequestData={auditRequestData}
                                                        />}
                                                    </div>
                                                </div>
                                            </div>



                                        {/* )} */}
                                    </>
                                )}
                            </section>
                        </section>
                    )}
                    {!isMobile && !error && !showViewRequestNoDataFound && !showNetworkError && !showServiceUnavailable && !isLoading && (
                        <>
                            {state?.searchFor!=="ENTRA" ? renderAuditRequestDetail() : renderEntraAuditRequestDetail()}
                        </>
                    )}
                    {(error || showViewRequestNoDataFound || showNetworkError || showServiceUnavailable) ? 
                        showViewRequestNoDataFound ? 
                        // <div className="no_info_found">
                        //     <div className="no_request_number"></div>
                        //     <div style={{fontWeight: '600', fontSize: '16px'}} className="mt-2">Select a Request Number</div>
                        //     <div style={{fontWeight: '400', fontSize: '14px', color: 'rgba(129, 129, 129, 1)'}} className="mt-2">To view details, select the request number</div>
                        // </div> 
                         <div style={{ height: 'calc(100vh - 272px)', alignContent: 'center', display: 'grid', gap: '16px', justifyContent: 'center', textAlign: 'center', margin: 'auto' }}>
                            <Icon
                                alt="alt value"
                                className="$color-icon-default"
                                style={{margin: 'auto'}}
                                icon="format_list_bulleted"
                                size="large"
                            />
                            <h6 style={{ fontWeight: '700' }}>{t("auditRequest.no_request_selected")}</h6>
                            <div style={{ fontSize: 'small' }} className="no-selection-message">{t("auditRequest.select_request_to_view_details")}</div>
                        </div>
                        : 
                        showNetworkError ? <NetworkError handleRefresh={handleRefresh} /> : showServiceUnavailable ? <ServiceUnavailable /> : (
                        <div style={{ textAlign: "center", color: "red", marginTop: "10px" }}>
                            {error}
                        </div> 
                    ) : null }
                    {
                        isMobile && isRequestSelected && !error && !showViewRequestNoDataFound && !showNetworkError && !showServiceUnavailable && (
                        <Modal 
                            showModal={isMobile && isRequestSelected}
                            id="pending_audit_request_detail"
                            className=""
                            onCloseModal={closeModal}
                            closeOnOutsideClick = {false}
                            showAuxiliaryButton={false}
                            showLink={false}
                            showPrimaryButton={false}
                            showSecondaryButton={false}
                            showSlot
                            showTertiaryButton={false}
                            showCloseButton={true}
                            title="Details"
                            type="fluid"
                            viewPort={isMobile ? "mobile" : "desktop"}
                        >
                            {renderAuditRequestDetail()}
                        </Modal>
                     )
                    }
                </section>
            </section>
            {renderToastContainer()}
            {showDetail && !error && !showNoDataFound && !showNetworkError && !showServiceUnavailable && <AuditRequestDetail onClose={() => setShowDetail(false)} requestNumber={requestNumber} />}
            <Modal
                className="remind-approve-modal"
                closeOnOutsideClick
                onCloseModal={() => {
                    setIsShowModel(false);
                }}
                primaryButtonProps={{
                    size: "medium",
                    text: t("auditRequest.send_reminder_upper_label"),
                    variant: "primary",
                    onClick: () => {
                        setIsShowModel(false);
                        setIsShowReminderModel(true);
                    },
                }}
                secondaryButtonProps={{
                    size: "medium",
                    text: t("auditRequest.cancel_label"),
                    variant: "secondary",
                    onClick: () => {
                        setIsShowModel(false);
                    },
                }}
                showTertiaryButton={false}
                showAuxiliaryButton={false}
                showLink={false}
                showModal={isShowModel}
                style={{}}
                text={t("auditRequest.friendly_reminder_label")}
                title={t("auditRequest.reminder_stage_label")}
                type="fluid"
                viewPort={isMobile ? "mobile" : "desktop"}

            ></Modal>
            <Modal
                className=""
                onCloseModal={() => setIsShowReminderModel(false)}
                primaryButtonProps={{
                    size: "medium",
                    text: isBtnLoading ? t("auditRequest.submitting_label") : t("auditRequest.remind_all_label"),
                    variant: "primary",
                    disabled: isBtnLoading,
                    onClick: () => {
                        const isSSOType = (requestType && requestType?.toLowerCase?.()?.includes?.('sso')) || (auditRequestData?.applicationsRequested && auditRequestData?.applicationsRequested?.toLowerCase?.()?.includes?.('sso'));
                        const entraAppRegistration = auditRequestData?.applicationsRequested && (auditRequestData?.applicationsRequested?.toLowerCase?.()?.includes?.("entra app registration") || auditRequestData?.applicationsRequested?.toLowerCase?.()?.includes?.("entra_app_registration"));
                        const applicationAetirement = auditRequestData?.applicationsRequested && (auditRequestData?.applicationsRequested?.toLowerCase?.()?.includes?.("application retirement") || auditRequestData?.applicationsRequested?.toLowerCase?.()?.includes?.("application_retirement"));
                        state?.searchFor==="ENTRA" ? entraSendFollowUp() : (isSSOType || entraAppRegistration || applicationAetirement) ? ssoSendReminder() : (requestNumber?.includes?.('IAMC') && ['MYPAM_CREATE_SAFE', 'MYPAM_SAFE_ACCESS', 'MYPAM_UPDATE_SAFE', 'Create Safe', 'Safe Access', 'Update Safe'].includes(requestType)) ?  mypamCancelOrRemindRequest('remind') : requestNumber?.includes?.('IAMC') ? entraSendFollowUp()  : sendReminder();
                    },
                }}
                secondaryButtonProps={{
                    size: "medium",
                    text: t("auditRequest.cancel_label"),
                    variant: "secondary",
                    onClick: () => setIsShowReminderModel(false),
                }}
                showTertiaryButton={false}
                showAuxiliaryButton={false}
                showLink={false}
                showModal={isShowReminderModel}
                text={t("auditRequest.friendly_reminder_label")}
                title={t("auditRequest.reminder_stage_label")}
                type="fluid"
                viewPort={isMobile ? "mobile" : "desktop"}
            >
                {approvalData?.filter(a => a.status.toLowerCase() !== "approved" && a.status.toLowerCase() !== "approval skipped" && a.status.toLowerCase() !== "timeout").map((item, index) => {
                    const gpid = item?.queueName != null ? item?.queueName : t("auditRequest.not_applicable");
                    // const managerName = item?.approver || "N/A";
                    const sentDate = item?.dateArrived || t("auditRequest.not_applicable");
                    const approvedDate = item?.dateApproved || t("auditRequest.not_applicable");
                    const status = (item?.status && item?.status?.includes?.(" ") ? item?.status?.split?.(" ")?.map?.(val=>`${val?.[0]?.toUpperCase?.() || ''}${val?.slice?.(1)?.toLowerCase?.() || ''}`)?.join?.(" ") : item?.status?.split?.("_")?.map?.(val=>`${val?.[0]?.toUpperCase?.() || ''}${val?.slice?.(1)?.toLowerCase?.() || ''}`)?.join?.(" ")) || t("homePage.pending");

                    return (
                        <div
                            key={index}
                            style={{
                                color: "var(--Tokens-Text-Primary, #3A3A3A)",
                                fontSize: "12px",
                                display: "flex",
                                flexDirection: "column",
                                gap: "0px",
                                padding: "16px",
                                border: "1px solid #ccc",
                                borderRadius: "8px",
                                marginBottom: "8px",
                            }}
                        >
                            <div>
                                {/* <strong>Manager name:</strong> {managerName} */}
                                {/* <br /> */}
                                {gpid ?? t("auditRequest.not_applicable")}
                            </div>

                            <div
                                style={{
                                    display: "flex",
                                    justifyContent: "space-between",
                                    alignItems: "center",
                                }}
                            >
                                <div>
                                    <span style={{ fontWeight: 500 }}>{t("auditRequest.sent_on_label")}: </span>
                                    {sentDate}
                                    <br />
                                    <span style={{ fontWeight: 500 }}>{t("auditRequest.approved_on_label")}: </span>
                                    {approvedDate != "null" ? approvedDate : t("auditRequest.not_applicable")}
                                </div>

                                <div
                                    style={{
                                        backgroundColor:
                                            status === "Approved"
                                                ? "#B3DACB"
                                                : status === "Rejected"
                                                    ? "#F8D7DA"
                                                    : "#FFE599",
                                        padding: "4px 8px",
                                        borderRadius: "4px",
                                        display: "flex",
                                        alignItems: "center",
                                        gap: "4px",
                                    }}
                                >
                                    {status === "Approved" && (
                                        <svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            width="15"
                                            height="15"
                                            viewBox="0 0 48 48"
                                        >
                                            <path
                                                fill="#43A047"
                                                d="M40.6 12.1L17 35.7 7.4 26.1 4.6 29 17 41.3 43.4 14.9z"
                                            ></path>
                                        </svg>
                                    )}
                                    <span style={{ fontWeight: 500 }}>{status}</span>
                                </div>
                            </div>
                        </div>
                    );
                })}
            </Modal>
            <Modal
                className=""
                onCloseModal={() => {
                    setIsShowCancelModel(false);
                }}
                showTertiaryButton={false}
                showAuxiliaryButton={false}
                showPrimaryButton={false}
                showSecondaryButton={false}
                showLink={false}
                showModal={isShowCancelModel}
                style={{}}
                text={t("auditRequest.cancel_message")}
                title={t("auditRequest.cancel_stage_label")}
                type="fluid"
                viewPort={isMobile ? "mobile" : "desktop"}
            >
                <div className="confirm-modal-btn">
                    <Button
                        className=""
                        size="medium"
                        style={{}}
                        text={t("auditRequest.back_label")}
                        variant="tertiary"
                        onClick={() => {
                            setIsShowCancelModel(false);
                        }}
                    />
                    <Button
                        className=""
                        size="medium"
                        style={{}}
                        text={isBtnLoading ? t("auditRequest.submitting_label") : t("auditRequest.cancel_request_label")}
                        variant="primary"
                        disabled={isBtnLoading}
                        onClick={() => {
                            const isSSOType = (requestType && requestType?.toLowerCase?.()?.includes?.('sso')) || (auditRequestData?.applicationsRequested && auditRequestData?.applicationsRequested?.toLowerCase?.()?.includes?.('sso'));
                            const entraAppRegistration = auditRequestData?.applicationsRequested && (auditRequestData?.applicationsRequested?.toLowerCase?.()?.includes?.("entra app registration") || auditRequestData?.applicationsRequested?.toLowerCase?.()?.includes?.("entra_app_registration"));
                            const applicationAetirement = auditRequestData?.applicationsRequested && (auditRequestData?.applicationsRequested?.toLowerCase?.()?.includes?.("application retirement") || auditRequestData?.applicationsRequested?.toLowerCase?.()?.includes?.("application_retirement"));
                            state?.searchFor==="ENTRA" ? entraCancelRequest() : (isSSOType || entraAppRegistration || applicationAetirement) ? ssoCancelRequest() : (requestNumber?.includes?.('IAMC') && ['MYPAM_CREATE_SAFE', 'MYPAM_SAFE_ACCESS', 'MYPAM_UPDATE_SAFE', 'Create Safe', 'Safe Access', 'Update Safe'].includes(requestType)) ?  mypamCancelOrRemindRequest('cancel') : requestNumber?.includes?.('IAMC') ? entraCancelRequest() :  onClickToCancelRequest();
                        }}
                    />

                </div>
            </Modal>

            <Modal
                showModal={isCancelConfirmModel}
                className="reactivation-modal"
                onCloseModal={() => setIsCancelConfirmModel(false)}
                notificationsProps={{
                    secondaryActionLabel: (
                        <>
                            <Icon
                                alt="alt value"
                                icon={copyButtonText == "Copied" ? "check" : "content_copy"}
                                size="medium"
                                style={{ marginRight: '6px', display: 'unset' }}
                            />

                            {copyButtonText}
                        </>
                    ),
                    secondaryActionOnClick: onClickCopynumber,
                    text: "123456",
                    title: 'Ticket number',
                    type: 'info'
                }}
                showAuxiliaryButton={false}
                showLink={false}
                showPrimaryButton={false}
                showSecondaryButton={false}
                showSlot
                showTertiaryButton={false}
                showCloseButton={true}
                style={{}}

                text={<>Request has been submitted for cancel. The ticket number assign to this cancel request is: 1382555007. Please save this number to reference the request in the future <br></br>
                    <div style={{ marginTop: '10px', marginBottom: '10px' }}>You can check your requests in the View all requests section<br></br></div>
                </>}
                title="Cancel Request confirmation"
                type="fluid"
                viewPort={isMobile ? "mobile" : "desktop"}
            >
                <div className="confirm-modal-btn">
                    <Button
                        className=""
                        size="medium"
                        style={{}}
                        text="Back"
                        variant="tertiary"
                        onClick={() => { setIsCancelConfirmModel(false); }}
                    />
                    <Button
                        className=""
                        size="medium"
                        style={{}}
                        text="View all requests"
                        variant="primary"
                        onClick={() => {
                            setIsShowCancelModel(false);
                            setIsCancelConfirmModel(false);
                        }}
                    />

                </div>
            </Modal>

            <Modal
                showModal={isSSOLogoPreviewOpen}
                onCloseModal={closeSSOLogoPreview}
                showAuxiliaryButton={false}
                showLink={false}
                showPrimaryButton={false}
                showSecondaryButton={false}
                showTertiaryButton={false}
                showCloseButton={true}
                showSlot
                title="Application Logo"
                type="fluid"
                viewPort={isMobile ? "mobile" : "desktop"}
            >
                <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '320px', padding: '8px' }}>
                    {ssoLogoPreviewSrc ? (
                        <img
                            src={ssoLogoPreviewSrc}
                            alt="Application Logo Preview"
                            style={{ maxWidth: '90vw', maxHeight: '75vh', objectFit: 'contain', borderRadius: '8px' }}
                        />
                    ) : (
                        <span style={{ fontSize: '12px', color: '#999' }}>Logo not available</span>
                    )}
                </div>
            </Modal>
        </main>
    );
};





export default PendingAuditRequests;
